import states from '../../src/constants/configs/states';
import { ALL_USER_ROLES } from '../../src/constants/roles/userRoleTypes';
import { flowTypes } from '../../src/constants/ssap/flows/flowTypes';
import { ssapModalTypes } from '../../src/constants/ssap/modals/ssapModalTypes';
import messages from '../../src/i18n/nv/messages_en.json';
import { processJsonTools } from '../../src/utils/tools/processJsonTools';
import { ssapData } from './ssap/ssapData';
import { ssapPreviousData } from './ssap/ssapPreviousData';
import { formatDate } from '../../src/utils/dates/date.utils';
import { DD_MM_YYYY } from '../../src/utils/dates/dateFormats.utils';

const getDataToSave = data =>
    processJsonTools.convertBloodRelationships(processJsonTools.convertTaxHousehold(data, 'object'), 'household');

export const mockState = {
    ssap: {
        cachedData: {
            ssns: {},
            previousSSNs: {},
            immigrationInfo: {},
            previousImmigrationInfo: {},
        },
        adjustedFlow: [
            {
                hhm: -1,
                isActive: true,
                pageName: 'BEFORE_WE_BEGIN_PAGE',
                formName: 'beforeWeBeginForm',
                reasons: [],
                componentName: '<Page1_00/>',
                page: {
                    pageName: 'BEFORE_WE_BEGIN_PAGE',
                    navBarText: 'ssap.page_title.before_we_begin',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page1_00)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page1_00',
                    buttons: {
                        leftButton: 'INITIAL',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'beforeWeBeginForm',
                },
                pageIndexInCurrentSection: 0,
                pageIndexInFlow: 0,
                sectionIndex: 0,
                sectionName: 'ssap.section_title.start',
                isTheFirstPageInSection: true,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'GET_READY_PAGE',
                reasons: [],
                componentName: '<Page1_01/>',
                page: {
                    pageName: 'GET_READY_PAGE',
                    navBarText: 'ssap.page_title.get_ready',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page1_01)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page1_01',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'HIDDEN',
                        rightButton: 'DEFAULT',
                    },
                },
                pageIndexInCurrentSection: 1,
                pageIndexInFlow: 1,
                sectionIndex: 0,
                sectionName: 'ssap.section_title.start',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'PRIMARY_CONTACT_INFORMATION_PAGE',
                formName: 'primaryContactForm',
                reasons: [],
                componentName: '<Page1_02/>',
                page: {
                    pageName: 'PRIMARY_CONTACT_INFORMATION_PAGE',
                    navBarText: 'ssap.page_title.primary_contact_info',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page1_02)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page1_02',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'primaryContactForm',
                },
                pageIndexInCurrentSection: 2,
                pageIndexInFlow: 2,
                sectionIndex: 0,
                sectionName: 'ssap.section_title.start',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'APPLICATION_ASSISTANCE_PAGE',
                formName: 'assistanceForm',
                reasons: [],
                componentName: '<Page1_03/>',
                page: {
                    pageName: 'APPLICATION_ASSISTANCE_PAGE',
                    navBarText: 'ssap.page_title.applying_for_coverage',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page1_03)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page1_03',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'assistanceForm',
                },
                pageIndexInCurrentSection: 3,
                pageIndexInFlow: 3,
                sectionIndex: 0,
                sectionName: 'ssap.section_title.start',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'HELP_PAYING_F0R_COVERAGE_PAGE',
                formName: 'financialAssistanceForm',
                reasons: [],
                componentName: '<Page1_03_E1/>',
                page: {
                    pageName: 'HELP_PAYING_F0R_COVERAGE_PAGE',
                    navBarText: 'ssap.page_title.help_paying_fot_coverage',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page1_03_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page1_03_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'financialAssistanceForm',
                },
                pageIndexInCurrentSection: 4,
                pageIndexInFlow: 4,
                sectionIndex: 0,
                sectionName: 'ssap.section_title.start',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'APPLICANTS_PAGE',
                formName: 'applyingForCoverageForm',
                reasons: [],
                componentName: '<Page1_04/>',
                page: {
                    pageName: 'APPLICANTS_PAGE',
                    navBarText: 'ssap.page_title.who_needs_coverage',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page1_04)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page1_04',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'applyingForCoverageForm',
                },
                pageIndexInCurrentSection: 4,
                pageIndexInFlow: 4,
                sectionIndex: 0,
                sectionName: 'ssap.section_title.start',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'ABOUT_YOUR_HOUSEHOLD_PAGE',
                formName: 'householdMembersForm',
                reasons: [],
                componentName: '<Page1_05/>',
                page: {
                    pageName: 'ABOUT_YOUR_HOUSEHOLD_PAGE',
                    navBarText: 'ssap.page_title.about_household',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page1_05)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page1_05',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        deleteButton: 'DEFAULT',
                        addPersonButton: 'DEFAULT',
                        removeMemberButton: 'DEFAULT',
                    },
                    extraButtons: {
                        addPersonButton: 'DEFAULT',
                    },
                    formName: 'householdMembersForm',
                },
                pageIndexInCurrentSection: 5,
                pageIndexInFlow: 5,
                sectionIndex: 0,
                sectionName: 'ssap.section_title.start',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'RELATIONSHIPS_PAGE',
                formName: 'relationshipsForm',
                reasons: [],
                componentName: '<Page2_13/>',
                page: {
                    pageName: 'RELATIONSHIPS_PAGE',
                    navBarText: 'ssap.page_title.household_relationships',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_13)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_13',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'relationshipsForm',
                },
                pageIndexInCurrentSection: 6,
                pageIndexInFlow: 6,
                sectionIndex: 0,
                sectionName: 'ssap.section_title.start',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'OTHER_ADDRESSES_PAGE',
                formName: 'otherAddressesForm',
                reasons: [],
                componentName: '<Page2_11_mod2/>',
                page: {
                    pageName: 'OTHER_ADDRESSES_PAGE',
                    navBarText: 'ssap.page_title.household_addresses',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_11_mod2)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_11_mod2',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'otherAddressesForm',
                },
                pageIndexInCurrentSection: 7,
                pageIndexInFlow: 7,
                sectionIndex: 0,
                sectionName: 'ssap.section_title.start',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'HOUSEHOLD_SUMMARY_PAGE',
                reasons: [],
                componentName: '<Page1_07_E2/>',
                page: {
                    pageName: 'HOUSEHOLD_SUMMARY_PAGE',
                    navBarText: 'ssap.page_title.summary',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page1_07_E2)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page1_07_E2',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'HIDDEN',
                        rightButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                    },
                },
                pageIndexInCurrentSection: 8,
                pageIndexInFlow: 8,
                sectionIndex: 0,
                sectionName: 'ssap.section_title.start',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'GET_READY_FOR_HOUSEHOLD_AND_FAMILY_PAGE',
                reasons: [],
                componentName: '<Page2_07/>',
                page: {
                    pageName: 'GET_READY_FOR_HOUSEHOLD_AND_FAMILY_PAGE',
                    navBarText: 'ssap.page_title.get_ready',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_07)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_07',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'HIDDEN',
                        rightButton: 'DEFAULT',
                    },
                },
                pageIndexInCurrentSection: 0,
                pageIndexInFlow: 9,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: true,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'PERSONAL_INFORMATION_PAGE',
                formName: 'personalInfoForm',
                reasons: [],
                page: {
                    pageName: 'PERSONAL_INFORMATION_PAGE',
                    navBarText: 'ssap.page_title.personal_information',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_08)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_08',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'personalInfoForm',
                    asyncQueries: [
                        {
                            queryType: 'ssns',
                            url: 'http://localhost:8888/mocks/ssns.json',
                        },
                    ],
                },
                componentName: '<Page2_08/>',
                pageIndexInCurrentSection: 1,
                pageIndexInFlow: 10,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'CITIZENSHIP_IMMIGRATION_STATUS_PAGE',
                formName: 'citizenshipImmigrationForm',
                reasons: ['- not applied for coverage'],
                page: {
                    pageName: 'CITIZENSHIP_IMMIGRATION_STATUS_PAGE',
                    navBarText: 'ssap.page_title.cis',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_09)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_09',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'citizenshipImmigrationForm',
                },
                componentName: '<Page2_09/>',
                pageIndexInCurrentSection: 2,
                pageIndexInFlow: 11,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'ETHNICITY_AND_RACE_PAGE',
                formName: 'ethnicityRaceForm',
                reasons: [],
                page: {
                    pageName: 'ETHNICITY_AND_RACE_PAGE',
                    navBarText: 'ssap.page_title.ethnicity_and_race',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_10)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_10',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'ethnicityRaceForm',
                },
                componentName: '<Page2_10/>',
                pageIndexInCurrentSection: 3,
                pageIndexInFlow: 12,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'MARITAL_STATUS',
                formName: 'maritalStatusForm',
                reasons: ['- person is married OR less than 14 y.o.'],
                page: {
                    pageName: 'MARITAL_STATUS',
                    navBarText: 'ssap.page_title.marital_status',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_28_E3)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_28_E3',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        updateInformationButton: 'SPOUSE',
                        fixRelationshipButton: 'SPOUSE',
                    },
                    formName: 'maritalStatusForm',
                },
                componentName: '<Page2_28_E3/>',
                pageIndexInCurrentSection: 4,
                pageIndexInFlow: 13,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'PARENT_CARETAKER_INFORMATION_PAGE',
                formName: 'parentCaretakerForm',
                reasons: ['- non-applicant AND or OR age is less than 19 '],
                page: {
                    pageName: 'PARENT_CARETAKER_INFORMATION_PAGE',
                    navBarText: 'ssap.page_title.parent_caretaker_info',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_26)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_26',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'parentCaretakerForm',
                },
                componentName: '<Page2_26/>',
                pageIndexInCurrentSection: 5,
                pageIndexInFlow: 14,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'PERSONAL_INFORMATION_PAGE',
                formName: 'personalInfoForm',
                reasons: [],
                page: {
                    pageName: 'PERSONAL_INFORMATION_PAGE',
                    navBarText: 'ssap.page_title.personal_information',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_08)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_08',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'personalInfoForm',
                    asyncQueries: [
                        {
                            queryType: 'ssns',
                            url: 'http://localhost:8888/mocks/ssns.json',
                        },
                    ],
                },
                componentName: '<Page2_08/>',
                pageIndexInCurrentSection: 6,
                pageIndexInFlow: 15,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'CITIZENSHIP_IMMIGRATION_STATUS_PAGE',
                formName: 'citizenshipImmigrationForm',
                reasons: ['- not applied for coverage'],
                page: {
                    pageName: 'CITIZENSHIP_IMMIGRATION_STATUS_PAGE',
                    navBarText: 'ssap.page_title.cis',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_09)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_09',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'citizenshipImmigrationForm',
                },
                componentName: '<Page2_09/>',
                pageIndexInCurrentSection: 7,
                pageIndexInFlow: 16,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'ETHNICITY_AND_RACE_PAGE',
                formName: 'ethnicityRaceForm',
                reasons: [],
                page: {
                    pageName: 'ETHNICITY_AND_RACE_PAGE',
                    navBarText: 'ssap.page_title.ethnicity_and_race',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_10)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_10',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'ethnicityRaceForm',
                },
                componentName: '<Page2_10/>',
                pageIndexInCurrentSection: 8,
                pageIndexInFlow: 17,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'MARITAL_STATUS',
                formName: 'maritalStatusForm',
                reasons: ['- person is married OR less than 14 y.o.'],
                page: {
                    pageName: 'MARITAL_STATUS',
                    navBarText: 'ssap.page_title.marital_status',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_28_E3)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_28_E3',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        updateInformationButton: 'SPOUSE',
                        fixRelationshipButton: 'SPOUSE',
                    },
                    formName: 'maritalStatusForm',
                },
                componentName: '<Page2_28_E3/>',
                pageIndexInCurrentSection: 9,
                pageIndexInFlow: 18,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'PARENT_CARETAKER_INFORMATION_PAGE',
                formName: 'parentCaretakerForm',
                reasons: ['- non-applicant AND or OR age is less than 19 '],
                page: {
                    pageName: 'PARENT_CARETAKER_INFORMATION_PAGE',
                    navBarText: 'ssap.page_title.parent_caretaker_info',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_26)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_26',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'parentCaretakerForm',
                },
                componentName: '<Page2_26/>',
                pageIndexInCurrentSection: 10,
                pageIndexInFlow: 19,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'PERSONAL_INFORMATION_PAGE',
                formName: 'personalInfoForm',
                reasons: [],
                page: {
                    pageName: 'PERSONAL_INFORMATION_PAGE',
                    navBarText: 'ssap.page_title.personal_information',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_08)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_08',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'personalInfoForm',
                    asyncQueries: [
                        {
                            queryType: 'ssns',
                            url: 'http://localhost:8888/mocks/ssns.json',
                        },
                    ],
                },
                componentName: '<Page2_08/>',
                pageIndexInCurrentSection: 11,
                pageIndexInFlow: 20,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'CITIZENSHIP_IMMIGRATION_STATUS_PAGE',
                formName: 'citizenshipImmigrationForm',
                reasons: ['- not applied for coverage'],
                page: {
                    pageName: 'CITIZENSHIP_IMMIGRATION_STATUS_PAGE',
                    navBarText: 'ssap.page_title.cis',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_09)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_09',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'citizenshipImmigrationForm',
                },
                componentName: '<Page2_09/>',
                pageIndexInCurrentSection: 12,
                pageIndexInFlow: 21,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'ETHNICITY_AND_RACE_PAGE',
                formName: 'ethnicityRaceForm',
                reasons: [],
                page: {
                    pageName: 'ETHNICITY_AND_RACE_PAGE',
                    navBarText: 'ssap.page_title.ethnicity_and_race',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_10)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_10',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'ethnicityRaceForm',
                },
                componentName: '<Page2_10/>',
                pageIndexInCurrentSection: 13,
                pageIndexInFlow: 22,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'MARITAL_STATUS',
                formName: 'maritalStatusForm',
                reasons: ['- person is married OR less than 14 y.o.'],
                page: {
                    pageName: 'MARITAL_STATUS',
                    navBarText: 'ssap.page_title.marital_status',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_28_E3)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_28_E3',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        updateInformationButton: 'SPOUSE',
                        fixRelationshipButton: 'SPOUSE',
                    },
                    formName: 'maritalStatusForm',
                },
                componentName: '<Page2_28_E3/>',
                pageIndexInCurrentSection: 14,
                pageIndexInFlow: 23,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'PARENT_CARETAKER_INFORMATION_PAGE',
                formName: 'parentCaretakerForm',
                reasons: ['- non-applicant AND or OR age is less than 19 '],
                page: {
                    pageName: 'PARENT_CARETAKER_INFORMATION_PAGE',
                    navBarText: 'ssap.page_title.parent_caretaker_info',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_26)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_26',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'parentCaretakerForm',
                },
                componentName: '<Page2_26/>',
                pageIndexInCurrentSection: 15,
                pageIndexInFlow: 24,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'ACTIVE_MILITARY_VETERAN_PAGE',
                formName: 'militaryServiceForm',
                reasons: [],
                componentName: '<Page2_25/>',
                page: {
                    pageName: 'ACTIVE_MILITARY_VETERAN_PAGE',
                    navBarText: 'ssap.page_title.military_service',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_25)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_25',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'militaryServiceForm',
                },
                pageIndexInCurrentSection: 16,
                pageIndexInFlow: 25,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'TAX_HOUSEHOLD_COMPOSITION_PAGE',
                formName: 'taxHouseholdCompositionForm',
                reasons: [],
                componentName: '<Page2_07_E2_mod1/>',
                page: {
                    pageName: 'TAX_HOUSEHOLD_COMPOSITION_PAGE',
                    navBarText: 'ssap.page_title.household_info',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_07_E2_mod1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_07_E2_mod1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        updateInformationButton: 'DEFAULT',
                    },
                    formName: 'taxHouseholdCompositionForm',
                },
                pageIndexInCurrentSection: 17,
                pageIndexInFlow: 26,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'AMERICAN_INDIAN_ALASKA_NATIVE_PAGE',
                formName: 'americanNativeForm',
                reasons: [],
                componentName: '<Page2_12/>',
                page: {
                    pageName: 'AMERICAN_INDIAN_ALASKA_NATIVE_PAGE',
                    navBarText: 'ssap.page_title.ai_an',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_12)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_12',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'americanNativeForm',
                },
                pageIndexInCurrentSection: 18,
                pageIndexInFlow: 27,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'MEDICAID_CHIP_DENIAL_INFORMATION_PAGE',
                formName: 'medicaidChipDenialForm',
                reasons: [],
                componentName: '<Page2_21/>',
                page: {
                    pageName: 'MEDICAID_CHIP_DENIAL_INFORMATION_PAGE',
                    navBarText: 'ssap.page_title.medicaid_chip_info',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_21)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_21',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'medicaidChipDenialForm',
                },
                pageIndexInCurrentSection: 19,
                pageIndexInFlow: 28,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'PREGNANCY_INFORMATION_PAGE',
                formName: 'pregnancyForm',
                reasons: [],
                componentName: '<Page2_22/>',
                page: {
                    pageName: 'PREGNANCY_INFORMATION_PAGE',
                    navBarText: 'ssap.page_title.pregnancy_info',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_22)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_22',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'pregnancyForm',
                },
                pageIndexInCurrentSection: 20,
                pageIndexInFlow: 29,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'DISABILITY_INFORMATION_PAGE',
                formName: 'disabilityForm',
                reasons: [],
                componentName: '<Page2_23/>',
                page: {
                    pageName: 'DISABILITY_INFORMATION_PAGE',
                    navBarText: 'ssap.page_title.disability_info',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_23)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_23',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'disabilityForm',
                },
                pageIndexInCurrentSection: 21,
                pageIndexInFlow: 30,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'FOSTER_CARE_INFORMATION_PAGE',
                formName: 'fosterCareForm',
                reasons: ['- no one HHM age of 18 - 25 y.o.'],
                componentName: '<Page2_24/>',
                page: {
                    pageName: 'FOSTER_CARE_INFORMATION_PAGE',
                    navBarText: 'ssap.page_title.foster_care_info',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_24)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_24',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'fosterCareForm',
                },
                pageIndexInCurrentSection: 22,
                pageIndexInFlow: 31,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'FULL_TIME_STUDENT_PAGE',
                formName: 'fullTimeStudentForm',
                reasons: ['- no one HHM age of 18 - 22 y.o.'],
                componentName: '<Page2_27/>',
                page: {
                    pageName: 'FULL_TIME_STUDENT_PAGE',
                    navBarText: 'ssap.page_title.full_time_student',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_27)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_27',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'fullTimeStudentForm',
                },
                pageIndexInCurrentSection: 23,
                pageIndexInFlow: 32,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'FAMILY_AND_HOUSEHOLD_SUMMARY_PAGE',
                reasons: [],
                componentName: '<Page2_14/>',
                page: {
                    pageName: 'FAMILY_AND_HOUSEHOLD_SUMMARY_PAGE',
                    navBarText: 'ssap.page_title.summary',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page2_14)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page2_14',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'HIDDEN',
                        rightButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                    },
                },
                pageIndexInCurrentSection: 24,
                pageIndexInFlow: 33,
                sectionIndex: 1,
                sectionName: 'ssap.section_title.family',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'GET_READY_FOR_INCOME_PAGE',
                formName: 'getReadyIncomeSection',
                reasons: [],
                componentName: '<Page3_31_E1/>',
                page: {
                    pageName: 'GET_READY_FOR_INCOME_PAGE',
                    navBarText: 'ssap.page_title.get_ready',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_31_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_31_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'getReadyIncomeSection',
                },
                pageIndexInCurrentSection: 0,
                pageIndexInFlow: 34,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: true,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'INCOME_SOURCES_PAGE',
                formName: 'incomeSourcesForm',
                reasons: [],
                page: {
                    pageName: 'INCOME_SOURCES_PAGE',
                    navBarText: 'ssap.page_title.income_sources',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_32_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_32_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        addIncomeSourceButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                        removeButton: 'DEFAULT',
                    },
                    formName: 'incomeSourcesForm',
                },
                componentName: '<Page3_32_E1/>',
                pageIndexInCurrentSection: 1,
                pageIndexInFlow: 35,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'TRIBAL_SOURCE_INCOME_PAGE',
                formName: 'tribalSourceForm',
                reasons: [],
                page: {
                    pageName: 'TRIBAL_SOURCE_INCOME_PAGE',
                    navBarText: 'ssap.page_title.tribal_income',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_33_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_33_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'tribalSourceForm',
                },
                componentName: '<Page3_33_E1/>',
                pageIndexInCurrentSection: 2,
                pageIndexInFlow: 36,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'DEDUCTION_SOURCES_PAGE',
                formName: 'deductionSourcesForm',
                reasons: [],
                page: {
                    pageName: 'DEDUCTION_SOURCES_PAGE',
                    navBarText: 'ssap.page_title.deduction_sources',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_34_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_34_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        addDeductionSourceButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                        removeButton: 'DEFAULT',
                    },
                    formName: 'deductionSourcesForm',
                },
                componentName: '<Page3_34_E1/>',
                pageIndexInCurrentSection: 3,
                pageIndexInFlow: 37,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'EXPECTED_INCOME_PAGE',
                formName: 'expectedIncomeForm',
                reasons: [],
                page: {
                    pageName: 'EXPECTED_INCOME_PAGE',
                    navBarText: 'ssap.page_title.expected_income',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_35_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_35_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        addDeductionSourceButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                        removeButton: 'DEFAULT',
                    },
                    formName: 'expectedIncomeForm',
                },
                componentName: '<Page3_35_E1/>',
                pageIndexInCurrentSection: 4,
                pageIndexInFlow: 38,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'PERSONAL_INCOME_SUMMARY_PAGE',
                reasons: [],
                page: {
                    pageName: 'PERSONAL_INCOME_SUMMARY_PAGE',
                    navBarText: 'ssap.page_title.summary',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_36_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_36_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'HIDDEN',
                        rightButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                    },
                },
                componentName: '<Page3_36_E1/>',
                pageIndexInCurrentSection: 5,
                pageIndexInFlow: 39,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'INCOME_SOURCES_PAGE',
                formName: 'incomeSourcesForm',
                reasons: [],
                page: {
                    pageName: 'INCOME_SOURCES_PAGE',
                    navBarText: 'ssap.page_title.income_sources',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_32_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_32_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        addIncomeSourceButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                        removeButton: 'DEFAULT',
                    },
                    formName: 'incomeSourcesForm',
                },
                componentName: '<Page3_32_E1/>',
                pageIndexInCurrentSection: 6,
                pageIndexInFlow: 40,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'TRIBAL_SOURCE_INCOME_PAGE',
                formName: 'tribalSourceForm',
                reasons: ['- household member not an AI/AN'],
                page: {
                    pageName: 'TRIBAL_SOURCE_INCOME_PAGE',
                    navBarText: 'ssap.page_title.tribal_income',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_33_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_33_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'tribalSourceForm',
                },
                componentName: '<Page3_33_E1/>',
                pageIndexInCurrentSection: 7,
                pageIndexInFlow: 41,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'DEDUCTION_SOURCES_PAGE',
                formName: 'deductionSourcesForm',
                reasons: [],
                page: {
                    pageName: 'DEDUCTION_SOURCES_PAGE',
                    navBarText: 'ssap.page_title.deduction_sources',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_34_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_34_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        addDeductionSourceButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                        removeButton: 'DEFAULT',
                    },
                    formName: 'deductionSourcesForm',
                },
                componentName: '<Page3_34_E1/>',
                pageIndexInCurrentSection: 8,
                pageIndexInFlow: 42,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'EXPECTED_INCOME_PAGE',
                formName: 'expectedIncomeForm',
                reasons: [],
                page: {
                    pageName: 'EXPECTED_INCOME_PAGE',
                    navBarText: 'ssap.page_title.expected_income',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_35_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_35_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        addDeductionSourceButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                        removeButton: 'DEFAULT',
                    },
                    formName: 'expectedIncomeForm',
                },
                componentName: '<Page3_35_E1/>',
                pageIndexInCurrentSection: 9,
                pageIndexInFlow: 43,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'PERSONAL_INCOME_SUMMARY_PAGE',
                reasons: [],
                page: {
                    pageName: 'PERSONAL_INCOME_SUMMARY_PAGE',
                    navBarText: 'ssap.page_title.summary',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_36_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_36_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'HIDDEN',
                        rightButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                    },
                },
                componentName: '<Page3_36_E1/>',
                pageIndexInCurrentSection: 10,
                pageIndexInFlow: 44,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'INCOME_SOURCES_PAGE',
                formName: 'incomeSourcesForm',
                reasons: [],
                page: {
                    pageName: 'INCOME_SOURCES_PAGE',
                    navBarText: 'ssap.page_title.income_sources',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_32_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_32_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        addIncomeSourceButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                        removeButton: 'DEFAULT',
                    },
                    formName: 'incomeSourcesForm',
                },
                componentName: '<Page3_32_E1/>',
                pageIndexInCurrentSection: 11,
                pageIndexInFlow: 45,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'TRIBAL_SOURCE_INCOME_PAGE',
                formName: 'tribalSourceForm',
                reasons: ['- household member is an AI/AN but do not have income'],
                page: {
                    pageName: 'TRIBAL_SOURCE_INCOME_PAGE',
                    navBarText: 'ssap.page_title.tribal_income',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_33_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_33_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'tribalSourceForm',
                },
                componentName: '<Page3_33_E1/>',
                pageIndexInCurrentSection: 12,
                pageIndexInFlow: 46,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'DEDUCTION_SOURCES_PAGE',
                formName: 'deductionSourcesForm',
                reasons: [],
                page: {
                    pageName: 'DEDUCTION_SOURCES_PAGE',
                    navBarText: 'ssap.page_title.deduction_sources',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_34_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_34_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        addDeductionSourceButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                        removeButton: 'DEFAULT',
                    },
                    formName: 'deductionSourcesForm',
                },
                componentName: '<Page3_34_E1/>',
                pageIndexInCurrentSection: 13,
                pageIndexInFlow: 47,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'EXPECTED_INCOME_PAGE',
                formName: 'expectedIncomeForm',
                reasons: [],
                page: {
                    pageName: 'EXPECTED_INCOME_PAGE',
                    navBarText: 'ssap.page_title.expected_income',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_35_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_35_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        addDeductionSourceButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                        removeButton: 'DEFAULT',
                    },
                    formName: 'expectedIncomeForm',
                },
                componentName: '<Page3_35_E1/>',
                pageIndexInCurrentSection: 14,
                pageIndexInFlow: 49,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'PERSONAL_INCOME_SUMMARY_PAGE',
                reasons: [],
                page: {
                    pageName: 'PERSONAL_INCOME_SUMMARY_PAGE',
                    navBarText: 'ssap.page_title.summary',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_36_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_36_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'HIDDEN',
                        rightButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                    },
                },
                componentName: '<Page3_36_E1/>',
                pageIndexInCurrentSection: 15,
                pageIndexInFlow: 49,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'INCOME_INFORMATION_SUMMARY_PAGE',
                reasons: [],
                componentName: '<Page3_37_E1/>',
                page: {
                    pageName: 'INCOME_INFORMATION_SUMMARY_PAGE',
                    navBarText: 'ssap.page_title.income_summary',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_37_E1)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_37_E1',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'HIDDEN',
                        rightButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                    },
                },
                pageIndexInCurrentSection: 16,
                pageIndexInFlow: 50,
                sectionIndex: 2,
                sectionName: 'ssap.section_title.income',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'OTHER_HEALTH_COVERAGE_PAGE',
                formName: 'otherHealthCoverageForm',
                reasons: ['- not applied for coverage'],
                page: {
                    pageName: 'OTHER_HEALTH_COVERAGE_PAGE',
                    navBarText: 'ssap.page_title.other_health_coverage',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_61)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_61',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'otherHealthCoverageForm',
                },
                componentName: '<Page4_61/>',
                pageIndexInCurrentSection: 0,
                pageIndexInFlow: 51,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: true,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'RECONCILIATION_IN_APTC_PAGE',
                formName: 'reconciliationAptcForm',
                reasons: [],
                page: {
                    pageName: 'RECONCILIATION_IN_APTC_PAGE',
                    navBarText: 'ssap.page_title.reconciliation_of_aptc',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_62)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_62',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'reconciliationAptcForm',
                },
                componentName: '<Page4_62/>',
                pageIndexInCurrentSection: 1,
                pageIndexInFlow: 52,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'EMPLOYER_COVERAGE_DETAIL_PAGE',
                formName: 'employerCoverageDetailsForm',
                reasons: ['- not applied for coverage'],
                page: {
                    pageName: 'EMPLOYER_COVERAGE_DETAIL_PAGE',
                    navBarText: 'ssap.page_title.employer_coverage_detail',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_63)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_63',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        addEmployerCoverageDetailButton: 'DEFAULT',
                    },
                    formName: 'employerCoverageDetailsForm',
                },
                componentName: '<Page4_63/>',
                pageIndexInCurrentSection: 2,
                pageIndexInFlow: 53,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'STATE_EMPLOYEE_HEALTH_BENEFIT_PAGE',
                formName: 'stateEmployeeHealthBenefitForm',
                reasons: ['- person does not apply for coverage'],
                page: {
                    pageName: 'STATE_EMPLOYEE_HEALTH_BENEFIT_PAGE',
                    navBarText: 'ssap.page_title.state_employee_health_benefit',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_65)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_65',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'stateEmployeeHealthBenefitForm',
                },
                componentName: '<Page4_65/>',
                pageIndexInCurrentSection: 3,
                pageIndexInFlow: 54,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 0,
                isActive: true,
                pageName: 'ADDITIONAL_INFORMATION_PAGE',
                formName: 'additionalInfoForm',
                reasons: [],
                page: {
                    pageName: 'ADDITIONAL_INFORMATION_PAGE',
                    navBarText: 'ssap.page_title.additional_information',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_66)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_66',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'additionalInfoForm',
                },
                componentName: '<Page4_66/>',
                pageIndexInCurrentSection: 4,
                pageIndexInFlow: 55,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'OTHER_HEALTH_COVERAGE_PAGE',
                formName: 'otherHealthCoverageForm',
                reasons: ['- not applied for coverage'],
                page: {
                    pageName: 'OTHER_HEALTH_COVERAGE_PAGE',
                    navBarText: 'ssap.page_title.other_health_coverage',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_61)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_61',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'otherHealthCoverageForm',
                },
                componentName: '<Page4_61/>',
                pageIndexInCurrentSection: 5,
                pageIndexInFlow: 56,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: true,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'RECONCILIATION_IN_APTC_PAGE',
                formName: 'reconciliationAptcForm',
                reasons: ['- applicable only if hhm matches primaryTaxFilerPersonId'],
                page: {
                    pageName: 'RECONCILIATION_IN_APTC_PAGE',
                    navBarText: 'ssap.page_title.reconciliation_of_aptc',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_62)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_62',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'reconciliationAptcForm',
                },
                componentName: '<Page4_62/>',
                pageIndexInCurrentSection: 6,
                pageIndexInFlow: 57,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'EMPLOYER_COVERAGE_DETAIL_PAGE',
                formName: 'employerCoverageDetailsForm',
                reasons: ['- not applied for coverage'],
                page: {
                    pageName: 'EMPLOYER_COVERAGE_DETAIL_PAGE',
                    navBarText: 'ssap.page_title.employer_coverage_detail',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_63)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_63',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        addEmployerCoverageDetailButton: 'DEFAULT',
                    },
                    formName: 'employerCoverageDetailsForm',
                },
                componentName: '<Page4_63/>',
                pageIndexInCurrentSection: 7,
                pageIndexInFlow: 58,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'STATE_EMPLOYEE_HEALTH_BENEFIT_PAGE',
                formName: 'stateEmployeeHealthBenefitForm',
                reasons: ['- person does not apply for coverage'],
                page: {
                    pageName: 'STATE_EMPLOYEE_HEALTH_BENEFIT_PAGE',
                    navBarText: 'ssap.page_title.state_employee_health_benefit',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_65)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_65',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'stateEmployeeHealthBenefitForm',
                },
                componentName: '<Page4_65/>',
                pageIndexInCurrentSection: 8,
                pageIndexInFlow: 59,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 1,
                isActive: true,
                pageName: 'ADDITIONAL_INFORMATION_PAGE',
                formName: 'additionalInfoForm',
                reasons: ['Person does not qualify'],
                page: {
                    pageName: 'ADDITIONAL_INFORMATION_PAGE',
                    navBarText: 'ssap.page_title.additional_information',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_66)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_66',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'additionalInfoForm',
                },
                componentName: '<Page4_66/>',
                pageIndexInCurrentSection: 9,
                pageIndexInFlow: 60,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'OTHER_HEALTH_COVERAGE_PAGE',
                formName: 'otherHealthCoverageForm',
                reasons: ['- not applied for coverage'],
                page: {
                    pageName: 'OTHER_HEALTH_COVERAGE_PAGE',
                    navBarText: 'ssap.page_title.other_health_coverage',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_61)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_61',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'otherHealthCoverageForm',
                },
                componentName: '<Page4_61/>',
                pageIndexInCurrentSection: 10,
                pageIndexInFlow: 61,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: true,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'RECONCILIATION_IN_APTC_PAGE',
                formName: 'reconciliationAptcForm',
                reasons: ['- applicable only if hhm matches primaryTaxFilerPersonId'],
                page: {
                    pageName: 'RECONCILIATION_IN_APTC_PAGE',
                    navBarText: 'ssap.page_title.reconciliation_of_aptc',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_62)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_62',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'reconciliationAptcForm',
                },
                componentName: '<Page4_62/>',
                pageIndexInCurrentSection: 11,
                pageIndexInFlow: 62,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'EMPLOYER_COVERAGE_DETAIL_PAGE',
                formName: 'employerCoverageDetailsForm',
                reasons: ['- not applied for coverage'],
                page: {
                    pageName: 'EMPLOYER_COVERAGE_DETAIL_PAGE',
                    navBarText: 'ssap.page_title.employer_coverage_detail',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_63)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_63',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                        addEmployerCoverageDetailButton: 'DEFAULT',
                    },
                    formName: 'employerCoverageDetailsForm',
                },
                componentName: '<Page4_63/>',
                pageIndexInCurrentSection: 12,
                pageIndexInFlow: 63,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'STATE_EMPLOYEE_HEALTH_BENEFIT_PAGE',
                formName: 'stateEmployeeHealthBenefitForm',
                reasons: ['- person does not apply for coverage'],
                page: {
                    pageName: 'STATE_EMPLOYEE_HEALTH_BENEFIT_PAGE',
                    navBarText: 'ssap.page_title.state_employee_health_benefit',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_65)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_65',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'stateEmployeeHealthBenefitForm',
                },
                componentName: '<Page4_65/>',
                pageIndexInCurrentSection: 13,
                pageIndexInFlow: 64,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: false,
            },
            {
                hhm: 2,
                isActive: true,
                pageName: 'ADDITIONAL_INFORMATION_PAGE',
                formName: 'additionalInfoForm',
                reasons: ['Person does not qualify'],
                page: {
                    pageName: 'ADDITIONAL_INFORMATION_PAGE',
                    navBarText: 'ssap.page_title.additional_information',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_66)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_66',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'DEFAULT',
                        rightButton: 'COMBINED',
                    },
                    formName: 'additionalInfoForm',
                },
                componentName: '<Page4_66/>',
                pageIndexInCurrentSection: 14,
                pageIndexInFlow: 65,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'ADDITIONAL_INFORMATION_SUMMARY_PAGE',
                reasons: [],
                componentName: '<Page4_64/>',
                page: {
                    pageName: 'ADDITIONAL_INFORMATION_SUMMARY_PAGE',
                    navBarText: 'ssap.page_title.summary',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page4_64)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page4_64',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'HIDDEN',
                        rightButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                    },
                },
                pageIndexInCurrentSection: 15,
                pageIndexInFlow: 66,
                sectionIndex: 3,
                sectionName: 'ssap.section_title.additional',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'REVIEW_AND_SIGN_PAGE',
                reasons: [],
                componentName: '<Page3_15/>',
                page: {
                    pageName: 'REVIEW_AND_SIGN_PAGE',
                    navBarText: 'ssap.page_title.review_and_sign',
                    component: {
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_15',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'HIDDEN',
                        rightButton: 'DEFAULT',
                    },
                },
                pageIndexInCurrentSection: 0,
                pageIndexInFlow: 67,
                sectionIndex: 4,
                sectionName: 'ssap.section_title.review',
                isTheFirstPageInSection: true,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'FINAL_APPLICATION_REVIEW_PAGE',
                reasons: [],
                componentName: '<Page3_16/>',
                page: {
                    pageName: 'FINAL_APPLICATION_REVIEW_PAGE',
                    navBarText: 'ssap.page_title.final_review',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_16)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_16',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'HIDDEN',
                        rightButton: 'DEFAULT',
                        editButton_secondary: 'DEFAULT',
                        downloadButton: 'INITIAL',
                        printButton: 'INITIAL',
                    },
                },
                pageIndexInCurrentSection: 1,
                pageIndexInFlow: 68,
                sectionIndex: 4,
                sectionName: 'ssap.section_title.review',
                isTheFirstPageInSection: false,
            },
            {
                hhm: -1,
                isActive: true,
                pageName: 'SIGN_AND_SUBMIT_PAGE',
                formName: 'signAndSubmitApplicationForm',
                reasons: [],
                componentName: '<Page3_17/>',
                page: {
                    pageName: 'SIGN_AND_SUBMIT_PAGE',
                    navBarText: 'ssap.page_title.sign_and_submit',
                    component: {
                        type: {
                            compare: null,
                            displayName: 'Connect(Page3_17)',
                        },
                        key: null,
                        ref: null,
                        props: {},
                        _owner: null,
                        _store: {},
                    },
                    componentName: 'Page3_17',
                    buttons: {
                        leftButton: 'DEFAULT',
                        middleButton: 'HIDDEN',
                        rightButton: 'SWITCHED_TO_SUBMIT_BUTTON',
                        editButton_secondary: 'DEFAULT',
                    },
                    formName: 'signAndSubmitApplicationForm',
                },
                pageIndexInCurrentSection: 2,
                pageIndexInFlow: 69,
                sectionIndex: 4,
                sectionName: 'ssap.section_title.review',
                isTheFirstPageInSection: false,
            },
        ],
        affordability: {
            year: 2020,
            percent: 9.78,
        },
        counties: {
            HOME_ADDRESS: [
                {
                    16019: 'Bonneville',
                },
            ],
            MAILING_ADDRESS: [
                {
                    16053: 'Jerome',
                },
                {
                    16047: 'Gooding',
                },
            ],
        },
        countries: [
            {
                id: 1,
                countryCode: 'AFG',
                countryName: 'AFGHANISTAN',
                creationTimestamp: 1502152380434,
                updateTimestamp: 1425616321000,
            },
            {
                id: 2,
                countryCode: 'ALB',
                countryName: 'ALBANIA',
                creationTimestamp: 1502152380438,
                updateTimestamp: 1425616321000,
            },
            {
                id: 3,
                countryCode: 'DZA',
                countryName: 'ALGERIA',
                creationTimestamp: 1502152380440,
                updateTimestamp: 1425616321000,
            },
            {
                id: 4,
                countryCode: 'ASM',
                countryName: 'AMERICAN SAMOA',
                creationTimestamp: 1502152380443,
                updateTimestamp: 1425616321000,
            },
            {
                id: 5,
                countryCode: 'AND',
                countryName: 'ANDORRA',
                creationTimestamp: 1502152380446,
                updateTimestamp: 1425616321000,
            },
            {
                id: 6,
                countryCode: 'AGO',
                countryName: 'ANGOLA',
                creationTimestamp: 1502152380448,
                updateTimestamp: 1425616321000,
            },
            {
                id: 7,
                countryCode: 'AIA',
                countryName: 'ANGUILLA',
                creationTimestamp: 1502152380451,
                updateTimestamp: 1425616321000,
            },
            {
                id: 8,
                countryCode: 'ATA',
                countryName: 'ANTARCTICA',
                creationTimestamp: 1502152380454,
                updateTimestamp: 1425616321000,
            },
            {
                id: 9,
                countryCode: 'ATG',
                countryName: 'ANTIGUA AND BARBUDA',
                creationTimestamp: 1502152380456,
                updateTimestamp: 1425616321000,
            },
            {
                id: 10,
                countryCode: 'ARG',
                countryName: 'ARGENTINA',
                creationTimestamp: 1502152380459,
                updateTimestamp: 1425616321000,
            },
            {
                id: 11,
                countryCode: 'ARM',
                countryName: 'ARMENIA',
                creationTimestamp: 1502152380462,
                updateTimestamp: 1425616321000,
            },
            {
                id: 12,
                countryCode: 'ABW',
                countryName: 'ARUBA',
                creationTimestamp: 1502152380464,
                updateTimestamp: 1425616321000,
            },
            {
                id: 13,
                countryCode: 'AUS',
                countryName: 'AUSTRALIA',
                creationTimestamp: 1502152380467,
                updateTimestamp: 1425616321000,
            },
            {
                id: 14,
                countryCode: 'AUT',
                countryName: 'AUSTRIA',
                creationTimestamp: 1502152380469,
                updateTimestamp: 1425616321000,
            },
            {
                id: 15,
                countryCode: 'AZE',
                countryName: 'AZERBAIJAN',
                creationTimestamp: 1502152380472,
                updateTimestamp: 1425616321000,
            },
            {
                id: 16,
                countryCode: 'BHS',
                countryName: 'BAHAMAS',
                creationTimestamp: 1502152380474,
                updateTimestamp: 1425616321000,
            },
            {
                id: 17,
                countryCode: 'BHR',
                countryName: 'BAHRAIN',
                creationTimestamp: 1502152380477,
                updateTimestamp: 1425616321000,
            },
            {
                id: 18,
                countryCode: 'BGD',
                countryName: 'BANGLADESH',
                creationTimestamp: 1502152380480,
                updateTimestamp: 1425616321000,
            },
            {
                id: 19,
                countryCode: 'BRB',
                countryName: 'BARBADOS',
                creationTimestamp: 1502152380482,
                updateTimestamp: 1425616321000,
            },
            {
                id: 20,
                countryCode: 'BLR',
                countryName: 'BELARUS',
                creationTimestamp: 1502152380485,
                updateTimestamp: 1425616321000,
            },
            {
                id: 21,
                countryCode: 'BEL',
                countryName: 'BELGIUM',
                creationTimestamp: 1502152380487,
                updateTimestamp: 1425616321000,
            },
            {
                id: 22,
                countryCode: 'BLZ',
                countryName: 'BELIZE',
                creationTimestamp: 1502152380490,
                updateTimestamp: 1425616321000,
            },
            {
                id: 23,
                countryCode: 'BEN',
                countryName: 'BENIN',
                creationTimestamp: 1502152380492,
                updateTimestamp: 1425616321000,
            },
            {
                id: 24,
                countryCode: 'BMU',
                countryName: 'BERMUDA',
                creationTimestamp: 1502152380495,
                updateTimestamp: 1425616321000,
            },
            {
                id: 25,
                countryCode: 'BTN',
                countryName: 'BHUTAN',
                creationTimestamp: 1502152380498,
                updateTimestamp: 1425616321000,
            },
            {
                id: 26,
                countryCode: 'BOL',
                countryName: 'BOLIVIA, PLURINATIONAL STATE OF',
                creationTimestamp: 1502152380500,
                updateTimestamp: 1425616321000,
            },
            {
                id: 27,
                countryCode: 'BIH',
                countryName: 'BOSNIA AND HERZEGOVINA',
                creationTimestamp: 1502152380503,
                updateTimestamp: 1425616321000,
            },
            {
                id: 28,
                countryCode: 'BWA',
                countryName: 'BOTSWANA',
                creationTimestamp: 1502152380505,
                updateTimestamp: 1425616321000,
            },
            {
                id: 29,
                countryCode: 'BVT',
                countryName: 'BOUVET ISLAND',
                creationTimestamp: 1502152380508,
                updateTimestamp: 1425616321000,
            },
            {
                id: 30,
                countryCode: 'BRA',
                countryName: 'BRAZIL',
                creationTimestamp: 1502152380510,
                updateTimestamp: 1425616321000,
            },
            {
                id: 31,
                countryCode: 'IOT',
                countryName: 'BRITISH INDIAN OCEAN TERRITORY',
                creationTimestamp: 1502152380512,
                updateTimestamp: 1425616321000,
            },
            {
                id: 32,
                countryCode: 'BRN',
                countryName: 'BRUNEI DARUSSALAM',
                creationTimestamp: 1502152380515,
                updateTimestamp: 1425616321000,
            },
            {
                id: 33,
                countryCode: 'BGR',
                countryName: 'BULGARIA',
                creationTimestamp: 1502152380518,
                updateTimestamp: 1425616322000,
            },
            {
                id: 34,
                countryCode: 'BFA',
                countryName: 'BURKINA FASO',
                creationTimestamp: 1502152380520,
                updateTimestamp: 1425616322000,
            },
            {
                id: 35,
                countryCode: 'BDI',
                countryName: 'BURUNDI',
                creationTimestamp: 1502152380523,
                updateTimestamp: 1425616322000,
            },
            {
                id: 36,
                countryCode: 'KHM',
                countryName: 'CAMBODIA',
                creationTimestamp: 1502152380526,
                updateTimestamp: 1425616322000,
            },
            {
                id: 37,
                countryCode: 'CMR',
                countryName: 'CAMEROON',
                creationTimestamp: 1502152380528,
                updateTimestamp: 1425616322000,
            },
            {
                id: 38,
                countryCode: 'CAN',
                countryName: 'CANADA',
                creationTimestamp: 1502152380531,
                updateTimestamp: 1425616322000,
            },
            {
                id: 39,
                countryCode: 'CPV',
                countryName: 'CAPE VERDE',
                creationTimestamp: 1502152380534,
                updateTimestamp: 1425616322000,
            },
            {
                id: 40,
                countryCode: 'CYM',
                countryName: 'CAYMAN ISLANDS',
                creationTimestamp: 1502152380537,
                updateTimestamp: 1425616322000,
            },
            {
                id: 41,
                countryCode: 'CAF',
                countryName: 'CENTRAL AFRICAN REPUBLIC',
                creationTimestamp: 1502152380539,
                updateTimestamp: 1425616322000,
            },
            {
                id: 42,
                countryCode: 'TCD',
                countryName: 'CHAD',
                creationTimestamp: 1502152380542,
                updateTimestamp: 1425616322000,
            },
            {
                id: 43,
                countryCode: 'CHL',
                countryName: 'CHILE',
                creationTimestamp: 1502152380544,
                updateTimestamp: 1425616322000,
            },
            {
                id: 44,
                countryCode: 'CHN',
                countryName: 'CHINA',
                creationTimestamp: 1502152380547,
                updateTimestamp: 1425616322000,
            },
            {
                id: 45,
                countryCode: 'CXR',
                countryName: 'CHRISTMAS ISLAND',
                creationTimestamp: 1502152380549,
                updateTimestamp: 1425616322000,
            },
            {
                id: 46,
                countryCode: 'CCK',
                countryName: 'COCOS (KEELING) ISLANDS',
                creationTimestamp: 1502152380552,
                updateTimestamp: 1425616322000,
            },
            {
                id: 47,
                countryCode: 'COL',
                countryName: 'COLOMBIA',
                creationTimestamp: 1502152380555,
                updateTimestamp: 1425616322000,
            },
            {
                id: 48,
                countryCode: 'COM',
                countryName: 'COMOROS',
                creationTimestamp: 1502152380557,
                updateTimestamp: 1425616322000,
            },
            {
                id: 49,
                countryCode: 'COG',
                countryName: 'CONGO',
                creationTimestamp: 1502152380559,
                updateTimestamp: 1425616322000,
            },
            {
                id: 50,
                countryCode: 'COD',
                countryName: 'CONGO, DEMOCRATIC REPUBLIC OF THE',
                creationTimestamp: 1502152380562,
                updateTimestamp: 1425616322000,
            },
            {
                id: 51,
                countryCode: 'COK',
                countryName: 'COOK ISLANDS',
                creationTimestamp: 1502152380564,
                updateTimestamp: 1425616322000,
            },
            {
                id: 52,
                countryCode: 'CRI',
                countryName: 'COSTA RICA',
                creationTimestamp: 1502152380567,
                updateTimestamp: 1425616322000,
            },
            {
                id: 53,
                countryCode: 'HRV',
                countryName: 'CROATIA',
                creationTimestamp: 1502152380569,
                updateTimestamp: 1425616322000,
            },
            {
                id: 54,
                countryCode: 'CUB',
                countryName: 'CUBA',
                creationTimestamp: 1502152380572,
                updateTimestamp: 1425616322000,
            },
            {
                id: 55,
                countryCode: 'CYP',
                countryName: 'CYPRUS',
                creationTimestamp: 1502152380574,
                updateTimestamp: 1425616322000,
            },
            {
                id: 56,
                countryCode: 'CZE',
                countryName: 'CZECH REPUBLIC',
                creationTimestamp: 1502152380577,
                updateTimestamp: 1425616322000,
            },
            {
                id: 57,
                countryCode: 'CIV',
                countryName: 'CETE D\'IVOIRE',  
                creationTimestamp: 1502152380579,
                updateTimestamp: 1425616322000,
            },
            {
                id: 58,
                countryCode: 'DNK',
                countryName: 'DENMARK',
                creationTimestamp: 1502152380582,
                updateTimestamp: 1425616322000,
            },
            {
                id: 59,
                countryCode: 'DJI',
                countryName: 'DJIBOUTI',
                creationTimestamp: 1502152380584,
                updateTimestamp: 1425616322000,
            },
            {
                id: 60,
                countryCode: 'DMA',
                countryName: 'DOMINICA',
                creationTimestamp: 1502152380587,
                updateTimestamp: 1425616322000,
            },
            {
                id: 61,
                countryCode: 'DOM',
                countryName: 'DOMINICAN REPUBLIC',
                creationTimestamp: 1502152380589,
                updateTimestamp: 1425616322000,
            },
            {
                id: 62,
                countryCode: 'ECU',
                countryName: 'ECUADOR',
                creationTimestamp: 1502152380592,
                updateTimestamp: 1425616322000,
            },
            {
                id: 63,
                countryCode: 'EGY',
                countryName: 'EGYPT',
                creationTimestamp: 1502152380594,
                updateTimestamp: 1425616322000,
            },
            {
                id: 64,
                countryCode: 'SLV',
                countryName: 'EL SALVADOR',
                creationTimestamp: 1502152380597,
                updateTimestamp: 1425616322000,
            },
            {
                id: 65,
                countryCode: 'GNQ',
                countryName: 'EQUATORIAL GUINEA',
                creationTimestamp: 1502152380599,
                updateTimestamp: 1425616322000,
            },
            {
                id: 66,
                countryCode: 'ERI',
                countryName: 'ERITREA',
                creationTimestamp: 1502152380602,
                updateTimestamp: 1425616322000,
            },
            {
                id: 67,
                countryCode: 'EST',
                countryName: 'ESTONIA',
                creationTimestamp: 1502152380604,
                updateTimestamp: 1425616322000,
            },
            {
                id: 68,
                countryCode: 'ETH',
                countryName: 'ETHIOPIA',
                creationTimestamp: 1502152380607,
                updateTimestamp: 1425616322000,
            },
            {
                id: 69,
                countryCode: 'FLK',
                countryName: 'FALKLAND ISLANDS (MALVINAS)',
                creationTimestamp: 1502152380609,
                updateTimestamp: 1425616322000,
            },
            {
                id: 70,
                countryCode: 'FRO',
                countryName: 'FAROE ISLANDS',
                creationTimestamp: 1502152380612,
                updateTimestamp: 1425616322000,
            },
            {
                id: 71,
                countryCode: 'FJI',
                countryName: 'FIJI',
                creationTimestamp: 1502152380614,
                updateTimestamp: 1425616322000,
            },
            {
                id: 72,
                countryCode: 'FIN',
                countryName: 'FINLAND',
                creationTimestamp: 1502152380617,
                updateTimestamp: 1425616322000,
            },
            {
                id: 73,
                countryCode: 'FRA',
                countryName: 'FRANCE',
                creationTimestamp: 1502152380619,
                updateTimestamp: 1425616322000,
            },
            {
                id: 74,
                countryCode: 'GUF',
                countryName: 'FRENCH GUIANA',
                creationTimestamp: 1502152380622,
                updateTimestamp: 1425616322000,
            },
            {
                id: 75,
                countryCode: 'PYF',
                countryName: 'FRENCH POLYNESIA',
                creationTimestamp: 1502152380625,
                updateTimestamp: 1425616322000,
            },
            {
                id: 76,
                countryCode: 'ATF',
                countryName: 'FRENCH SOUTHERN TERRITORIES',
                creationTimestamp: 1502152380628,
                updateTimestamp: 1425616322000,
            },
            {
                id: 77,
                countryCode: 'GAB',
                countryName: 'GABON',
                creationTimestamp: 1502152380630,
                updateTimestamp: 1425616322000,
            },
            {
                id: 78,
                countryCode: 'GMB',
                countryName: 'GAMBIA',
                creationTimestamp: 1502152380633,
                updateTimestamp: 1425616322000,
            },
            {
                id: 79,
                countryCode: 'GEO',
                countryName: 'GEORGIA',
                creationTimestamp: 1502152380635,
                updateTimestamp: 1425616322000,
            },
            {
                id: 80,
                countryCode: 'DEU',
                countryName: 'GERMANY',
                creationTimestamp: 1502152380638,
                updateTimestamp: 1425616322000,
            },
            {
                id: 81,
                countryCode: 'GHA',
                countryName: 'GHANA',
                creationTimestamp: 1502152380641,
                updateTimestamp: 1425616322000,
            },
            {
                id: 82,
                countryCode: 'GIB',
                countryName: 'GIBRALTAR',
                creationTimestamp: 1502152380643,
                updateTimestamp: 1425616322000,
            },
            {
                id: 83,
                countryCode: 'GRC',
                countryName: 'GREECE',
                creationTimestamp: 1502152380646,
                updateTimestamp: 1425616322000,
            },
            {
                id: 84,
                countryCode: 'GRL',
                countryName: 'GREENLAND',
                creationTimestamp: 1502152380649,
                updateTimestamp: 1425616322000,
            },
            {
                id: 85,
                countryCode: 'GRD',
                countryName: 'GRENADA',
                creationTimestamp: 1502152380651,
                updateTimestamp: 1425616322000,
            },
            {
                id: 86,
                countryCode: 'GLP',
                countryName: 'GUADELOUPE',
                creationTimestamp: 1502152380654,
                updateTimestamp: 1425616322000,
            },
            {
                id: 87,
                countryCode: 'GUM',
                countryName: 'GUAM',
                creationTimestamp: 1502152380657,
                updateTimestamp: 1425616322000,
            },
            {
                id: 88,
                countryCode: 'GTM',
                countryName: 'GUATEMALA',
                creationTimestamp: 1502152380660,
                updateTimestamp: 1425616322000,
            },
            {
                id: 89,
                countryCode: 'GGY',
                countryName: 'GUERNSEY',
                creationTimestamp: 1502152380663,
                updateTimestamp: 1425616322000,
            },
            {
                id: 90,
                countryCode: 'GIN',
                countryName: 'GUINEA',
                creationTimestamp: 1502152380665,
                updateTimestamp: 1425616322000,
            },
            {
                id: 91,
                countryCode: 'GNB',
                countryName: 'GUINEA-BISSAU',
                creationTimestamp: 1502152380668,
                updateTimestamp: 1425616322000,
            },
            {
                id: 92,
                countryCode: 'GUY',
                countryName: 'GUYANA',
                creationTimestamp: 1502152380670,
                updateTimestamp: 1425616322000,
            },
            {
                id: 93,
                countryCode: 'HTI',
                countryName: 'HAITI',
                creationTimestamp: 1502152380673,
                updateTimestamp: 1425616322000,
            },
            {
                id: 94,
                countryCode: 'HMD',
                countryName: 'HEARD ISLAND AND MCDONALD ISLANDS',
                creationTimestamp: 1502152380675,
                updateTimestamp: 1425616322000,
            },
            {
                id: 95,
                countryCode: 'VAT',
                countryName: 'HOLY SEE (VATICAN CITY STATE)',
                creationTimestamp: 1502152380678,
                updateTimestamp: 1425616322000,
            },
            {
                id: 96,
                countryCode: 'HND',
                countryName: 'HONDURAS',
                creationTimestamp: 1502152380681,
                updateTimestamp: 1425616322000,
            },
            {
                id: 97,
                countryCode: 'HKG',
                countryName: 'HONG KONG',
                creationTimestamp: 1502152380683,
                updateTimestamp: 1425616322000,
            },
            {
                id: 98,
                countryCode: 'HUN',
                countryName: 'HUNGARY',
                creationTimestamp: 1502152380686,
                updateTimestamp: 1425616322000,
            },
            {
                id: 99,
                countryCode: 'ISL',
                countryName: 'ICELAND',
                creationTimestamp: 1502152380689,
                updateTimestamp: 1425616322000,
            },
            {
                id: 100,
                countryCode: 'IND',
                countryName: 'INDIA',
                creationTimestamp: 1502152380691,
                updateTimestamp: 1425616322000,
            },
            {
                id: 101,
                countryCode: 'IDN',
                countryName: 'INDONESIA',
                creationTimestamp: 1502152380694,
                updateTimestamp: 1425616322000,
            },
            {
                id: 102,
                countryCode: 'IRN',
                countryName: 'IRAN, ISLAMIC REPUBLIC OF',
                creationTimestamp: 1502152380697,
                updateTimestamp: 1425616322000,
            },
            {
                id: 103,
                countryCode: 'IRQ',
                countryName: 'IRAQ',
                creationTimestamp: 1502152380699,
                updateTimestamp: 1425616322000,
            },
            {
                id: 104,
                countryCode: 'IRL',
                countryName: 'IRELAND',
                creationTimestamp: 1502152380702,
                updateTimestamp: 1425616322000,
            },
            {
                id: 105,
                countryCode: 'IMN',
                countryName: 'ISLE OF MAN',
                creationTimestamp: 1502152380704,
                updateTimestamp: 1425616322000,
            },
            {
                id: 106,
                countryCode: 'ISR',
                countryName: 'ISRAEL',
                creationTimestamp: 1502152380707,
                updateTimestamp: 1425616322000,
            },
            {
                id: 107,
                countryCode: 'ITA',
                countryName: 'ITALY',
                creationTimestamp: 1502152380709,
                updateTimestamp: 1425616322000,
            },
            {
                id: 108,
                countryCode: 'JAM',
                countryName: 'JAMAICA',
                creationTimestamp: 1502152380712,
                updateTimestamp: 1425616322000,
            },
            {
                id: 109,
                countryCode: 'JPN',
                countryName: 'JAPAN',
                creationTimestamp: 1502152380715,
                updateTimestamp: 1425616322000,
            },
            {
                id: 110,
                countryCode: 'JEY',
                countryName: 'JERSEY',
                creationTimestamp: 1502152380718,
                updateTimestamp: 1425616322000,
            },
            {
                id: 111,
                countryCode: 'JOR',
                countryName: 'JORDAN',
                creationTimestamp: 1502152380720,
                updateTimestamp: 1425616322000,
            },
            {
                id: 112,
                countryCode: 'KAZ',
                countryName: 'KAZAKHSTAN',
                creationTimestamp: 1502152380723,
                updateTimestamp: 1425616322000,
            },
            {
                id: 113,
                countryCode: 'KEN',
                countryName: 'KENYA',
                creationTimestamp: 1502152380726,
                updateTimestamp: 1425616322000,
            },
            {
                id: 114,
                countryCode: 'KIR',
                countryName: 'KIRIBATI',
                creationTimestamp: 1502152380728,
                updateTimestamp: 1425616322000,
            },
            {
                id: 115,
                countryCode: 'PRK',
                countryName: 'KOREA, DEMOCRATIC PEOPLE\'S REPUBLIC OF',  
                creationTimestamp: 1502152380731,
                updateTimestamp: 1425616322000,
            },
            {
                id: 116,
                countryCode: 'KOR',
                countryName: 'KOREA, REPUBLIC OF',
                creationTimestamp: 1502152380733,
                updateTimestamp: 1425616322000,
            },
            {
                id: 117,
                countryCode: 'KVO',
                countryName: 'KOSOVO',
                creationTimestamp: 1502152380736,
                updateTimestamp: 1425616322000,
            },
            {
                id: 118,
                countryCode: 'KWT',
                countryName: 'KUWAIT',
                creationTimestamp: 1502152380739,
                updateTimestamp: 1425616322000,
            },
            {
                id: 119,
                countryCode: 'KGZ',
                countryName: 'KYRGYZSTAN',
                creationTimestamp: 1502152380742,
                updateTimestamp: 1425616322000,
            },
            {
                id: 237,
                countryCode: 'URY',
                countryName: 'URUGUAY',
                creationTimestamp: 1502152381063,
                updateTimestamp: 1425616322000,
            },
            {
                id: 120,
                countryCode: 'LAO',
                countryName: 'LAO PEOPLE\'S DEMOCRATIC REPUBLIC',  
                creationTimestamp: 1502152380745,
                updateTimestamp: 1425616322000,
            },
            {
                id: 121,
                countryCode: 'LVA',
                countryName: 'LATVIA',
                creationTimestamp: 1502152380749,
                updateTimestamp: 1425616322000,
            },
            {
                id: 122,
                countryCode: 'LBN',
                countryName: 'LEBANON',
                creationTimestamp: 1502152380751,
                updateTimestamp: 1425616322000,
            },
            {
                id: 123,
                countryCode: 'LSO',
                countryName: 'LESOTHO',
                creationTimestamp: 1502152380754,
                updateTimestamp: 1425616322000,
            },
            {
                id: 124,
                countryCode: 'LBR',
                countryName: 'LIBERIA',
                creationTimestamp: 1502152380757,
                updateTimestamp: 1425616322000,
            },
            {
                id: 125,
                countryCode: 'LBY',
                countryName: 'LIBYAN ARAB JAMAHIRIYA',
                creationTimestamp: 1502152380760,
                updateTimestamp: 1425616322000,
            },
            {
                id: 126,
                countryCode: 'LIE',
                countryName: 'LIECHTENSTEIN',
                creationTimestamp: 1502152380762,
                updateTimestamp: 1425616322000,
            },
            {
                id: 127,
                countryCode: 'LTU',
                countryName: 'LITHUANIA',
                creationTimestamp: 1502152380765,
                updateTimestamp: 1425616322000,
            },
            {
                id: 128,
                countryCode: 'LUX',
                countryName: 'LUXEMBOURG',
                creationTimestamp: 1502152380768,
                updateTimestamp: 1425616322000,
            },
            {
                id: 129,
                countryCode: 'MAC',
                countryName: 'MACAO',
                creationTimestamp: 1502152380771,
                updateTimestamp: 1425616322000,
            },
            {
                id: 130,
                countryCode: 'MKD',
                countryName: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF',
                creationTimestamp: 1502152380774,
                updateTimestamp: 1425616322000,
            },
            {
                id: 131,
                countryCode: 'MDG',
                countryName: 'MADAGASCAR',
                creationTimestamp: 1502152380777,
                updateTimestamp: 1425616322000,
            },
            {
                id: 132,
                countryCode: 'MWI',
                countryName: 'MALAWI',
                creationTimestamp: 1502152380779,
                updateTimestamp: 1425616322000,
            },
            {
                id: 133,
                countryCode: 'MYS',
                countryName: 'MALAYSIA',
                creationTimestamp: 1502152380782,
                updateTimestamp: 1425616322000,
            },
            {
                id: 134,
                countryCode: 'MDV',
                countryName: 'MALDIVES',
                creationTimestamp: 1502152380785,
                updateTimestamp: 1425616322000,
            },
            {
                id: 135,
                countryCode: 'MLI',
                countryName: 'MALI',
                creationTimestamp: 1502152380787,
                updateTimestamp: 1425616322000,
            },
            {
                id: 136,
                countryCode: 'MLT',
                countryName: 'MALTA',
                creationTimestamp: 1502152380790,
                updateTimestamp: 1425616322000,
            },
            {
                id: 137,
                countryCode: 'MHL',
                countryName: 'MARSHALL ISLANDS',
                creationTimestamp: 1502152380793,
                updateTimestamp: 1425616322000,
            },
            {
                id: 138,
                countryCode: 'MTQ',
                countryName: 'MARTINIQUE',
                creationTimestamp: 1502152380795,
                updateTimestamp: 1425616322000,
            },
            {
                id: 139,
                countryCode: 'MRT',
                countryName: 'MAURITANIA',
                creationTimestamp: 1502152380798,
                updateTimestamp: 1425616322000,
            },
            {
                id: 140,
                countryCode: 'MUS',
                countryName: 'MAURITIUS',
                creationTimestamp: 1502152380801,
                updateTimestamp: 1425616322000,
            },
            {
                id: 141,
                countryCode: 'MYT',
                countryName: 'MAYOTTE',
                creationTimestamp: 1502152380803,
                updateTimestamp: 1425616322000,
            },
            {
                id: 142,
                countryCode: 'MEX',
                countryName: 'MEXICO',
                creationTimestamp: 1502152380806,
                updateTimestamp: 1425616322000,
            },
            {
                id: 143,
                countryCode: 'FSM',
                countryName: 'MICRONESIA, FEDERATED STATES OF',
                creationTimestamp: 1502152380808,
                updateTimestamp: 1425616322000,
            },
            {
                id: 144,
                countryCode: 'MDA',
                countryName: 'MOLDOVA, REPUBLIC OF',
                creationTimestamp: 1502152380811,
                updateTimestamp: 1425616322000,
            },
            {
                id: 145,
                countryCode: 'MCO',
                countryName: 'MONACO',
                creationTimestamp: 1502152380814,
                updateTimestamp: 1425616322000,
            },
            {
                id: 146,
                countryCode: 'MNG',
                countryName: 'MONGOLIA',
                creationTimestamp: 1502152380816,
                updateTimestamp: 1425616322000,
            },
            {
                id: 147,
                countryCode: 'MNE',
                countryName: 'MONTENEGRO',
                creationTimestamp: 1502152380819,
                updateTimestamp: 1425616322000,
            },
            {
                id: 148,
                countryCode: 'MSR',
                countryName: 'MONTSERRAT',
                creationTimestamp: 1502152380821,
                updateTimestamp: 1425616322000,
            },
            {
                id: 149,
                countryCode: 'MAR',
                countryName: 'MOROCCO',
                creationTimestamp: 1502152380824,
                updateTimestamp: 1425616322000,
            },
            {
                id: 150,
                countryCode: 'MOZ',
                countryName: 'MOZAMBIQUE',
                creationTimestamp: 1502152380826,
                updateTimestamp: 1425616322000,
            },
            {
                id: 151,
                countryCode: 'MMR',
                countryName: 'MYANMAR',
                creationTimestamp: 1502152380829,
                updateTimestamp: 1425616322000,
            },
            {
                id: 152,
                countryCode: 'NAM',
                countryName: 'NAMIBIA',
                creationTimestamp: 1502152380831,
                updateTimestamp: 1425616322000,
            },
            {
                id: 153,
                countryCode: 'NRU',
                countryName: 'NAURU',
                creationTimestamp: 1502152380834,
                updateTimestamp: 1425616322000,
            },
            {
                id: 154,
                countryCode: 'NPL',
                countryName: 'NEPAL',
                creationTimestamp: 1502152380836,
                updateTimestamp: 1425616322000,
            },
            {
                id: 155,
                countryCode: 'NLD',
                countryName: 'NETHERLANDS',
                creationTimestamp: 1502152380839,
                updateTimestamp: 1425616322000,
            },
            {
                id: 156,
                countryCode: 'ANT',
                countryName: 'NETHERLANDS ANTILLES',
                creationTimestamp: 1502152380841,
                updateTimestamp: 1425616322000,
            },
            {
                id: 157,
                countryCode: 'NCL',
                countryName: 'NEW CALEDONIA',
                creationTimestamp: 1502152380844,
                updateTimestamp: 1425616322000,
            },
            {
                id: 158,
                countryCode: 'NZL',
                countryName: 'NEW ZEALAND',
                creationTimestamp: 1502152380846,
                updateTimestamp: 1425616322000,
            },
            {
                id: 159,
                countryCode: 'NIC',
                countryName: 'NICARAGUA',
                creationTimestamp: 1502152380849,
                updateTimestamp: 1425616322000,
            },
            {
                id: 160,
                countryCode: 'NER',
                countryName: 'NIGER',
                creationTimestamp: 1502152380851,
                updateTimestamp: 1425616322000,
            },
            {
                id: 161,
                countryCode: 'NGA',
                countryName: 'NIGERIA',
                creationTimestamp: 1502152380854,
                updateTimestamp: 1425616322000,
            },
            {
                id: 162,
                countryCode: 'NIU',
                countryName: 'NIUE',
                creationTimestamp: 1502152380856,
                updateTimestamp: 1425616322000,
            },
            {
                id: 163,
                countryCode: 'NFK',
                countryName: 'NORFOLK ISLAND',
                creationTimestamp: 1502152380859,
                updateTimestamp: 1425616322000,
            },
            {
                id: 164,
                countryCode: 'MNP',
                countryName: 'NORTHERN MARIANA ISLANDS',
                creationTimestamp: 1502152380861,
                updateTimestamp: 1425616322000,
            },
            {
                id: 165,
                countryCode: 'NOR',
                countryName: 'NORWAY',
                creationTimestamp: 1502152380864,
                updateTimestamp: 1425616322000,
            },
            {
                id: 166,
                countryCode: 'OMN',
                countryName: 'OMAN',
                creationTimestamp: 1502152380867,
                updateTimestamp: 1425616322000,
            },
            {
                id: 167,
                countryCode: 'PAK',
                countryName: 'PAKISTAN',
                creationTimestamp: 1502152380869,
                updateTimestamp: 1425616322000,
            },
            {
                id: 168,
                countryCode: 'PLW',
                countryName: 'PALAU',
                creationTimestamp: 1502152380872,
                updateTimestamp: 1425616322000,
            },
            {
                id: 169,
                countryCode: 'PSE',
                countryName: 'PALESTINIAN TERRITORY, OCCUPIED',
                creationTimestamp: 1502152380875,
                updateTimestamp: 1425616322000,
            },
            {
                id: 170,
                countryCode: 'PAN',
                countryName: 'PANAMA',
                creationTimestamp: 1502152380877,
                updateTimestamp: 1425616322000,
            },
            {
                id: 171,
                countryCode: 'PNG',
                countryName: 'PAPUA NEW GUINEA',
                creationTimestamp: 1502152380880,
                updateTimestamp: 1425616322000,
            },
            {
                id: 172,
                countryCode: 'PRY',
                countryName: 'PARAGUAY',
                creationTimestamp: 1502152380882,
                updateTimestamp: 1425616322000,
            },
            {
                id: 173,
                countryCode: 'PER',
                countryName: 'PERU',
                creationTimestamp: 1502152380885,
                updateTimestamp: 1425616322000,
            },
            {
                id: 174,
                countryCode: 'PHL',
                countryName: 'PHILIPPINES',
                creationTimestamp: 1502152380888,
                updateTimestamp: 1425616322000,
            },
            {
                id: 175,
                countryCode: 'PCN',
                countryName: 'PITCAIRN',
                creationTimestamp: 1502152380890,
                updateTimestamp: 1425616322000,
            },
            {
                id: 176,
                countryCode: 'POL',
                countryName: 'POLAND',
                creationTimestamp: 1502152380893,
                updateTimestamp: 1425616322000,
            },
            {
                id: 177,
                countryCode: 'PRT',
                countryName: 'PORTUGAL',
                creationTimestamp: 1502152380895,
                updateTimestamp: 1425616322000,
            },
            {
                id: 178,
                countryCode: 'PRI',
                countryName: 'PUERTO RICO',
                creationTimestamp: 1502152380898,
                updateTimestamp: 1425616322000,
            },
            {
                id: 179,
                countryCode: 'QAT',
                countryName: 'QATAR',
                creationTimestamp: 1502152380901,
                updateTimestamp: 1425616322000,
            },
            {
                id: 180,
                countryCode: 'ROU',
                countryName: 'ROMANIA',
                creationTimestamp: 1502152380903,
                updateTimestamp: 1425616322000,
            },
            {
                id: 181,
                countryCode: 'RUS',
                countryName: 'RUSSIAN FEDERATION',
                creationTimestamp: 1502152380906,
                updateTimestamp: 1425616322000,
            },
            {
                id: 182,
                countryCode: 'RWA',
                countryName: 'RWANDA',
                creationTimestamp: 1502152380909,
                updateTimestamp: 1425616322000,
            },
            {
                id: 183,
                countryCode: 'REU',
                countryName: 'REUNION',
                creationTimestamp: 1502152380912,
                updateTimestamp: 1425616322000,
            },
            {
                id: 184,
                countryCode: 'BLM',
                countryName: 'SAINT BARTHELEMY',
                creationTimestamp: 1502152380915,
                updateTimestamp: 1425616322000,
            },
            {
                id: 185,
                countryCode: 'SHN',
                countryName: 'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA',
                creationTimestamp: 1502152380918,
                updateTimestamp: 1425616322000,
            },
            {
                id: 186,
                countryCode: 'KNA',
                countryName: 'SAINT KITTS AND NEVIS',
                creationTimestamp: 1502152380920,
                updateTimestamp: 1425616322000,
            },
            {
                id: 187,
                countryCode: 'LCA',
                countryName: 'SAINT LUCIA',
                creationTimestamp: 1502152380923,
                updateTimestamp: 1425616322000,
            },
            {
                id: 188,
                countryCode: 'MAF',
                countryName: 'SAINT MARTIN (FRENCH PART)',
                creationTimestamp: 1502152380926,
                updateTimestamp: 1425616322000,
            },
            {
                id: 189,
                countryCode: 'SPM',
                countryName: 'SAINT PIERRE AND MIQUELON',
                creationTimestamp: 1502152380929,
                updateTimestamp: 1425616322000,
            },
            {
                id: 190,
                countryCode: 'VCT',
                countryName: 'SAINT VINCENT AND THE GRENADINES',
                creationTimestamp: 1502152380932,
                updateTimestamp: 1425616322000,
            },
            {
                id: 191,
                countryCode: 'WSM',
                countryName: 'SAMOA',
                creationTimestamp: 1502152380935,
                updateTimestamp: 1425616322000,
            },
            {
                id: 192,
                countryCode: 'SMR',
                countryName: 'SAN MARINO',
                creationTimestamp: 1502152380937,
                updateTimestamp: 1425616322000,
            },
            {
                id: 193,
                countryCode: 'STP',
                countryName: 'SAO TOME AND PRINCIPE',
                creationTimestamp: 1502152380942,
                updateTimestamp: 1425616322000,
            },
            {
                id: 194,
                countryCode: 'SAU',
                countryName: 'SAUDI ARABIA',
                creationTimestamp: 1502152380945,
                updateTimestamp: 1425616322000,
            },
            {
                id: 195,
                countryCode: 'SEN',
                countryName: 'SENEGAL',
                creationTimestamp: 1502152380948,
                updateTimestamp: 1425616322000,
            },
            {
                id: 196,
                countryCode: 'SRB',
                countryName: 'SERBIA',
                creationTimestamp: 1502152380950,
                updateTimestamp: 1425616322000,
            },
            {
                id: 197,
                countryCode: 'SYC',
                countryName: 'SEYCHELLES',
                creationTimestamp: 1502152380953,
                updateTimestamp: 1425616322000,
            },
            {
                id: 198,
                countryCode: 'SLE',
                countryName: 'SIERRA LEONE',
                creationTimestamp: 1502152380956,
                updateTimestamp: 1425616322000,
            },
            {
                id: 199,
                countryCode: 'SGP',
                countryName: 'SINGAPORE',
                creationTimestamp: 1502152380958,
                updateTimestamp: 1425616322000,
            },
            {
                id: 200,
                countryCode: 'SVK',
                countryName: 'SLOVAKIA',
                creationTimestamp: 1502152380961,
                updateTimestamp: 1425616322000,
            },
            {
                id: 201,
                countryCode: 'SVN',
                countryName: 'SLOVENIA',
                creationTimestamp: 1502152380964,
                updateTimestamp: 1425616322000,
            },
            {
                id: 202,
                countryCode: 'SLB',
                countryName: 'SOLOMON ISLANDS',
                creationTimestamp: 1502152380967,
                updateTimestamp: 1425616322000,
            },
            {
                id: 203,
                countryCode: 'SOM',
                countryName: 'SOMALIA',
                creationTimestamp: 1502152380970,
                updateTimestamp: 1425616322000,
            },
            {
                id: 204,
                countryCode: 'ZAF',
                countryName: 'SOUTH AFRICA',
                creationTimestamp: 1502152380973,
                updateTimestamp: 1425616322000,
            },
            {
                id: 205,
                countryCode: 'SGS',
                countryName: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS',
                creationTimestamp: 1502152380975,
                updateTimestamp: 1425616322000,
            },
            {
                id: 206,
                countryCode: 'SSD',
                countryName: 'SOUTH SUDAN',
                creationTimestamp: 1502152380978,
                updateTimestamp: 1425616322000,
            },
            {
                id: 207,
                countryCode: 'ESP',
                countryName: 'SPAIN',
                creationTimestamp: 1502152380981,
                updateTimestamp: 1425616322000,
            },
            {
                id: 208,
                countryCode: 'LKA',
                countryName: 'SRI LANKA',
                creationTimestamp: 1502152380984,
                updateTimestamp: 1425616322000,
            },
            {
                id: 209,
                countryCode: 'STL',
                countryName: 'STATELESS',
                creationTimestamp: 1502152380987,
                updateTimestamp: 1425616322000,
            },
            {
                id: 210,
                countryCode: 'SDN',
                countryName: 'SUDAN',
                creationTimestamp: 1502152380990,
                updateTimestamp: 1425616322000,
            },
            {
                id: 211,
                countryCode: 'SUR',
                countryName: 'SURINAME',
                creationTimestamp: 1502152380992,
                updateTimestamp: 1425616322000,
            },
            {
                id: 212,
                countryCode: 'SJM',
                countryName: 'SVALBARD AND JAN MAYEN',
                creationTimestamp: 1502152380995,
                updateTimestamp: 1425616322000,
            },
            {
                id: 213,
                countryCode: 'SWZ',
                countryName: 'SWAZILAND',
                creationTimestamp: 1502152380997,
                updateTimestamp: 1425616322000,
            },
            {
                id: 214,
                countryCode: 'SWE',
                countryName: 'SWEDEN',
                creationTimestamp: 1502152381000,
                updateTimestamp: 1425616322000,
            },
            {
                id: 215,
                countryCode: 'CHE',
                countryName: 'SWITZERLAND',
                creationTimestamp: 1502152381003,
                updateTimestamp: 1425616322000,
            },
            {
                id: 216,
                countryCode: 'SYR',
                countryName: 'SYRIAN ARAB REPUBLIC',
                creationTimestamp: 1502152381006,
                updateTimestamp: 1425616322000,
            },
            {
                id: 217,
                countryCode: 'TWN',
                countryName: 'TAIWAN, PROVINCE OF CHINA',
                creationTimestamp: 1502152381009,
                updateTimestamp: 1425616322000,
            },
            {
                id: 218,
                countryCode: 'TJK',
                countryName: 'TAJIKISTAN',
                creationTimestamp: 1502152381012,
                updateTimestamp: 1425616322000,
            },
            {
                id: 219,
                countryCode: 'TZA',
                countryName: 'TANZANIA, UNITED REPUBLIC OF',
                creationTimestamp: 1502152381015,
                updateTimestamp: 1425616322000,
            },
            {
                id: 220,
                countryCode: 'THA',
                countryName: 'THAILAND',
                creationTimestamp: 1502152381018,
                updateTimestamp: 1425616322000,
            },
            {
                id: 221,
                countryCode: 'TLS',
                countryName: 'TIMOR-LESTE',
                creationTimestamp: 1502152381020,
                updateTimestamp: 1425616322000,
            },
            {
                id: 222,
                countryCode: 'TGO',
                countryName: 'TOGO',
                creationTimestamp: 1502152381023,
                updateTimestamp: 1425616322000,
            },
            {
                id: 223,
                countryCode: 'TKL',
                countryName: 'TOKELAU',
                creationTimestamp: 1502152381026,
                updateTimestamp: 1425616322000,
            },
            {
                id: 224,
                countryCode: 'TON',
                countryName: 'TONGA',
                creationTimestamp: 1502152381028,
                updateTimestamp: 1425616322000,
            },
            {
                id: 225,
                countryCode: 'TTO',
                countryName: 'TRINIDAD AND TOBAGO',
                creationTimestamp: 1502152381031,
                updateTimestamp: 1425616322000,
            },
            {
                id: 226,
                countryCode: 'TUN',
                countryName: 'TUNISIA',
                creationTimestamp: 1502152381033,
                updateTimestamp: 1425616322000,
            },
            {
                id: 227,
                countryCode: 'TUR',
                countryName: 'TURKEY',
                creationTimestamp: 1502152381036,
                updateTimestamp: 1425616322000,
            },
            {
                id: 228,
                countryCode: 'TKM',
                countryName: 'TURKMENISTAN',
                creationTimestamp: 1502152381039,
                updateTimestamp: 1425616322000,
            },
            {
                id: 229,
                countryCode: 'TCA',
                countryName: 'TURKS AND CAICOS ISLANDS',
                creationTimestamp: 1502152381041,
                updateTimestamp: 1425616322000,
            },
            {
                id: 230,
                countryCode: 'TUV',
                countryName: 'TUVALU',
                creationTimestamp: 1502152381044,
                updateTimestamp: 1425616322000,
            },
            {
                id: 231,
                countryCode: 'UGA',
                countryName: 'UGANDA',
                creationTimestamp: 1502152381047,
                updateTimestamp: 1425616322000,
            },
            {
                id: 232,
                countryCode: 'UKR',
                countryName: 'UKRAINE',
                creationTimestamp: 1502152381049,
                updateTimestamp: 1425616322000,
            },
            {
                id: 233,
                countryCode: 'ARE',
                countryName: 'UNITED ARAB EMIRATES',
                creationTimestamp: 1502152381052,
                updateTimestamp: 1425616322000,
            },
            {
                id: 234,
                countryCode: 'GBR',
                countryName: 'UNITED KINGDOM',
                creationTimestamp: 1502152381055,
                updateTimestamp: 1425616322000,
            },
            {
                id: 235,
                countryCode: 'USA',
                countryName: 'UNITED STATES',
                creationTimestamp: 1502152381057,
                updateTimestamp: 1425616322000,
            },
            {
                id: 236,
                countryCode: 'UMI',
                countryName: 'UNITED STATES MINOR OUTLYING ISLANDS',
                creationTimestamp: 1502152381060,
                updateTimestamp: 1425616322000,
            },
            {
                id: 238,
                countryCode: 'UZB',
                countryName: 'UZBEKISTAN',
                creationTimestamp: 1502152381066,
                updateTimestamp: 1425616322000,
            },
            {
                id: 239,
                countryCode: 'VUT',
                countryName: 'VANUATU',
                creationTimestamp: 1502152381069,
                updateTimestamp: 1425616322000,
            },
            {
                id: 240,
                countryCode: 'VEN',
                countryName: 'VENEZUELA, BOLIVARIAN REPUBLIC OF',
                creationTimestamp: 1502152381072,
                updateTimestamp: 1425616322000,
            },
            {
                id: 241,
                countryCode: 'VNM',
                countryName: 'VIET NAM',
                creationTimestamp: 1502152381074,
                updateTimestamp: 1425616322000,
            },
            {
                id: 242,
                countryCode: 'VGB',
                countryName: 'VIRGIN ISLANDS (BRITISH)',
                creationTimestamp: 1502152381077,
                updateTimestamp: 1425616322000,
            },
            {
                id: 243,
                countryCode: 'VIR',
                countryName: 'VIRGIN ISLANDS (U.S.)',
                creationTimestamp: 1502152381080,
                updateTimestamp: 1425616322000,
            },
            {
                id: 244,
                countryCode: 'WLF',
                countryName: 'WALLIS AND FUTUNA',
                creationTimestamp: 1502152381082,
                updateTimestamp: 1425616322000,
            },
            {
                id: 245,
                countryCode: 'ESH',
                countryName: 'WESTERN SAHARA *',
                creationTimestamp: 1502152381085,
                updateTimestamp: 1425616322000,
            },
            {
                id: 246,
                countryCode: 'YEM',
                countryName: 'YEMEN',
                creationTimestamp: 1502152381088,
                updateTimestamp: 1425616322000,
            },
            {
                id: 247,
                countryCode: 'ZMB',
                countryName: 'ZAMBIA',
                creationTimestamp: 1502152381090,
                updateTimestamp: 1425616322000,
            },
            {
                id: 248,
                countryCode: 'ZWE',
                countryName: 'ZIMBABWE',
                creationTimestamp: 1502152381093,
                updateTimestamp: 1425616322000,
            },
            {
                id: 249,
                countryCode: 'ALA',
                countryName: 'ELAND ISLANDS',
                creationTimestamp: 1502152381096,
                updateTimestamp: 1425616322000,
            },
        ],
        data: getDataToSave(ssapData),
        launchData: {
            isInReviewMode: false
        },
        disabledUi: {
            allInputsDisabled: false,
            buttonsDisabled: [],
            errorMessage: null,
            errorMessageReplacements: [],
        },
        enrollments: {
            atomized: {},
            bulk: [
                {
                    memberGuid: '1001002145',
                    hasActiveHealthEnrollment: true,
                },
                {
                    memberGuid: '1001016686',
                    hasActiveHealthEnrollment: true,
                },
                {
                    memberGuid: '1001016687',
                    hasActiveHealthEnrollment: false,
                },
            ],
            isDataFetched: false
        },
        exception: {
            exceptionType: null,
            exceptionPages: [],
        },
        flow: {
            flowType: flowTypes.FINANCIAL_FLOW,
            isFlowLoaded: true,
        },
        form: {
            firstForm: {
                isFormInInitialState: true,
            },
            secondForm: {
                isFormInInitialState: true,
            },
        },
        methods: {},
        page: 10,
        previousData: getDataToSave(ssapPreviousData),
        tribes: [
            {
                name: 'Alabama',
                code: 'AL',
                tribes: [
                    {
                        tribeName: 'Poarch Band of Creek Indians of Alabama',
                        tribeCode: 'AL010001',
                    },
                ],
            },
            {
                name: 'Alaska',
                code: 'AK',
                tribes: [
                    {
                        tribeName: 'Agdaagux Tribe of King Cove',
                        tribeCode: 'AK020003',
                    },
                    {
                        tribeName: 'Ak Chin Indian Community of the Maricopa (Ak Chin) Indian Reservation',
                        tribeCode: 'AK020232',
                    },
                    {
                        tribeName: 'Akiachak Native Community',
                        tribeCode: 'AK020005',
                    },
                    {
                        tribeName: 'Akiak Native Community',
                        tribeCode: 'AK020006',
                    },
                    {
                        tribeName: 'Alatna Village',
                        tribeCode: 'AK020009',
                    },
                    {
                        tribeName: 'Algaaciq Native Village (St. Mary\'s)',  
                        tribeCode: 'AK020011',
                    },
                    {
                        tribeName: 'Allakaket Village',
                        tribeCode: 'AK020012',
                    },
                    {
                        tribeName: 'Angoon Community Association',
                        tribeCode: 'AK020016',
                    },
                    {
                        tribeName: 'Anvik Village',
                        tribeCode: 'AK020018',
                    },
                    {
                        tribeName: 'Arctic Village (See Native Village of Venetie Tribal Government)',
                        tribeCode: 'AK020019',
                    },
                    {
                        tribeName: 'Arizona',
                        tribeCode: 'AK020231',
                    },
                    {
                        tribeName: 'Asa\'carsarmiut Tribe',  
                        tribeCode: 'AK020020',
                    },
                    {
                        tribeName: 'Atqasuk Village (Atkasook)',
                        tribeCode: 'AK020023',
                    },
                    {
                        tribeName: 'Beaver Village',
                        tribeCode: 'AK020025',
                    },
                    {
                        tribeName: 'Birch Creek Tribe',
                        tribeCode: 'AK020028',
                    },
                    {
                        tribeName: 'Central Council of the Tlingit & Haida Indian Tribes',
                        tribeCode: 'AK020213',
                    },
                    {
                        tribeName: 'Chalkyitsik Village',
                        tribeCode: 'AK020033',
                    },
                    {
                        tribeName: 'Cheesh-Na Tribe (formerly the Native Village of Chistochina)',
                        tribeCode: 'AK020034',
                    },
                    {
                        tribeName: 'Chevak Native Village',
                        tribeCode: 'AK020036',
                    },
                    {
                        tribeName: 'Chickaloon Native Village',
                        tribeCode: 'AK020037',
                    },
                    {
                        tribeName: 'Chignik Bay Tribal Council (formerly the Native Village of Chignik)',
                        tribeCode: 'AK020038',
                    },
                    {
                        tribeName: 'Chignik Lake Village',
                        tribeCode: 'AK020040',
                    },
                    {
                        tribeName: 'Chilkat Indian Village (Klukwan)',
                        tribeCode: 'AK020041',
                    },
                    {
                        tribeName: 'Chilkoot Indian Association (Haines)',
                        tribeCode: 'AK020042',
                    },
                    {
                        tribeName: 'Chinik Eskimo Community (Golovin)',
                        tribeCode: 'AK020043',
                    },
                    {
                        tribeName: 'Chuloonawick Native Village',
                        tribeCode: 'AK020046',
                    },
                    {
                        tribeName: 'Circle Native Community',
                        tribeCode: 'AK020047',
                    },
                    {
                        tribeName: 'Cocopah Tribe of Arizona',
                        tribeCode: 'AK020233',
                    },
                    {
                        tribeName:
                            'Colorado River Indian Tribes of the Colorado River Indian Reservation (Arizona and California)',
                        tribeCode: 'AK020234',
                    },
                    {
                        tribeName: 'Craig Community Association',
                        tribeCode: 'AK020050',
                    },
                    {
                        tribeName: 'Curyung Tribal Council',
                        tribeCode: 'AK020052',
                    },
                    {
                        tribeName: 'Douglas Indian Association',
                        tribeCode: 'AK020056',
                    },
                    {
                        tribeName: 'Egegik Village',
                        tribeCode: 'AK020059',
                    },
                    {
                        tribeName: 'Eklutna Native Village',
                        tribeCode: 'AK020060',
                    },
                    {
                        tribeName: 'Ekwok Village',
                        tribeCode: 'AK020062',
                    },
                    {
                        tribeName: 'Emmonak Village',
                        tribeCode: 'AK020064',
                    },
                    {
                        tribeName: 'Evansville Village (aka Bettles Field)',
                        tribeCode: 'AK020065',
                    },
                    {
                        tribeName: 'Fort McDowell Yavapai Nation',
                        tribeCode: 'AK020235',
                    },
                    {
                        tribeName: 'Fort Mojave Indian Tribe (Arizona, California and Nevada)',
                        tribeCode: 'AK020236',
                    },
                    {
                        tribeName: 'Galena Village (aka Louden Village)',
                        tribeCode: 'AK020070',
                    },
                    {
                        tribeName: 'Gila River Indian Community of the Gila River Indian Reservation',
                        tribeCode: 'AK020237',
                    },
                    {
                        tribeName: 'Gulkana Village',
                        tribeCode: 'AK020075',
                    },
                    {
                        tribeName: 'Havasupai Tribe of the Havasupai Reservation',
                        tribeCode: 'AK020238',
                    },
                    {
                        tribeName: 'Healy Lake Village',
                        tribeCode: 'AK020077',
                    },
                    {
                        tribeName: 'Holy Cross Village',
                        tribeCode: 'AK020078',
                    },
                    {
                        tribeName: 'Hoonah Indian Association',
                        tribeCode: 'AK020079',
                    },
                    {
                        tribeName: 'Hopi Tribe of Arizona',
                        tribeCode: 'AK020239',
                    },
                    {
                        tribeName: 'Hualapai Indian Tribe of the Hualapai Indian Tribe Reservation',
                        tribeCode: 'AK020240',
                    },
                    {
                        tribeName: 'Hughes Village',
                        tribeCode: 'AK020081',
                    },
                    {
                        tribeName: 'Huslia Village',
                        tribeCode: 'AK020082',
                    },
                    {
                        tribeName: 'Hydaburg Cooperative Association',
                        tribeCode: 'AK020083',
                    },
                    {
                        tribeName: 'Igiugig Village',
                        tribeCode: 'AK020084',
                    },
                    {
                        tribeName: 'Inupiat Community of the Arctic Slope',
                        tribeCode: 'AK020086',
                    },
                    {
                        tribeName: 'Iqurmuit Traditional Council (formerly the Native Village of Russian Mission)',
                        tribeCode: 'AK020087',
                    },
                    {
                        tribeName: 'Ivanoff Bay Village',
                        tribeCode: 'AK020088',
                    },
                    {
                        tribeName: 'Kaguyak Village',
                        tribeCode: 'AK020089',
                    },
                    {
                        tribeName: 'Kaibab Band of Paiute Indians of the Kaibab Indian Reservation',
                        tribeCode: 'AK020241',
                    },
                    {
                        tribeName: 'Kaktovik Village (aka Barter Island)',
                        tribeCode: 'AK020091',
                    },
                    {
                        tribeName: 'Kasigluk Traditional Elders Council (formerly the Native Village of Kasigluk)',
                        tribeCode: 'AK020097',
                    },
                    {
                        tribeName: 'Kenaitze Indian Tribe',
                        tribeCode: 'AK020098',
                    },
                    {
                        tribeName: 'Ketchikan Indian Corporation',
                        tribeCode: 'AK020099',
                    },
                    {
                        tribeName: 'King Island Native Community',
                        tribeCode: 'AK020101',
                    },
                    {
                        tribeName: 'King Salmon Tribe',
                        tribeCode: 'AK020102',
                    },
                    {
                        tribeName: 'Klawock Cooperative Association',
                        tribeCode: 'AK020105',
                    },
                    {
                        tribeName: 'Knik Tribe',
                        tribeCode: 'AK020107',
                    },
                    {
                        tribeName: 'Kokhanok Village',
                        tribeCode: 'AK020109',
                    },
                    {
                        tribeName: 'Koyukuk Native Village',
                        tribeCode: 'AK020114',
                    },
                    {
                        tribeName: 'Levelock Village',
                        tribeCode: 'AK020119',
                    },
                    {
                        tribeName: 'Lime Village',
                        tribeCode: 'AK020120',
                    },
                    {
                        tribeName: 'Manley Hot Springs Village',
                        tribeCode: 'AK020122',
                    },
                    {
                        tribeName: 'Manokotak Village',
                        tribeCode: 'AK020123',
                    },
                    {
                        tribeName: 'McGrath Native Village',
                        tribeCode: 'AK020126',
                    },
                    {
                        tribeName: 'Mentasta Traditional Council',
                        tribeCode: 'AK020128',
                    },
                    {
                        tribeName: 'Metlakatla Indian Community, Annette Island Reserve',
                        tribeCode: 'AK020129',
                    },
                    {
                        tribeName: 'Naknek Native Village',
                        tribeCode: 'AK020131',
                    },
                    {
                        tribeName: 'Native Village of Afognak (formerly the Village of Afognak)',
                        tribeCode: 'AK020002',
                    },
                    {
                        tribeName: 'Native Village of Akhiok',
                        tribeCode: 'AK020004',
                    },
                    {
                        tribeName: 'Native Village of Akutan',
                        tribeCode: 'AK020007',
                    },
                    {
                        tribeName: 'Native Village of Aleknagik',
                        tribeCode: 'AK020010',
                    },
                    {
                        tribeName: 'Native Village of Ambler',
                        tribeCode: 'AK020013',
                    },
                    {
                        tribeName: 'Native Village of Atka',
                        tribeCode: 'AK020021',
                    },
                    {
                        tribeName: 'Native Village of Barrow Inupiat Traditional Government',
                        tribeCode: 'AK020024',
                    },
                    {
                        tribeName: 'Native Village of Belkofski',
                        tribeCode: 'AK020026',
                    },
                    {
                        tribeName: 'Native Village of Brevig Mission',
                        tribeCode: 'AK020029',
                    },
                    {
                        tribeName: 'Native Village of Buckland',
                        tribeCode: 'AK020030',
                    },
                    {
                        tribeName: 'Native Village of Cantwell',
                        tribeCode: 'AK020031',
                    },
                    {
                        tribeName: 'Native Village of Chenega (aka Chanega)',
                        tribeCode: 'AK020032',
                    },
                    {
                        tribeName: 'Native Village of Chignik Lagoon',
                        tribeCode: 'AK020039',
                    },
                    {
                        tribeName: 'Native Village of Chitina',
                        tribeCode: 'AK020044',
                    },
                    {
                        tribeName: 'Native Village of Chuathbaluk (Russian Mission, Kuskokwim)',
                        tribeCode: 'AK020045',
                    },
                    {
                        tribeName: 'Native Village of Council',
                        tribeCode: 'AK020049',
                    },
                    {
                        tribeName: 'Native Village of Deering',
                        tribeCode: 'AK020053',
                    },
                    {
                        tribeName: 'Native Village of Diomede (aka Inalik)',
                        tribeCode: 'AK020054',
                    },
                    {
                        tribeName: 'Native Village of Eagle',
                        tribeCode: 'AK020057',
                    },
                    {
                        tribeName: 'Native Village of Eek',
                        tribeCode: 'AK020058',
                    },
                    {
                        tribeName: 'Native Village of Ekuk',
                        tribeCode: 'AK020061',
                    },
                    {
                        tribeName: 'Native Village of Elim',
                        tribeCode: 'AK020063',
                    },
                    {
                        tribeName: 'Native Village of Eyak (Cordova)',
                        tribeCode: 'AK020066',
                    },
                    {
                        tribeName: 'Native Village of False Pass',
                        tribeCode: 'AK020067',
                    },
                    {
                        tribeName: 'Native Village of Fort Yukon',
                        tribeCode: 'AK020068',
                    },
                    {
                        tribeName: 'Native Village of Gakona',
                        tribeCode: 'AK020069',
                    },
                    {
                        tribeName: 'Native Village of Gambell',
                        tribeCode: 'AK020071',
                    },
                    {
                        tribeName: 'Native Village of Georgetown',
                        tribeCode: 'AK020072',
                    },
                    {
                        tribeName: 'Native Village of Goodnews Bay',
                        tribeCode: 'AK020073',
                    },
                    {
                        tribeName: 'Native Village of Hamilton',
                        tribeCode: 'AK020076',
                    },
                    {
                        tribeName: 'Native Village of Hooper Bay',
                        tribeCode: 'AK020080',
                    },
                    {
                        tribeName: 'Native Village of Kanatak',
                        tribeCode: 'AK020094',
                    },
                    {
                        tribeName: 'Native Village of Karluk',
                        tribeCode: 'AK020095',
                    },
                    {
                        tribeName: 'Native Village of Kiana',
                        tribeCode: 'AK020100',
                    },
                    {
                        tribeName: 'Native Village of Kipnuk',
                        tribeCode: 'AK020103',
                    },
                    {
                        tribeName: 'Native Village of Kivalina',
                        tribeCode: 'AK020104',
                    },
                    {
                        tribeName: 'Native Village of Kluti Kaah (aka Copper Center)',
                        tribeCode: 'AK020106',
                    },
                    {
                        tribeName: 'Native Village of Kobuk',
                        tribeCode: 'AK020108',
                    },
                    {
                        tribeName: 'Native Village of Kongiganak',
                        tribeCode: 'AK020110',
                    },
                    {
                        tribeName: 'Native Village of Kotzebue',
                        tribeCode: 'AK020112',
                    },
                    {
                        tribeName: 'Native Village of Koyuk',
                        tribeCode: 'AK020113',
                    },
                    {
                        tribeName: 'Native Village of Kwigillingok',
                        tribeCode: 'AK020116',
                    },
                    {
                        tribeName: 'Native Village of Kwinhagak (aka Quinhagak)',
                        tribeCode: 'AK020117',
                    },
                    {
                        tribeName: 'Native Village of Larsen Bay',
                        tribeCode: 'AK020118',
                    },
                    {
                        tribeName: 'Native Village of Marshall (aka Fortuna Ledge)',
                        tribeCode: 'AK020124',
                    },
                    {
                        tribeName: 'Native Village of Mary\'s Igloo',  
                        tribeCode: 'AK020125',
                    },
                    {
                        tribeName: 'Native Village of Mekoryuk',
                        tribeCode: 'AK020127',
                    },
                    {
                        tribeName: 'Native Village of Minto',
                        tribeCode: 'AK020130',
                    },
                    {
                        tribeName: 'Native Village of Nanwalek (aka English Bay)',
                        tribeCode: 'AK020132',
                    },
                    {
                        tribeName: 'Native Village of Napaimute',
                        tribeCode: 'AK020133',
                    },
                    {
                        tribeName: 'Native Village of Napakiak',
                        tribeCode: 'AK020134',
                    },
                    {
                        tribeName: 'Native Village of Napaskiak',
                        tribeCode: 'AK020135',
                    },
                    {
                        tribeName: 'Native Village of Nelson Lagoon',
                        tribeCode: 'AK020136',
                    },
                    {
                        tribeName: 'Native Village of Nightmute',
                        tribeCode: 'AK020142',
                    },
                    {
                        tribeName: 'Native Village of Nikolski',
                        tribeCode: 'AK020144',
                    },
                    {
                        tribeName: 'Native Village of Noatak',
                        tribeCode: 'AK020146',
                    },
                    {
                        tribeName: 'Native Village of Nuiqsut (aka Nooiksut)',
                        tribeCode: 'AK020151',
                    },
                    {
                        tribeName: 'Native Village of Nunam Iqua (formerly the Native Village of Sheldon\'s Point)',  
                        tribeCode: 'AK020154',
                    },
                    {
                        tribeName: 'Native Village of Nunapitchuk',
                        tribeCode: 'AK020155',
                    },
                    {
                        tribeName: 'Native Village of Ouzinkie',
                        tribeCode: 'AK020160',
                    },
                    {
                        tribeName: 'Native Village of Paimiut',
                        tribeCode: 'AK020161',
                    },
                    {
                        tribeName: 'Native Village of Perryville',
                        tribeCode: 'AK020164',
                    },
                    {
                        tribeName: 'Native Village of Pilot Point',
                        tribeCode: 'AK020166',
                    },
                    {
                        tribeName: 'Native Village of Pitka\'s Point',  
                        tribeCode: 'AK020168',
                    },
                    {
                        tribeName: 'Native Village of Point Hope',
                        tribeCode: 'AK020170',
                    },
                    {
                        tribeName: 'Native Village of Point Lay',
                        tribeCode: 'AK020171',
                    },
                    {
                        tribeName: 'Native Village of Port Graham',
                        tribeCode: 'AK020172',
                    },
                    {
                        tribeName: 'Native Village of Port Heiden',
                        tribeCode: 'AK020173',
                    },
                    {
                        tribeName: 'Native Village of Port Lions',
                        tribeCode: 'AK020174',
                    },
                    {
                        tribeName: 'Native Village of Ruby',
                        tribeCode: 'AK020181',
                    },
                    {
                        tribeName: 'Native Village of Saint Michael',
                        tribeCode: 'AK020183',
                    },
                    {
                        tribeName: 'Native Village of Savoonga',
                        tribeCode: 'AK020186',
                    },
                    {
                        tribeName: 'Native Village of Scammon Bay',
                        tribeCode: 'AK020188',
                    },
                    {
                        tribeName: 'Native Village of Selawik',
                        tribeCode: 'AK020189',
                    },
                    {
                        tribeName: 'Native Village of Shaktoolik',
                        tribeCode: 'AK020192',
                    },
                    {
                        tribeName: 'Native Village of Shishmaref',
                        tribeCode: 'AK020193',
                    },
                    {
                        tribeName: 'Native Village of Shungnak',
                        tribeCode: 'AK020194',
                    },
                    {
                        tribeName: 'Native Village of Stevens',
                        tribeCode: 'AK020201',
                    },
                    {
                        tribeName: 'Native Village of Tanacross',
                        tribeCode: 'AK020205',
                    },
                    {
                        tribeName: 'Native Village of Tanana',
                        tribeCode: 'AK020206',
                    },
                    {
                        tribeName: 'Native Village of Tatitlek',
                        tribeCode: 'AK020208',
                    },
                    {
                        tribeName: 'Native Village of Tazlina',
                        tribeCode: 'AK020209',
                    },
                    {
                        tribeName: 'Native Village of Teller',
                        tribeCode: 'AK020211',
                    },
                    {
                        tribeName: 'Native Village of Tetlin',
                        tribeCode: 'AK020212',
                    },
                    {
                        tribeName: 'Native Village of Tuntutuliak',
                        tribeCode: 'AK020216',
                    },
                    {
                        tribeName: 'Native Village of Tununak',
                        tribeCode: 'AK020217',
                    },
                    {
                        tribeName: 'Native Village of Tyonek',
                        tribeCode: 'AK020219',
                    },
                    {
                        tribeName: 'Native Village of Unalakleet',
                        tribeCode: 'AK020222',
                    },
                    {
                        tribeName: 'Native Village of Unga',
                        tribeCode: 'AK020223',
                    },
                    {
                        tribeName:
                            'Native Village of Venetie Tribal Government (Arctic Village and Village of Venetie)',
                        tribeCode: 'AK020225',
                    },
                    {
                        tribeName: 'Native Village of Wales',
                        tribeCode: 'AK020227',
                    },
                    {
                        tribeName: 'Native Village of White Mountain',
                        tribeCode: 'AK020228',
                    },
                    {
                        tribeName: 'Navajo Nation (Arizona, New Mexico and Utah)',
                        tribeCode: 'AK020242',
                    },
                    {
                        tribeName: 'Nenana Native Association',
                        tribeCode: 'AK020137',
                    },
                    {
                        tribeName: 'New Koliganek Village Council',
                        tribeCode: 'AK020138',
                    },
                    {
                        tribeName: 'New Stuyahok Village',
                        tribeCode: 'AK020139',
                    },
                    {
                        tribeName: 'Newhalen Village',
                        tribeCode: 'AK020140',
                    },
                    {
                        tribeName: 'Newtok Village',
                        tribeCode: 'AK020141',
                    },
                    {
                        tribeName: 'Nikolai Village',
                        tribeCode: 'AK020143',
                    },
                    {
                        tribeName: 'Ninilchik Village',
                        tribeCode: 'AK020145',
                    },
                    {
                        tribeName: 'Nome Eskimo Community',
                        tribeCode: 'AK020147',
                    },
                    {
                        tribeName: 'Nondalton Village',
                        tribeCode: 'AK020148',
                    },
                    {
                        tribeName: 'Noorvik Native Community',
                        tribeCode: 'AK020149',
                    },
                    {
                        tribeName: 'Northway Village',
                        tribeCode: 'AK020150',
                    },
                    {
                        tribeName: 'Nulato Village',
                        tribeCode: 'AK020152',
                    },
                    {
                        tribeName: 'Nunakauyarmiut Tribe (formerly the Native Village of Toksook Bay)',
                        tribeCode: 'AK020153',
                    },
                    {
                        tribeName: 'Organized Village of Grayling (aka Holikachuk)',
                        tribeCode: 'AK020074',
                    },
                    {
                        tribeName: 'Organized Village of Kake',
                        tribeCode: 'AK020090',
                    },
                    {
                        tribeName: 'Organized Village of Kasaan',
                        tribeCode: 'AK020096',
                    },
                    {
                        tribeName: 'Organized Village of Kwethluk',
                        tribeCode: 'AK020115',
                    },
                    {
                        tribeName: 'Organized Village of Saxman',
                        tribeCode: 'AK020187',
                    },
                    {
                        tribeName: 'Orutsararmuit Native Village (aka Bethel)',
                        tribeCode: 'AK020158',
                    },
                    {
                        tribeName: 'Oscarville Traditional Village',
                        tribeCode: 'AK020159',
                    },
                    {
                        tribeName: 'Pascua Yaqui Tribe of Arizona',
                        tribeCode: 'AK020243',
                    },
                    {
                        tribeName: 'Pauloff Harbor Village',
                        tribeCode: 'AK020162',
                    },
                    {
                        tribeName: 'Pedro Bay Village',
                        tribeCode: 'AK020163',
                    },
                    {
                        tribeName: 'Petersburg Indian Association',
                        tribeCode: 'AK020165',
                    },
                    {
                        tribeName: 'Pilot Station Traditional Village',
                        tribeCode: 'AK020167',
                    },
                    {
                        tribeName: 'Platinum Traditional Village',
                        tribeCode: 'AK020169',
                    },
                    {
                        tribeName: 'Portage Creek Village (aka Ohgsenakale)',
                        tribeCode: 'AK020175',
                    },
                    {
                        tribeName: 'Pribilof Islands Aleut Communities of St. Paul & St. George Islands',
                        tribeCode: 'AK020176',
                    },
                    {
                        tribeName: 'Qagan Tayagungin Tribe of Sand Point Village',
                        tribeCode: 'AK020177',
                    },
                    {
                        tribeName: 'Qawalangin Tribe of Unalaska',
                        tribeCode: 'AK020178',
                    },
                    {
                        tribeName: 'Quechan Tribe of the Fort Yuma Indian Reservation (Arizona and California)',
                        tribeCode: 'AK020244',
                    },
                    {
                        tribeName: 'Rampart Village',
                        tribeCode: 'AK020179',
                    },
                    {
                        tribeName:
                            'Saint George Island (See Pribilof Islands Aleut Communities of St. Paul & St. George Islands)',
                        tribeCode: 'AK020182',
                    },
                    {
                        tribeName:
                            'Saint Paul Island (See Pribilof Islands Aleut Communities of St. Paul & St. George Islands)',
                        tribeCode: 'AK020184',
                    },
                    {
                        tribeName: 'Salt River Pima-Maricopa Indian Community of the Salt River Reservation',
                        tribeCode: 'AK020245',
                    },
                    {
                        tribeName: 'San Carlos Apache Tribe of the San Carlos Reservation',
                        tribeCode: 'AK020246',
                    },
                    {
                        tribeName: 'San Juan Southern Paiute Tribe of Arizona',
                        tribeCode: 'AK020247',
                    },
                    {
                        tribeName: 'Seldovia Village Tribe',
                        tribeCode: 'AK020190',
                    },
                    {
                        tribeName: 'Shageluk Native Village',
                        tribeCode: 'AK020191',
                    },
                    {
                        tribeName: 'Sitka Tribe of Alaska',
                        tribeCode: 'AK020195',
                    },
                    {
                        tribeName: 'Skagway Village',
                        tribeCode: 'AK020196',
                    },
                    {
                        tribeName: 'South Naknek Village',
                        tribeCode: 'AK020199',
                    },
                    {
                        tribeName: 'Stebbins Community Association',
                        tribeCode: 'AK020200',
                    },
                    {
                        tribeName: 'Sun\'aq Tribe of Kodiak (formerly the Shoonaq\' Tribe of Kodiak)',  
                        tribeCode: 'AK020203',
                    },
                    {
                        tribeName: 'Takotna Village',
                        tribeCode: 'AK020204',
                    },
                    {
                        tribeName: 'Tangirnaq Native Village (formerly Lesnoi Village)',
                        tribeCode: 'AK020207',
                    },
                    {
                        tribeName: 'Telida Village',
                        tribeCode: 'AK020210',
                    },
                    {
                        tribeName: 'Tohono O\'odham Nation of Arizona',  
                        tribeCode: 'AK020248',
                    },
                    {
                        tribeName: 'Tonto Apache Tribe of Arizona',
                        tribeCode: 'AK020249',
                    },
                    {
                        tribeName: 'Traditional Village of Togiak',
                        tribeCode: 'AK020214',
                    },
                    {
                        tribeName: 'Tuluksak Native Community',
                        tribeCode: 'AK020215',
                    },
                    {
                        tribeName: 'Twin Hills Village',
                        tribeCode: 'AK020218',
                    },
                    {
                        tribeName: 'Ugashik Village',
                        tribeCode: 'AK020220',
                    },
                    {
                        tribeName: 'Umkumiute Native Village',
                        tribeCode: 'AK020221',
                    },
                    {
                        tribeName: 'Village of Alakanuk',
                        tribeCode: 'AK020008',
                    },
                    {
                        tribeName: 'Village of Anaktuvuk Pass',
                        tribeCode: 'AK020014',
                    },
                    {
                        tribeName: 'Village of Aniak',
                        tribeCode: 'AK020017',
                    },
                    {
                        tribeName: 'Village of Atmautluak',
                        tribeCode: 'AK020022',
                    },
                    {
                        tribeName: 'Village of Bill Moore\'s Slough',  
                        tribeCode: 'AK020027',
                    },
                    {
                        tribeName: 'Village of Chefornak',
                        tribeCode: 'AK020035',
                    },
                    {
                        tribeName: 'Village of Clarks Point',
                        tribeCode: 'AK020048',
                    },
                    {
                        tribeName: 'Village of Crooked Creek',
                        tribeCode: 'AK020051',
                    },
                    {
                        tribeName: 'Village of Dot Lake',
                        tribeCode: 'AK020055',
                    },
                    {
                        tribeName: 'Village of Iliamna',
                        tribeCode: 'AK020085',
                    },
                    {
                        tribeName: 'Village of Kalskag',
                        tribeCode: 'AK020092',
                    },
                    {
                        tribeName: 'Village of Kaltag',
                        tribeCode: 'AK020093',
                    },
                    {
                        tribeName: 'Village of Kotlik',
                        tribeCode: 'AK020111',
                    },
                    {
                        tribeName: 'Village of Lower Kalskag',
                        tribeCode: 'AK020121',
                    },
                    {
                        tribeName: 'Village of Ohogamiut',
                        tribeCode: 'AK020156',
                    },
                    {
                        tribeName: 'Village of Old Harbor',
                        tribeCode: 'AK020157',
                    },
                    {
                        tribeName: 'Village of Red Devil',
                        tribeCode: 'AK020180',
                    },
                    {
                        tribeName: 'Village of Salamatoff',
                        tribeCode: 'AK020185',
                    },
                    {
                        tribeName: 'Village of Sleetmute',
                        tribeCode: 'AK020197',
                    },
                    {
                        tribeName: 'Village of Solomon',
                        tribeCode: 'AK020198',
                    },
                    {
                        tribeName: 'Village of Stony River',
                        tribeCode: 'AK020202',
                    },
                    {
                        tribeName: 'Village of Venetie (See Native Village of Venetie Tribal Government)',
                        tribeCode: 'AK020224',
                    },
                    {
                        tribeName: 'Village of Wainwright',
                        tribeCode: 'AK020226',
                    },
                    {
                        tribeName: 'White Mountain Apache Tribe of the Fort Apache Reservation',
                        tribeCode: 'AK020250',
                    },
                    {
                        tribeName: 'Wrangell Cooperative Association',
                        tribeCode: 'AK020229',
                    },
                    {
                        tribeName: 'Yakutat Tlingit Tribe',
                        tribeCode: 'AK020230',
                    },
                    {
                        tribeName: 'Yavapai-Apache Nation of the Camp Verde Indian Reservation',
                        tribeCode: 'AK020251',
                    },
                    {
                        tribeName: 'Yavapai-Prescott Tribe of the Yavapai Reservation',
                        tribeCode: 'AK020252',
                    },
                    {
                        tribeName: 'Yupiit of Andreafski',
                        tribeCode: 'AK020015',
                    },
                ],
            },
            {
                name: 'Arizona',
                code: 'AZ',
                tribes: [
                    {
                        tribeName: 'Ak Chin Indian Community of the Maricopa (Ak Chin) Indian Reservation',
                        tribeCode: 'AZ040591',
                    },
                    {
                        tribeName: 'Cocopah Tribe of Arizona',
                        tribeCode: 'AZ040592',
                    },
                    {
                        tribeName:
                            'Colorado River Indian Tribes of the Colorado River Indian Reservation (Arizona and California)',
                        tribeCode: 'AZ040593',
                    },
                    {
                        tribeName: 'Fort McDowell Yavapai Nation',
                        tribeCode: 'AZ040594',
                    },
                    {
                        tribeName: 'Fort Mojave Indian Tribe (Arizona, California and Nevada)',
                        tribeCode: 'AZ040595',
                    },
                    {
                        tribeName: 'Gila River Indian Community of the Gila River Indian Reservation',
                        tribeCode: 'AZ040596',
                    },
                    {
                        tribeName: 'Havasupai Tribe of the Havasupai Reservation',
                        tribeCode: 'AZ040597',
                    },
                    {
                        tribeName: 'Hopi Tribe of Arizona',
                        tribeCode: 'AZ040598',
                    },
                    {
                        tribeName: 'Hualapai Indian Tribe of the Hualapai Indian Tribe Reservation',
                        tribeCode: 'AZ040599',
                    },
                    {
                        tribeName: 'Kaibab Band of Paiute Indians of the Kaibab Indian Reservation',
                        tribeCode: 'AZ040600',
                    },
                    {
                        tribeName: 'Navajo Nation (Arizona, New Mexico and Utah)',
                        tribeCode: 'AZ040601',
                    },
                    {
                        tribeName: 'Pascua Yaqui Tribe of Arizona',
                        tribeCode: 'AZ040602',
                    },
                    {
                        tribeName: 'Quechan Tribe of the Fort Yuma Indian Reservation (Arizona and California)',
                        tribeCode: 'AZ040603',
                    },
                    {
                        tribeName: 'Salt River Pima-Maricopa Indian Community of the Salt River Reservation',
                        tribeCode: 'AZ040604',
                    },
                    {
                        tribeName: 'San Carlos Apache Tribe of the San Carlos Reservation',
                        tribeCode: 'AZ040605',
                    },
                    {
                        tribeName: 'San Juan Southern Paiute Tribe of Arizona',
                        tribeCode: 'AZ040606',
                    },
                    {
                        tribeName: 'Tohono O\'odham Nation of Arizona',  
                        tribeCode: 'AZ040607',
                    },
                    {
                        tribeName: 'Tonto Apache Tribe of Arizona',
                        tribeCode: 'AZ040608',
                    },
                    {
                        tribeName: 'White Mountain Apache Tribe of the Fort Apache Reservation',
                        tribeCode: 'AZ040609',
                    },
                    {
                        tribeName: 'Yavapai-Apache Nation of the Camp Verde Indian Reservation',
                        tribeCode: 'AZ040610',
                    },
                    {
                        tribeName: 'Yavapai-Prescott Tribe of the Yavapai Reservation',
                        tribeCode: 'AZ040611',
                    },
                ],
            },
            {
                name: 'California',
                code: 'CA',
                tribes: [
                    {
                        tribeName: 'Agua Caliente Band of Cahuilla Indians of the Agua Caliente Indian Reservation',
                        tribeCode: 'CA060253',
                    },
                    {
                        tribeName: 'Alturas Indian Rancheria',
                        tribeCode: 'CA060254',
                    },
                    {
                        tribeName:
                            'Augustine Band of Cahuilla Indians (formerly the Augustine Band of Cahuilla Mission Indians of the Augustine Reservation)',
                        tribeCode: 'CA060255',
                    },
                    {
                        tribeName: 'Barona Group of Capitan Grande Band of Mission Indians of the Barona Reservation',
                        tribeCode: 'CA060272',
                    },
                    {
                        tribeName: 'Bear River Band of the Rohnerville Rancheria',
                        tribeCode: 'CA060256',
                    },
                    {
                        tribeName: 'Berry Creek Rancheria of Maidu Indians of California',
                        tribeCode: 'CA060257',
                    },
                    {
                        tribeName: 'Big Lagoon Rancheria',
                        tribeCode: 'CA060258',
                    },
                    {
                        tribeName: 'Big Pine Band of Owens Valley Paiute Shoshone Indians of the Big Pine Reservation',
                        tribeCode: 'CA060259',
                    },
                    {
                        tribeName: 'Big Sandy Rancheria of Mono Indians of California',
                        tribeCode: 'CA060260',
                    },
                    {
                        tribeName: 'Big Valley Band of Pomo Indians of the Big Valley Rancheria',
                        tribeCode: 'CA060261',
                    },
                    {
                        tribeName: 'Blue Lake Rancheria',
                        tribeCode: 'CA060262',
                    },
                    {
                        tribeName: 'Bridgeport Paiute Indian Colony of California',
                        tribeCode: 'CA060263',
                    },
                    {
                        tribeName: 'Buena Vista Rancheria of Me-Wuk Indians of California',
                        tribeCode: 'CA060264',
                    },
                    {
                        tribeName: 'Cabazon Band of  Mission Indians',
                        tribeCode: 'CA060265',
                    },
                    {
                        tribeName:
                            'Cachil DeHe Band of Wintun Indians of the Colusa Indian Community of the Colusa Rancheria',
                        tribeCode: 'CA060266',
                    },
                    {
                        tribeName: 'Cahto Indian Tribe of the Laytonville Rancheria',
                        tribeCode: 'CA060268',
                    },
                    {
                        tribeName: 'Cahuilla Band of Mission Indians of the Cahuilla Reservation',
                        tribeCode: 'CA060267',
                    },
                    {
                        tribeName:
                            'California Valley Miwok Tribe (formerly the Sheep Ranch Rancheria of Me-Wuk Indians of California)',
                        tribeCode: 'CA060269',
                    },
                    {
                        tribeName: 'Campo Band of Diegueño Mission Indians of the Campo Indian Reservation',
                        tribeCode: 'CA060270',
                    },
                    {
                        tribeName: 'Capitan Grande Band of Diegueño Mission Indians of California:',
                        tribeCode: 'CA060271',
                    },
                    {
                        tribeName: 'Cedarville Rancheria',
                        tribeCode: 'CA060364',
                    },
                    {
                        tribeName: 'Chemehuevi Indian Tribe of the Chemehuevi Reservation',
                        tribeCode: 'CA060274',
                    },
                    {
                        tribeName: 'Cher-Ae Heights Indian Community of the Trinidad Rancheria',
                        tribeCode: 'CA060275',
                    },
                    {
                        tribeName: 'Chicken Ranch Rancheria of Me-Wuk Indians of California',
                        tribeCode: 'CA060276',
                    },
                    {
                        tribeName: 'Cloverdale Rancheria of Pomo Indians of California',
                        tribeCode: 'CA060277',
                    },
                    {
                        tribeName: 'Cold Springs Rancheria of Mono Indians of California',
                        tribeCode: 'CA060278',
                    },
                    {
                        tribeName:
                            'Colorado River Indian Tribes of the Colorado River Indian Reservation (california and California)',
                        tribeCode: 'CA060279',
                    },
                    {
                        tribeName: 'Cortina Indian Rancheria of Wintun Indians of California',
                        tribeCode: 'CA060280',
                    },
                    {
                        tribeName: 'Coyote Valley Band of Pomo Indians of California',
                        tribeCode: 'CA060281',
                    },
                    {
                        tribeName: 'Death Valley Timbi-Sha Shoshone Band of California',
                        tribeCode: 'CA060282',
                    },
                    {
                        tribeName: 'Dry Creek Rancheria of Pomo Indians of California',
                        tribeCode: 'CA060283',
                    },
                    {
                        tribeName: 'Elem Indian Colony of Pomo Indians of the Sulphur Bank Rancheria',
                        tribeCode: 'CA060284',
                    },
                    {
                        tribeName: 'Elk Valley Rancheria',
                        tribeCode: 'CA060285',
                    },
                    {
                        tribeName: 'Enterprise Rancheria of Maidu Indians of California',
                        tribeCode: 'CA060286',
                    },
                    {
                        tribeName: 'Ewiiaapaayp Band of Kumeyaay Indians',
                        tribeCode: 'CA060287',
                    },
                    {
                        tribeName: 'Federated Indians of Graton Rancheria',
                        tribeCode: 'CA060288',
                    },
                    {
                        tribeName: 'Fort Bidwell Indian Community of the Fort Bidwell Reservation of California',
                        tribeCode: 'CA060289',
                    },
                    {
                        tribeName:
                            'Fort Independence Indian Community of Paiute Indians of the Fort Independence Reservation',
                        tribeCode: 'CA060290',
                    },
                    {
                        tribeName: 'Fort Mojave Indian Tribe (california, California and Nevada)',
                        tribeCode: 'CA060291',
                    },
                    {
                        tribeName: 'Greenville Rancheria of Maidu Indians of California',
                        tribeCode: 'CA060292',
                    },
                    {
                        tribeName: 'Grindstone Indian Rancheria of Wintun-Wailaki Indians of California',
                        tribeCode: 'CA060293',
                    },
                    {
                        tribeName: 'Guidiville Rancheria of California',
                        tribeCode: 'CA060294',
                    },
                    {
                        tribeName:
                            'Habematolel Pomo of Upper Lake (formerly the Upper Lake Band of Pomo Indians of Upper Lake Rancheria of California)',
                        tribeCode: 'CA060295',
                    },
                    {
                        tribeName: 'Hoopa Valley Tribe',
                        tribeCode: 'CA060296',
                    },
                    {
                        tribeName: 'Hopland Band of Pomo Indians of the Hopland Rancheria',
                        tribeCode: 'CA060297',
                    },
                    {
                        tribeName: 'Inaja Band of Diegueño Mission Indians of the Inaja and Cosmit Reservation',
                        tribeCode: 'CA060298',
                    },
                    {
                        tribeName: 'Ione Band of Miwok Indians of California',
                        tribeCode: 'CA060299',
                    },
                    {
                        tribeName: 'Jackson Rancheria of Me-Wuk Indians of  California',
                        tribeCode: 'CA060300',
                    },
                    {
                        tribeName: 'Jamul Indian Village of California',
                        tribeCode: 'CA060301',
                    },
                    {
                        tribeName: 'Karuk Tribe of California',
                        tribeCode: 'CA060302',
                    },
                    {
                        tribeName: 'Kashia Band of Pomo Indians of the Stewart\'s Point Rancheria',  
                        tribeCode: 'CA060303',
                    },
                    {
                        tribeName: 'Koi Nation of Northern California',
                        tribeCode: 'CA060365',
                    },
                    {
                        tribeName: 'La Jolla Band of Luiseño Mission Indians of the La Jolla Reservation',
                        tribeCode: 'CA060304',
                    },
                    {
                        tribeName: 'La Posta Band of Diegueño Mission Indians of the La Posta Indian Reservation',
                        tribeCode: 'CA060305',
                    },
                    {
                        tribeName: 'Lipay Nation of Santa Ysebel',
                        tribeCode: 'CA060366',
                    },
                    {
                        tribeName: 'Los Coyotes Band of Cahuilla & Cupeno Indians of the Los Coyotes Reservation',
                        tribeCode: 'CA060306',
                    },
                    {
                        tribeName: 'Lower Lake Rancheria',
                        tribeCode: 'CA060307',
                    },
                    {
                        tribeName: 'Lytton Rancheria of California',
                        tribeCode: 'CA060308',
                    },
                    {
                        tribeName: 'Manchester Band of Pomo Indians of the Manchester-Point Arena Rancheria',
                        tribeCode: 'CA060309',
                    },
                    {
                        tribeName: 'Manzanita Band of Diegueño Mission Indians of the Manzanita Reservation',
                        tribeCode: 'CA060310',
                    },
                    {
                        tribeName: 'Mechoopda Indian Tribe of Chico Rancheria',
                        tribeCode: 'CA060311',
                    },
                    {
                        tribeName: 'Mesa Grande Band of Diegueño Mission Indians of the Mesa Grande Reservation',
                        tribeCode: 'CA060312',
                    },
                    {
                        tribeName: 'Middletown Rancheria of Pomo Indians of California',
                        tribeCode: 'CA060313',
                    },
                    {
                        tribeName: 'Mooretown Rancheria of Maidu Indians of California',
                        tribeCode: 'CA060314',
                    },
                    {
                        tribeName: 'Morongo Band of Cahuilla Mission Indians of the Morongo Reservation',
                        tribeCode: 'CA060315',
                    },
                    {
                        tribeName: 'Northfork Rancheria of Mono Indians of California',
                        tribeCode: 'CA060316',
                    },
                    {
                        tribeName: 'Paiute-Shoshone Indians of the Bishop Community of the Bishop Colony',
                        tribeCode: 'CA060317',
                    },
                    {
                        tribeName: 'Paiute-Shoshone Indians of the Lone Pine Community of the Lone Pine Reservation',
                        tribeCode: 'CA060318',
                    },
                    {
                        tribeName: 'Pala Band of Luiseño Mission Indians of the Pala Reservation',
                        tribeCode: 'CA060319',
                    },
                    {
                        tribeName: 'Paskenta Band of Nomlaki Indians of California',
                        tribeCode: 'CA060320',
                    },
                    {
                        tribeName: 'Pauma Band of Luiseño Mission Indians of the Pauma & Yuima Reservation',
                        tribeCode: 'CA060321',
                    },
                    {
                        tribeName: 'Pechanga Band of Luiseño Mission Indians of the Pechanga Reservation',
                        tribeCode: 'CA060322',
                    },
                    {
                        tribeName: 'Picayune Rancheria of Chukchansi Indians of California',
                        tribeCode: 'CA060323',
                    },
                    {
                        tribeName:
                            'Pinoleville Pomo Nation (formerly the Pinoleville Rancheria of Pomo Indians of California)',
                        tribeCode: 'CA060324',
                    },
                    {
                        tribeName:
                            'Pit River Tribe (includes XL Ranch, Big Bend, Likely, Lookout, Montgomery Creek and Roaring Creek Rancherias)',
                        tribeCode: 'CA060325',
                    },
                    {
                        tribeName:
                            'Potter Valley Tribe (formerly the Potter Valley Rancheria of Pomo Indians of California)',
                        tribeCode: 'CA060326',
                    },
                    {
                        tribeName: 'Quartz Valley Indian Community of the Quartz Valley Reservation of California',
                        tribeCode: 'CA060327',
                    },
                    {
                        tribeName: 'Quechan Tribe of the Fort Yuma Indian Reservation (california and California)',
                        tribeCode: 'CA060328',
                    },
                    {
                        tribeName: 'Ramona Band or Village of Cahuilla Mission Indians of California',
                        tribeCode: 'CA060329',
                    },
                    {
                        tribeName: 'Redding Rancheria',
                        tribeCode: 'CA060330',
                    },
                    {
                        tribeName: 'Redwood Valley Rancheria of Pomo Indians of California',
                        tribeCode: 'CA060331',
                    },
                    {
                        tribeName: 'Resighini Rancheria',
                        tribeCode: 'CA060332',
                    },
                    {
                        tribeName: 'Rincon Band of Luiseño Mission Indians of the Rincon Reservation',
                        tribeCode: 'CA060333',
                    },
                    {
                        tribeName: 'Robinson Rancheria of Pomo Indians of California',
                        tribeCode: 'CA060334',
                    },
                    {
                        tribeName: 'Round Valley Indian Tribes of the Round Valley Reservation',
                        tribeCode: 'CA060335',
                    },
                    {
                        tribeName: 'Rumsey Indian Rancheria of Wintun Indians of California',
                        tribeCode: 'CA060336',
                    },
                    {
                        tribeName: 'San Manual Band of Serrano Mission Indians of the San Maual Reservation',
                        tribeCode: 'CA060337',
                    },
                    {
                        tribeName: 'San Pasqual Band of Diegueño Mission Indians of California',
                        tribeCode: 'CA060338',
                    },
                    {
                        tribeName:
                            'Santa Rosa Band of Cahuilla Indians (formerly the Santa Rosa Band of Cahuilla Mission Indians of the Santa Rosa Reservation)',
                        tribeCode: 'CA060340',
                    },
                    {
                        tribeName: 'Santa Rosa Indian Community of the Santa Rosa Rancheria',
                        tribeCode: 'CA060339',
                    },
                    {
                        tribeName: 'Santa Ynez Band of Chumash Mission Indians of the Santa Ynez Reservation',
                        tribeCode: 'CA060341',
                    },
                    {
                        tribeName: 'Santa Ysabel Band of Diegueño Mission Indians of the Santa Ysabel Reservation',
                        tribeCode: 'CA060342',
                    },
                    {
                        tribeName: 'Scotts Valley Band of Pomo Indians of California',
                        tribeCode: 'CA060343',
                    },
                    {
                        tribeName: 'Sheep Ranch Rancheria of Me-Wuk Indians',
                        tribeCode: 'CA060344',
                    },
                    {
                        tribeName: 'Sherwood Valley Rancheria of Pomo Indians of California',
                        tribeCode: 'CA060345',
                    },
                    {
                        tribeName: 'Shingle Springs Band of Miwok Indians, Shingle Springs Rancheria (Verona Tract)',
                        tribeCode: 'CA060346',
                    },
                    {
                        tribeName: 'Smith River Rancheria',
                        tribeCode: 'CA060347',
                    },
                    {
                        tribeName: 'Soboba Band of Luiseño Indians',
                        tribeCode: 'CA060348',
                    },
                    {
                        tribeName: 'Susanville Indian Rancheria',
                        tribeCode: 'CA060349',
                    },
                    {
                        tribeName:
                            'Sycuan Band of the Kumeyaay Nation (formerly the Sycuan Band of Diegueno Mission Indians of California)',
                        tribeCode: 'CA060350',
                    },
                    {
                        tribeName: 'Table Bluff Reservation-Wiyot Tribe',
                        tribeCode: 'CA060351',
                    },
                    {
                        tribeName: 'Table Mountain Rancheria of California',
                        tribeCode: 'CA060352',
                    },
                    {
                        tribeName: 'Tejon Indian Tribe',
                        tribeCode: 'CA060367',
                    },
                    {
                        tribeName: 'Tolowa Dee-nl\' Nation',  
                        tribeCode: 'CA060368',
                    },
                    {
                        tribeName:
                            'Torres-Martinez Desert Cahuilla Indians (formerly the Torres-Martinez Band of Cahuilla Mission Indians of California)',
                        tribeCode: 'CA060353',
                    },
                    {
                        tribeName: 'Tule River Indian Tribe of the Tule River Reservation',
                        tribeCode: 'CA060354',
                    },
                    {
                        tribeName: 'Tuolumne Band of Me-Wuk Indians of the Tuolumne Rancheria of California',
                        tribeCode: 'CA060355',
                    },
                    {
                        tribeName: 'Twenty-Nine Palms Band of Mission Indians of California',
                        tribeCode: 'CA060356',
                    },
                    {
                        tribeName: 'United Auburn Indian Community of the Auburn Rancheria of California',
                        tribeCode: 'CA060357',
                    },
                    {
                        tribeName: 'Upper Lake Band of Pomo Indians',
                        tribeCode: 'CA060358',
                    },
                    {
                        tribeName: 'Utu Utu Gwaitu Paiute Tribe of the Benton Paiute Reservation',
                        tribeCode: 'CA060359',
                    },
                    {
                        tribeName:
                            'Viejas (Baron Long) Group of Capitan Grande Band of Mission Indians of the Viejas Reservation Cedarville Rancheria',
                        tribeCode: 'CA060273',
                    },
                    {
                        tribeName:
                            'Washoe Tribe (Carson Colony, Dresslerville Colony, Woodfords Community, Stewart Community and Washoe Ranches) (California and Nevada)',
                        tribeCode: 'CA060360',
                    },
                    {
                        tribeName: 'Wilton Rancheria',
                        tribeCode: 'CA060361',
                    },
                    {
                        tribeName: 'Wiyot Tribe (formerly the Table Bluff Reservation-Wiyot Tribe)',
                        tribeCode: 'CA060362',
                    },
                    {
                        tribeName: 'Yocha Dehe Wintun Nation',
                        tribeCode: 'CA060369',
                    },
                    {
                        tribeName: 'Yurok Tribe of the Yurok Reservation',
                        tribeCode: 'CA060363',
                    },
                ],
            },
            {
                name: 'Colorado',
                code: 'CO',
                tribes: [
                    {
                        tribeName: 'Southern Ute Indian Tribe of the Southern Ute Reservation',
                        tribeCode: 'CO080364',
                    },
                    {
                        tribeName: 'Ute Mountain Tribe of the Ute Mountain Reservation (Colorado, New Mexico and Utah)',
                        tribeCode: 'CO080365',
                    },
                ],
            },
            {
                name: 'Connecticut',
                code: 'CT',
                tribes: [
                    {
                        tribeName: 'Mashantucket Pequot Tribe of Connecticut',
                        tribeCode: 'CT090366',
                    },
                    {
                        tribeName: 'Mohegan Indian Tribe of Connecticut',
                        tribeCode: 'CT090367',
                    },
                ],
            },
            {
                name: 'Florida',
                code: 'FL',
                tribes: [
                    {
                        tribeName: 'Miccosukee Tribe of Indians of Florida',
                        tribeCode: 'FL120368',
                    },
                    {
                        tribeName:
                            'Seminole Tribe of Florida (Dania, Big Cypress, Brighton, Hollywood and Tampa Reservations)',
                        tribeCode: 'FL120369',
                    },
                ],
            },
            {
                name: 'Idaho',
                code: 'ID',
                tribes: [
                    {
                        tribeName: 'Coeur D\'Alene Tribe of the Coeur D\'Alene Reservation',  
                        tribeCode: 'ID160370',
                    },
                    {
                        tribeName: 'Kootenai Tribe of Idaho',
                        tribeCode: 'ID160371',
                    },
                    {
                        tribeName: 'Nez Perce Tribe of Idaho',
                        tribeCode: 'ID160372',
                    },
                    {
                        tribeName: 'Shoshone-Bannock Tribes of the Fort Hall Reservation of Idaho',
                        tribeCode: 'ID160373',
                    },
                    {
                        tribeName: 'Shoshone-Paiute Tribes of the Duck Valley Reservation',
                        tribeCode: 'NV320435',
                    },
                ],
            },
            {
                name: 'Indiana',
                code: 'IN',
                tribes: [
                    {
                        tribeName: 'Pokagon Band of Potawatomi Indians (Michigan and Indiana)',
                        tribeCode: 'IN000001',
                    },
                ],
            },
            {
                name: 'Iowa',
                code: 'IA',
                tribes: [
                    {
                        tribeName: 'Sac & Fox Tribe of the Mississippi in Iowa',
                        tribeCode: 'IA190374',
                    },
                ],
            },
            {
                name: 'Kansas',
                code: 'KS',
                tribes: [
                    {
                        tribeName: 'Iowa Tribe (Kansas and Nebraska)',
                        tribeCode: 'KS200375',
                    },
                    {
                        tribeName: 'Kickapoo Tribe of Indians of the Kickapoo Reservation in Kansas',
                        tribeCode: 'KS200376',
                    },
                    {
                        tribeName: 'Prairie Band of Potawatomi Nation',
                        tribeCode: 'KS200377',
                    },
                    {
                        tribeName: 'Sac and Fox Nation of Missouri (Kansas and Nebraska)',
                        tribeCode: 'KS200378',
                    },
                ],
            },
            {
                name: 'Louisiana',
                code: 'LA',
                tribes: [
                    {
                        tribeName: 'Chitimacha Tribe of Louisiana',
                        tribeCode: 'LA220379',
                    },
                    {
                        tribeName: 'Coushatta Tribe of Louisiana',
                        tribeCode: 'LA220380',
                    },
                    {
                        tribeName: 'Jena Band of Choctaw Indians',
                        tribeCode: 'LA220381',
                    },
                    {
                        tribeName: 'Tunica-Biloxi Indian Tribe of Louisiana',
                        tribeCode: 'LA220382',
                    },
                ],
            },
            {
                name: 'Maine',
                code: 'ME',
                tribes: [
                    {
                        tribeName: 'Aroostook Band of Micmac Indians',
                        tribeCode: 'ME230383',
                    },
                    {
                        tribeName: 'Houlton Band of Maliseet Indians of Maine',
                        tribeCode: 'ME230384',
                    },
                    {
                        tribeName: 'Passamaquoddy Tribe of Maine',
                        tribeCode: 'ME230385',
                    },
                    {
                        tribeName: 'Penobscot Tribe of Maine',
                        tribeCode: 'ME230386',
                    },
                ],
            },
            {
                name: 'Massachusetts',
                code: 'MA',
                tribes: [
                    {
                        tribeName: 'Mashpee Wampanoag Indian Tribal Council',
                        tribeCode: 'MA250387',
                    },
                    {
                        tribeName: 'Wampanoag Tribe of Gay Head (Aquinnah) of Massachusetts',
                        tribeCode: 'MA250388',
                    },
                ],
            },
            {
                name: 'Michigan',
                code: 'MI',
                tribes: [
                    {
                        tribeName: 'Bay Mills Indian Community of the Sault Ste. Marie Band of Chippewa Indians',
                        tribeCode: 'MI260389',
                    },
                    {
                        tribeName: 'Grand Traverse Band of Ottawa and Chippewa Indians',
                        tribeCode: 'MI260390',
                    },
                    {
                        tribeName: 'Hannahville Indian Community',
                        tribeCode: 'MI260391',
                    },
                    {
                        tribeName: 'Huron Potawatomi, Inc.',
                        tribeCode: 'MI260392',
                    },
                    {
                        tribeName: 'Keweenaw Bay Indian Community',
                        tribeCode: 'MI260393',
                    },
                    {
                        tribeName: 'Lac Vieux Desert Band of Lake Superior Chippewa Indians',
                        tribeCode: 'MI260394',
                    },
                    {
                        tribeName: 'Little River Band of Ottawa Indians',
                        tribeCode: 'MI260395',
                    },
                    {
                        tribeName: 'Little Traverse Bay Bands of Odawa Indians',
                        tribeCode: 'MI260396',
                    },
                    {
                        tribeName: 'Match-e-be-nash-she-wish Band of Pottawatomi Indians of Michigan',
                        tribeCode: 'MI260397',
                    },
                    {
                        tribeName: 'Pokagon Band of Potawatomi Indians (Michigan and Indiana)',
                        tribeCode: 'MI260398',
                    },
                    {
                        tribeName: 'Saginaw Chippewa Indian Tribe of Michigan',
                        tribeCode: 'MI260399',
                    },
                    {
                        tribeName: 'Sault Ste. Marie Tribe of Chippewa Indians of Michigan',
                        tribeCode: 'MI260400',
                    },
                ],
            },
            {
                name: 'Minnesota',
                code: 'MN',
                tribes: [
                    {
                        tribeName:
                            'Fond du Lac Band; Grand Portage Band; Leech Lake Band; Mille Lacs Ban; White Earth Band)',
                        tribeCode: 'MN270404',
                    },
                    {
                        tribeName: 'Lower Sioux Indian Community in the State of Minnesota',
                        tribeCode: 'MN270401',
                    },
                    {
                        tribeName: 'Mdewakanton Sioux Indians',
                        tribeCode: 'MN270402',
                    },
                    {
                        tribeName: 'Mdewakanton Sioux Indians',
                        tribeCode: 'MN270406',
                    },
                    {
                        tribeName: 'Minnesota Chippewa Tribe (Six component reservations: Bois Forte Band (Nett Lake);',
                        tribeCode: 'MN270403',
                    },
                    {
                        tribeName: 'Prairie Island Indian Community in the State of Minnesota',
                        tribeCode: 'MN270405',
                    },
                    {
                        tribeName: 'Red Lake Band of Chippewa Indians',
                        tribeCode: 'MN270407',
                    },
                    {
                        tribeName: 'Shakopee Mdewakanton Sioux Community of Minnesota',
                        tribeCode: 'MN270408',
                    },
                    {
                        tribeName: 'Upper Sioux Community',
                        tribeCode: 'MN270409',
                    },
                ],
            },
            {
                name: 'Mississippi',
                code: 'MS',
                tribes: [
                    {
                        tribeName: 'Mississippi Band of Choctaw Indians',
                        tribeCode: 'MS280410',
                    },
                ],
            },
            {
                name: 'Montana',
                code: 'MT',
                tribes: [
                    {
                        tribeName: 'Assiniboine and Sioux Tribes of the Fort Peck Indian Reservation',
                        tribeCode: 'MT300411',
                    },
                    {
                        tribeName: 'Blackfeet Tribe of the Blackfeet Indian Reservation of Montana',
                        tribeCode: 'MT300412',
                    },
                    {
                        tribeName: 'Chippewa-Cree Indians of the Rocky Boy\'s Reservation',  
                        tribeCode: 'MT300413',
                    },
                    {
                        tribeName: 'Confederated Salish and Kootenai Tribes of the Flathead Reservation',
                        tribeCode: 'MT300414',
                    },
                    {
                        tribeName: 'Crow Tribe of Montana',
                        tribeCode: 'MT300415',
                    },
                    {
                        tribeName: 'Fort Belknap Indian Community of the Fort Belknap Reservation of Montana',
                        tribeCode: 'MT300416',
                    },
                    {
                        tribeName: 'Northern Cheyenne Tribe of the Northern Cheyenne Indian Reservation',
                        tribeCode: 'MT300417',
                    },
                ],
            },
            {
                name: 'Nebraska',
                code: 'NE',
                tribes: [
                    {
                        tribeName: 'Iowa Tribe (Kansas and Nebraska)',
                        tribeCode: 'NE310418',
                    },
                    {
                        tribeName: 'Omaha Tribe of Nebraska',
                        tribeCode: 'NE310419',
                    },
                    {
                        tribeName: 'Ponca Tribe of Nebraska',
                        tribeCode: 'NE310420',
                    },
                    {
                        tribeName: 'Sac and Fox Nation of Missouri (Kansas and Nebraska)',
                        tribeCode: 'NE310421',
                    },
                    {
                        tribeName: 'Santee Sioux Nation',
                        tribeCode: 'NE310422',
                    },
                    {
                        tribeName: 'Winnebago Tribe of Nebraska',
                        tribeCode: 'NE310423',
                    },
                ],
            },
            {
                name: 'Nevada',
                code: 'NV',
                tribes: [
                    {
                        tribeName: 'Confederated Tribes of the Goshute Reservation (Nevada and Utah)',
                        tribeCode: 'NV320424',
                    },
                    {
                        tribeName: 'Duckwater Shoshone Tribe of the Duckwater Reservation',
                        tribeCode: 'NV320425',
                    },
                    {
                        tribeName: 'Ely Shoshone Tribe of Nevada',
                        tribeCode: 'NV320426',
                    },
                    {
                        tribeName:
                            'Fort McDermitt Paiute and Shoshone Tribes of the Fort McDermitt Indian Reservation (Nevada and Oregon)',
                        tribeCode: 'NV320427',
                    },
                    {
                        tribeName: 'Fort Mojave Indian Tribe (Arizona, California and Nevada)',
                        tribeCode: 'NV320428',
                    },
                    {
                        tribeName: 'Las Vegas Tribe of Paiute Indians of the Las Vegas Indian Colony',
                        tribeCode: 'NV320429',
                    },
                    {
                        tribeName: 'Lovelock Paiute Tribe of the Lovelock Indian Colony',
                        tribeCode: 'NV320430',
                    },
                    {
                        tribeName: 'Moapa Band of Paiute Indians of the Moapa River Indian Reservation',
                        tribeCode: 'NV320431',
                    },
                    {
                        tribeName: 'Paiute-Shoshone Tribe of the Fallon Reservation and Colony',
                        tribeCode: 'NV320432',
                    },
                    {
                        tribeName: 'Pyramid Lake Paiute Tribe of the Pyramid Lake Reservation',
                        tribeCode: 'NV320433',
                    },
                    {
                        tribeName: 'Reno-Sparks Indian Colony',
                        tribeCode: 'NV320434',
                    },
                    {
                        tribeName: 'Shoshone-Paiute Tribes of the Duck Valley Reservation',
                        tribeCode: 'NV320435',
                    },
                    {
                        tribeName: 'Summit Lake Paiute Tribe of Nevada',
                        tribeCode: 'NV320436',
                    },
                    {
                        tribeName:
                            'Te-Moak Tribe of Western Shoshone Indians of Nevada (Four constituent bands: Battle Mountain Band; Elko Band; South Fork Band; Wells Band)',
                        tribeCode: 'NV320437',
                    },
                    {
                        tribeName: 'Walker River Paiute Tribe of the Walker River Reservation',
                        tribeCode: 'NV320438',
                    },
                    {
                        tribeName:
                            'Washoe Tribe (Nevada and California) (Carson Colony, Dresslerville Colony, Woodfords Community, Stewart Community and Washoe Ranches)',
                        tribeCode: 'NV320439',
                    },
                    {
                        tribeName: 'Winnemucca Indian Colony of Nevada',
                        tribeCode: 'NV320440',
                    },
                    {
                        tribeName: 'Yerington Paiute Tribe of the Yerington Colony & Campbell Ranch',
                        tribeCode: 'NV320441',
                    },
                    {
                        tribeName: 'Yomba Shoshone Tribe of the Yomba Reservation',
                        tribeCode: 'NV320442',
                    },
                ],
            },
            {
                name: 'New Mexico',
                code: 'NM',
                tribes: [
                    {
                        tribeName: 'Jicarilla Apache Nation',
                        tribeCode: 'NM350443',
                    },
                    {
                        tribeName: 'Kewa Pueblo',
                        tribeCode: 'NM350466',
                    },
                    {
                        tribeName: 'Mescalero Apache Tribe of the Mescalero Reservation',
                        tribeCode: 'NM350444',
                    },
                    {
                        tribeName: 'Navajo Nation (Arizona, New Mexico and Utah)',
                        tribeCode: 'NM350445',
                    },
                    {
                        tribeName: 'Ohkay Owingeh (formerly the Pueblo of San Juan)',
                        tribeCode: 'NM350446',
                    },
                    {
                        tribeName: 'Pueblo of Acoma',
                        tribeCode: 'NM350447',
                    },
                    {
                        tribeName: 'Pueblo of Cochiti',
                        tribeCode: 'NM350448',
                    },
                    {
                        tribeName: 'Pueblo of Isleta',
                        tribeCode: 'NM350450',
                    },
                    {
                        tribeName: 'Pueblo of Jemez',
                        tribeCode: 'NM350449',
                    },
                    {
                        tribeName: 'Pueblo of Laguna',
                        tribeCode: 'NM350451',
                    },
                    {
                        tribeName: 'Pueblo of Nambe',
                        tribeCode: 'NM350452',
                    },
                    {
                        tribeName: 'Pueblo of Picuris',
                        tribeCode: 'NM350453',
                    },
                    {
                        tribeName: 'Pueblo of Pojoaque',
                        tribeCode: 'NM350454',
                    },
                    {
                        tribeName: 'Pueblo of San Felipe',
                        tribeCode: 'NM350455',
                    },
                    {
                        tribeName: 'Pueblo of San Ildefonso',
                        tribeCode: 'NM350456',
                    },
                    {
                        tribeName: 'Pueblo of Sandia',
                        tribeCode: 'NM350457',
                    },
                    {
                        tribeName: 'Pueblo of Santa Ana',
                        tribeCode: 'NM350458',
                    },
                    {
                        tribeName: 'Pueblo of Santa Clara',
                        tribeCode: 'NM350459',
                    },
                    {
                        tribeName: 'Pueblo of Santo Domingo',
                        tribeCode: 'NM350460',
                    },
                    {
                        tribeName: 'Pueblo of Taos',
                        tribeCode: 'NM350461',
                    },
                    {
                        tribeName: 'Pueblo of Tesuque',
                        tribeCode: 'NM350462',
                    },
                    {
                        tribeName: 'Pueblo of Zia',
                        tribeCode: 'NM350463',
                    },
                    {
                        tribeName: 'Ute Mountain Tribe of the Ute Mountain Reservation (Colorado, New Mexico and Utah)',
                        tribeCode: 'NM350464',
                    },
                    {
                        tribeName: 'Zuni Tribe of the Zuni Reservation',
                        tribeCode: 'NM350465',
                    },
                ],
            },
            {
                name: 'New York',
                code: 'NY',
                tribes: [
                    {
                        tribeName: 'Cayuga Nation of New York',
                        tribeCode: 'NY360466',
                    },
                    {
                        tribeName: 'Oneida Nation of New York',
                        tribeCode: 'NY360467',
                    },
                    {
                        tribeName: 'Onondaga Nation of New York',
                        tribeCode: 'NY360468',
                    },
                    {
                        tribeName:
                            'Saint Regis Mohawk Tribe (formerly the St. Regis Band of Mohawk Indians of New York)',
                        tribeCode: 'NY360469',
                    },
                    {
                        tribeName: 'Seneca Nation of New York',
                        tribeCode: 'NY360470',
                    },
                    {
                        tribeName: 'Shinnecock Indian Nation',
                        tribeCode: 'NY360471',
                    },
                    {
                        tribeName: 'Tonawanda Band of Seneca Indians of New York',
                        tribeCode: 'NY360472',
                    },
                    {
                        tribeName: 'Tuscarora Nation of New York',
                        tribeCode: 'NY360473',
                    },
                ],
            },
            {
                name: 'North Carolina',
                code: 'NC',
                tribes: [
                    {
                        tribeName: 'Eastern Band of Cherokee Indians of North Carolina',
                        tribeCode: 'NC370474',
                    },
                ],
            },
            {
                name: 'North Dakota',
                code: 'ND',
                tribes: [
                    {
                        tribeName: 'Spirit Lake Tribe',
                        tribeCode: 'ND380475',
                    },
                    {
                        tribeName: 'Standing Rock Sioux Tribe (North Dakota and South Dakota)',
                        tribeCode: 'ND380476',
                    },
                    {
                        tribeName: 'Three Affiliated Tribes of the Fort Berthold Reservation',
                        tribeCode: 'ND380477',
                    },
                    {
                        tribeName: 'Turtle Mountain Band of Chippewa Indians of North Dakota',
                        tribeCode: 'ND380478',
                    },
                ],
            },
            {
                name: 'Oklahoma',
                code: 'OK',
                tribes: [
                    {
                        tribeName: 'Absentee-Shawnee Tribe of Indians',
                        tribeCode: 'OK400479',
                    },
                    {
                        tribeName: 'Alabama-Quassarte Tribal Town',
                        tribeCode: 'OK400480',
                    },
                    {
                        tribeName: 'Apache Tribe',
                        tribeCode: 'OK400481',
                    },
                    {
                        tribeName: 'Caddo Nation of Oklahoma',
                        tribeCode: 'OK400482',
                    },
                    {
                        tribeName: 'Cherokee Nation',
                        tribeCode: 'OK400483',
                    },
                    {
                        tribeName: 'Cheyenne-Arapaho Tribes',
                        tribeCode: 'OK400484',
                    },
                    {
                        tribeName: 'Chickasaw Nation',
                        tribeCode: 'OK400485',
                    },
                    {
                        tribeName: 'Choctaw Nation of Oklahoma',
                        tribeCode: 'OK400486',
                    },
                    {
                        tribeName: 'Citizen Potawatomi Nation',
                        tribeCode: 'OK400487',
                    },
                    {
                        tribeName: 'Comanche Nation',
                        tribeCode: 'OK400488',
                    },
                    {
                        tribeName: 'Delaware Nation',
                        tribeCode: 'OK400489',
                    },
                    {
                        tribeName: 'Delaware Tribe of Indians',
                        tribeCode: 'OK400490',
                    },
                    {
                        tribeName: 'Eastern Shawnee Tribe of Oklahoma',
                        tribeCode: 'OK400491',
                    },
                    {
                        tribeName: 'Fort Sill Apache Tribe of Oklahoma',
                        tribeCode: 'OK400492',
                    },
                    {
                        tribeName: 'Iowa Tribe of Oklahoma',
                        tribeCode: 'OK400493',
                    },
                    {
                        tribeName: 'Kaw Nation',
                        tribeCode: 'OK400494',
                    },
                    {
                        tribeName: 'Kialegee Tribal Town',
                        tribeCode: 'OK400495',
                    },
                    {
                        tribeName: 'Kickapoo Tribe of Oklahoma',
                        tribeCode: 'OK400496',
                    },
                    {
                        tribeName: 'Kiowa Indian Tribe of Oklahoma',
                        tribeCode: 'OK400497',
                    },
                    {
                        tribeName: 'Miami Tribe of Oklahoma',
                        tribeCode: 'OK400498',
                    },
                    {
                        tribeName: 'Modoc Tribe of Oklahoma',
                        tribeCode: 'OK400499',
                    },
                    {
                        tribeName: 'Muscogee (Creek) Nation',
                        tribeCode: 'OK400500',
                    },
                    {
                        tribeName: 'Osage Tribe',
                        tribeCode: 'OK400501',
                    },
                    {
                        tribeName: 'Otoe-Missouria Tribe of Indians',
                        tribeCode: 'OK400503',
                    },
                    {
                        tribeName: 'Ottawa Tribe of Oklahoma',
                        tribeCode: 'OK400502',
                    },
                    {
                        tribeName: 'Pawnee Nation of Oklahoma',
                        tribeCode: 'OK400504',
                    },
                    {
                        tribeName: 'Peoria Tribe of Indians of Oklahoma',
                        tribeCode: 'OK400505',
                    },
                    {
                        tribeName: 'Ponca Tribe of Indians of Oklahoma',
                        tribeCode: 'OK400506',
                    },
                    {
                        tribeName: 'Quapaw Tribe of Indians',
                        tribeCode: 'OK400507',
                    },
                    {
                        tribeName: 'Sac & Fox Nation',
                        tribeCode: 'OK400508',
                    },
                    {
                        tribeName: 'Seminole Nation of Oklahoma',
                        tribeCode: 'OK400509',
                    },
                    {
                        tribeName: 'Seneca-Cayuga Tribe of Oklahoma',
                        tribeCode: 'OK400510',
                    },
                    {
                        tribeName: 'Shawnee Tribe',
                        tribeCode: 'OK400511',
                    },
                    {
                        tribeName: 'Thlopthlocco Tribal Town',
                        tribeCode: 'OK400512',
                    },
                    {
                        tribeName: 'Tonkawa Tribe of Indians of Oklahoma',
                        tribeCode: 'OK400513',
                    },
                    {
                        tribeName: 'United Keetoowah Band of Cherokee Indians in Oklahoma',
                        tribeCode: 'OK400514',
                    },
                    {
                        tribeName: 'Wichita and Affiliated Tribes (Wichita, Keechi, Waco and Tawakonie)',
                        tribeCode: 'OK400515',
                    },
                    {
                        tribeName: 'Wyandotte Nation',
                        tribeCode: 'OK400516',
                    },
                ],
            },
            {
                name: 'Oregon',
                code: 'OR',
                tribes: [
                    {
                        tribeName: 'Burns Paiute Tribe',
                        tribeCode: 'OR410517',
                    },
                    {
                        tribeName: 'Confederated Tribes of the Coos, Lower Umpqua and Siuslaw Indians of Oregon',
                        tribeCode: 'OR410518',
                    },
                    {
                        tribeName: 'Confederated Tribes of the Grand Ronde Community of Oregon',
                        tribeCode: 'OR410519',
                    },
                    {
                        tribeName: 'Confederated Tribes of the Siletz Reservation',
                        tribeCode: 'OR410520',
                    },
                    {
                        tribeName: 'Confederated Tribes of the Umatilla Reservation',
                        tribeCode: 'OR410521',
                    },
                    {
                        tribeName: 'Confederated Tribes of the Warm Springs Reservation of Oregon',
                        tribeCode: 'OR410522',
                    },
                    {
                        tribeName: 'Coquille Tribe of Oregon',
                        tribeCode: 'OR410523',
                    },
                    {
                        tribeName: 'Cow Creek Band of Umpqua Indians of Oregon',
                        tribeCode: 'OR410524',
                    },
                    {
                        tribeName:
                            'Fort McDermitt Paiute and Shoshone Tribes of the Fort McDermitt Indian Reservation (Nevada and Oregon)',
                        tribeCode: 'OR410525',
                    },
                    {
                        tribeName: 'Klamath Tribes (formerly the Klamath Indian Tribe of Oregon)',
                        tribeCode: 'OR410526',
                    },
                ],
            },
            {
                name: 'Rhode Island',
                code: 'RI',
                tribes: [
                    {
                        tribeName: 'Narragansett Indian Tribe of Rhode Island',
                        tribeCode: 'RI440527',
                    },
                ],
            },
            {
                name: 'South Carolina',
                code: 'SC',
                tribes: [
                    {
                        tribeName: 'Catawba Indian Nation (Catawba Tribe of South Carolina)',
                        tribeCode: 'SC450528',
                    },
                ],
            },
            {
                name: 'South Dakota',
                code: 'SD',
                tribes: [
                    {
                        tribeName: 'Cheyenne River Sioux Tribe of the Cheyenne River Reservation',
                        tribeCode: 'SD460529',
                    },
                    {
                        tribeName: 'Crow Creek Sioux Tribe of the Crow Creek Reservation',
                        tribeCode: 'SD460530',
                    },
                    {
                        tribeName: 'Flandreau Santee Sioux Tribe of South Dakota',
                        tribeCode: 'SD460531',
                    },
                    {
                        tribeName: 'Lower Brule Sioux Tribe of the Lower Brule Reservation',
                        tribeCode: 'SD460532',
                    },
                    {
                        tribeName: 'Oglala Sioux Tribe of the Pine Ridge Reservation',
                        tribeCode: 'SD460533',
                    },
                    {
                        tribeName: 'Rosebud Sioux Tribe of the Rosebud Indian Reservation',
                        tribeCode: 'SD460534',
                    },
                    {
                        tribeName: 'Sisseton-Wahpeton Oyate of the Lake Traverse Reservation',
                        tribeCode: 'SD460535',
                    },
                    {
                        tribeName: 'Standing Rock Sioux Tribe (North Dakota and South Dakota)',
                        tribeCode: 'SD460536',
                    },
                    {
                        tribeName: 'Yankton Sioux Tribe of South Dakota',
                        tribeCode: 'SD460537',
                    },
                ],
            },
            {
                name: 'Texas',
                code: 'TX',
                tribes: [
                    {
                        tribeName: 'Alabama-Coushatta Tribes',
                        tribeCode: 'TX480538',
                    },
                    {
                        tribeName: 'Kickapoo Traditional Tribe of Texas',
                        tribeCode: 'TX480539',
                    },
                    {
                        tribeName: 'Ysleta Del Sur Pueblo of Texas',
                        tribeCode: 'TX480540',
                    },
                ],
            },
            {
                name: 'Utah',
                code: 'UT',
                tribes: [
                    {
                        tribeName: 'Confederated Tribes of the Goshute Reservation (Nevada and Utah)',
                        tribeCode: 'UT490541',
                    },
                    {
                        tribeName: 'Navajo Nation (Arizona, New Mexico and Utah)',
                        tribeCode: 'UT490542',
                    },
                    {
                        tribeName: 'Northwestern Band of Shoshoni Nation of Utah (Washakie)',
                        tribeCode: 'UT490543',
                    },
                    {
                        tribeName:
                            'Paiute Indian Tribe of Utah  (Cedar City Band of Paiutes, Kanosh Band of Paiutes, Koosharem Band of Paiutes, Indian Peaks Band of Paiutes, and Shivwits Band of Paiutes)',
                        tribeCode: 'UT490544',
                    },
                    {
                        tribeName: 'Skull Valley Band of Goshute Indians of Utah',
                        tribeCode: 'UT490545',
                    },
                    {
                        tribeName: 'Ute Indian Tribe of the Uintah and Ouray Reservation',
                        tribeCode: 'UT490546',
                    },
                    {
                        tribeName: 'Ute Mountain Ute Tribe (Colorado, New Mexico and Utah)',
                        tribeCode: 'UT490547',
                    },
                ],
            },
            {
                name: 'Virginia',
                code: 'VA',
                tribes: [
                    {
                        tribeName: 'Chickahominy Indian Tribe',
                        tribeCode: 'VA000002',
                    },
                    {
                        tribeName: 'Chickahominy Indian Tribe - Eastern Division',
                        tribeCode: 'VA000003',
                    },
                    {
                        tribeName: 'Monacan Indian Nation',
                        tribeCode: 'VA000006',
                    },
                    {
                        tribeName: 'Nansemond Indian Tribe',
                        tribeCode: 'VA000007',
                    },
                    {
                        tribeName: 'Pamunkey Indian Tribe',
                        tribeCode: 'VA000001',
                    },
                    {
                        tribeName: 'Rappahannock Tribe Inc.',
                        tribeCode: 'VA000005',
                    },
                    {
                        tribeName: 'Upper Mattaponi Tribe',
                        tribeCode: 'VA000004',
                    },
                ],
            },
            {
                name: 'Washington',
                code: 'WA',
                tribes: [
                    {
                        tribeName: 'Confederated Tribes and Bands of the Yakama Nation',
                        tribeCode: 'WA530550',
                    },
                    {
                        tribeName: 'Confederated Tribes of the Chehalis Reservation',
                        tribeCode: 'WA530548',
                    },
                    {
                        tribeName: 'Confederated Tribes of the Colville Reservation',
                        tribeCode: 'WA530549',
                    },
                    {
                        tribeName: 'Cowlitz Indian Tribe',
                        tribeCode: 'WA530551',
                    },
                    {
                        tribeName: 'Hoh Indian Tribe of the Hoh Indian Reservation',
                        tribeCode: 'WA530552',
                    },
                    {
                        tribeName: 'Jamestown S\'Klallam Tribe of Washington',  
                        tribeCode: 'WA530553',
                    },
                    {
                        tribeName: 'Kalispel Indian Community of the Kalispel Reservation',
                        tribeCode: 'WA530554',
                    },
                    {
                        tribeName: 'Lower Elwha Tribal Community of the Lower Elwha Reservation',
                        tribeCode: 'WA530555',
                    },
                    {
                        tribeName: 'Lummi Tribe of the Lummi Reservation',
                        tribeCode: 'WA530556',
                    },
                    {
                        tribeName: 'Makah Indian Tribe of the Makah Indian Reservation',
                        tribeCode: 'WA530557',
                    },
                    {
                        tribeName: 'Muckleshoot Indian Tribe of the Muckleshoot Reservation',
                        tribeCode: 'WA530558',
                    },
                    {
                        tribeName: 'Nisqually Indian Tribe of the Nisqually Reservation',
                        tribeCode: 'WA530559',
                    },
                    {
                        tribeName: 'Nooksack Indian Tribe of Washington',
                        tribeCode: 'WA530560',
                    },
                    {
                        tribeName: 'Port Gamble Indian Community of the Port Gamble Reservation',
                        tribeCode: 'WA530561',
                    },
                    {
                        tribeName: 'Puyallup Tribe of the Puyallup Reservation',
                        tribeCode: 'WA530562',
                    },
                    {
                        tribeName: 'Quileute Tribe of the Quileute Reservation',
                        tribeCode: 'WA530563',
                    },
                    {
                        tribeName: 'Quinault Tribe of the Quinault Reservation',
                        tribeCode: 'WA530564',
                    },
                    {
                        tribeName: 'Samish Indian Tribe',
                        tribeCode: 'WA530565',
                    },
                    {
                        tribeName: 'Sauk-Suiattle Indian Tribe of Washington',
                        tribeCode: 'WA530566',
                    },
                    {
                        tribeName: 'Shoalwater Bay Tribe of the Shoalwater Bay Indian Reservation',
                        tribeCode: 'WA530567',
                    },
                    {
                        tribeName: 'Skokomish Indian Tribe of the Skokomish Reservation',
                        tribeCode: 'WA530568',
                    },
                    {
                        tribeName: 'Snoqualmie Tribe',
                        tribeCode: 'WA530569',
                    },
                    {
                        tribeName: 'Spokane Tribe of the Spokane Reservation',
                        tribeCode: 'WA530570',
                    },
                    {
                        tribeName: 'Squaxin Island Tribe of the Squaxin Island Reservation',
                        tribeCode: 'WA530571',
                    },
                    {
                        tribeName: 'Stillaguamish Tribe of Washington',
                        tribeCode: 'WA530572',
                    },
                    {
                        tribeName: 'Suquamish Indian Tribe of the Port Madison Reservation',
                        tribeCode: 'WA530573',
                    },
                    {
                        tribeName: 'Swinomish Indians of the Swinomish Reservation',
                        tribeCode: 'WA530574',
                    },
                    {
                        tribeName: 'Tulalip Tribes of the Tulalip Reservation',
                        tribeCode: 'WA530575',
                    },
                    {
                        tribeName: 'Upper Skagit Indian Tribe of Washington',
                        tribeCode: 'WA530576',
                    },
                ],
            },
            {
                name: 'Wisconsin',
                code: 'WI',
                tribes: [
                    {
                        tribeName: 'Bad River Band of the Lake Superior Tribe of Chippewa Indians',
                        tribeCode: 'WI550577',
                    },
                    {
                        tribeName: 'Forest County Potawatomi Community',
                        tribeCode: 'WI550578',
                    },
                    {
                        tribeName: 'Ho-Chunk Nation of Wisconsin',
                        tribeCode: 'WI550579',
                    },
                    {
                        tribeName: 'Lac Courte Oreilles Band of Lake Superior Chippewa Indians of Wisconsin',
                        tribeCode: 'WI550580',
                    },
                    {
                        tribeName: 'Lac du Flambeau Band of Lake Superior Chippewa Indians of the Lac du Flambeau',
                        tribeCode: 'WI550581',
                    },
                    {
                        tribeName: 'Menominee Indian Tribe of Wisconsin',
                        tribeCode: 'WI550583',
                    },
                    {
                        tribeName: 'Oneida Tribe of Indians of Wisconsin',
                        tribeCode: 'WI550584',
                    },
                    {
                        tribeName: 'Red Cliff Band of Lake Superior Chippewa Indians of Wisconsin',
                        tribeCode: 'WI550585',
                    },
                    {
                        tribeName: 'Reservation of Wisconsin',
                        tribeCode: 'WI550582',
                    },
                    {
                        tribeName: 'Sokaogon Chippewa Community',
                        tribeCode: 'WI550587',
                    },
                    {
                        tribeName: 'St. Croix Chippewa Indians of Wisconsin',
                        tribeCode: 'WI550586',
                    },
                    {
                        tribeName: 'Stockbridge Munsee Community',
                        tribeCode: 'WI550588',
                    },
                ],
            },
            {
                name: 'Wyoming',
                code: 'WY',
                tribes: [
                    {
                        tribeName: 'Arapahoe Tribe of the Wind River Reservation',
                        tribeCode: 'WY560589',
                    },
                    {
                        tribeName: 'Shoshone Tribe of the Wind River Reservation',
                        tribeCode: 'WY560590',
                    },
                ],
            },
        ],
        relations: {
            dropdownOptions: [
                {
                    text: 'Relationship',
                    type: 'RELATION',
                    code: 'default',
                    mirrorType: 'RELATION',
                },
                {
                    text: 'Spouse',
                    type: 'SPOUSE',
                    code: '01',
                    mirrorType: 'SPOUSE',
                },
                {
                    text: 'Child (son or daughter)',
                    type: 'CHILD',
                    code: '19',
                    mirrorType: 'PARENT',
                },
                {
                    text: 'Brother-in-law or Sister-in-law',
                    type: 'BROTHER_OR_SISTER_IN_LAW',
                    code: '12',
                    mirrorType: 'BROTHER_OR_SISTER_IN_LAW',
                },
                {
                    text: 'Court Appointed or Live-In Guardian',
                    type: 'COURT_APPOINTED_GUARDIAN',
                    code: '31',
                    mirrorType: 'WARD',
                },
                {
                    text: 'Domestic partner',
                    type: 'DOMESTIC_PARTNER',
                    code: '53',
                    mirrorType: 'DOMESTIC_PARTNER',
                },
                {
                    text: 'First Cousin',
                    type: 'FIRST_COUSIN',
                    code: '08',
                    mirrorType: 'FIRST_COUSIN',
                },
                {
                    text: 'Former Spouse',
                    type: 'FORMER_SPOUSE',
                    code: '25',
                    mirrorType: 'FORMER_SPOUSE',
                },
                {
                    text: 'Grandchild (grandson or granddaughter)',
                    type: 'GRANDCHILD',
                    code: '05',
                    mirrorType: 'GRANDPARENT',
                },
                {
                    text: 'Grandparent (grandfather or grandmother)',
                    type: 'GRANDPARENT',
                    code: '04',
                    mirrorType: 'GRANDCHILD',
                },
                {
                    text: 'Mother-in-law or Father-in-law',
                    type: 'MOTHER_FATHER_IN_LAW',
                    code: '13',
                    mirrorType: 'SON_DAUGHTER_IN_LAW',
                },
                {
                    text: 'Nephew or Niece',
                    type: 'NEPHEW_NIECE',
                    code: '07',
                    mirrorType: 'UNCLE_AUNT',
                },
                {
                    text: 'Parent (father or mother)',
                    type: 'PARENT',
                    code: '03',
                    mirrorType: 'CHILD',
                },
                {
                    text: 'Sibling (brother or sister)',
                    type: 'SIBLING',
                    code: '14',
                    mirrorType: 'SIBLING',
                },
                {
                    text: 'Son-in-law or Daughter-in-law',
                    type: 'SON_DAUGHTER_IN_LAW',
                    code: '11',
                    mirrorType: 'MOTHER_FATHER_IN_LAW',
                },
                {
                    text: 'Stepchild (stepson or stepdaughter)',
                    type: 'STEPCHILD',
                    code: '17',
                    mirrorType: 'STEPPARENT',
                },
                {
                    text: 'Stepparent (stepfather or stepmother)',
                    type: 'STEPPARENT',
                    code: '16',
                    mirrorType: 'STEPCHILD',
                },
                {
                    text: 'Uncle or Aunt',
                    type: 'UNCLE_AUNT',
                    code: '06',
                    mirrorType: 'NEPHEW_NIECE',
                },
                {
                    text: 'Ward',
                    type: 'WARD',
                    code: '15',
                    mirrorType: 'COURT_APPOINTED_GUARDIAN',
                },
                {
                    text: 'Unrelated',
                    type: 'UNRELATED',
                    code: 'G8',
                    mirrorType: 'UNRELATED',
                },
                {
                    text: 'Other Relative',
                    type: 'OTHER_RELATIVE',
                    code: 'G9',
                    mirrorType: 'OTHER_RELATIVE',
                },
            ],
            loadedRelations: [
                {
                    text: 'Relationship',
                    type: 'RELATION',
                    code: 'default',
                    mirrorType: 'RELATION',
                },
                {
                    text: 'Spouse',
                    type: 'SPOUSE',
                    code: '01',
                    mirrorType: 'SPOUSE',
                },
                {
                    text: 'Child (son or daughter)',
                    type: 'CHILD',
                    code: '19',
                    mirrorType: 'PARENT',
                },
                {
                    text: 'Brother-in-law or Sister-in-law',
                    type: 'BROTHER_OR_SISTER_IN_LAW',
                    code: '12',
                    mirrorType: 'BROTHER_OR_SISTER_IN_LAW',
                },
                {
                    text: 'Court Appointed or Live-In Guardian',
                    type: 'COURT_APPOINTED_GUARDIAN',
                    code: '31',
                    mirrorType: 'WARD',
                },
                {
                    text: 'Domestic partner',
                    type: 'DOMESTIC_PARTNER',
                    code: '53',
                    mirrorType: 'DOMESTIC_PARTNER',
                },
                {
                    text: 'First Cousin',
                    type: 'FIRST_COUSIN',
                    code: '08',
                    mirrorType: 'FIRST_COUSIN',
                },
                {
                    text: 'Former Spouse',
                    type: 'FORMER_SPOUSE',
                    code: '25',
                    mirrorType: 'FORMER_SPOUSE',
                },
                {
                    text: 'Grandchild (grandson or granddaughter)',
                    type: 'GRANDCHILD',
                    code: '05',
                    mirrorType: 'GRANDPARENT',
                },
                {
                    text: 'Grandparent (grandfather or grandmother)',
                    type: 'GRANDPARENT',
                    code: '04',
                    mirrorType: 'GRANDCHILD',
                },
                {
                    text: 'Mother-in-law or Father-in-law',
                    type: 'MOTHER_FATHER_IN_LAW',
                    code: '13',
                    mirrorType: 'SON_DAUGHTER_IN_LAW',
                },
                {
                    text: 'Nephew or Niece',
                    type: 'NEPHEW_NIECE',
                    code: '07',
                    mirrorType: 'UNCLE_AUNT',
                },
                {
                    text: 'Parent (father or mother)',
                    type: 'PARENT',
                    code: '03',
                    mirrorType: 'CHILD',
                },
                {
                    text: 'Self',
                    type: 'SELF',
                    code: '18',
                    mirrorType: 'SELF',
                },
                {
                    text: 'Sibling (brother or sister)',
                    type: 'SIBLING',
                    code: '14',
                    mirrorType: 'SIBLING',
                },
                {
                    text: 'Son-in-law or Daughter-in-law',
                    type: 'SON_DAUGHTER_IN_LAW',
                    code: '11',
                    mirrorType: 'MOTHER_FATHER_IN_LAW',
                },
                {
                    text: 'Stepchild (stepson or stepdaughter)',
                    type: 'STEPCHILD',
                    code: '17',
                    mirrorType: 'STEPPARENT',
                },
                {
                    text: 'Stepparent (stepfather or stepmother)',
                    type: 'STEPPARENT',
                    code: '16',
                    mirrorType: 'STEPCHILD',
                },
                {
                    text: 'Uncle or Aunt',
                    type: 'UNCLE_AUNT',
                    code: '06',
                    mirrorType: 'NEPHEW_NIECE',
                },
                {
                    text: 'Ward',
                    type: 'WARD',
                    code: '15',
                    mirrorType: 'COURT_APPOINTED_GUARDIAN',
                },
                {
                    text: 'Unrelated',
                    type: 'UNRELATED',
                    code: 'G8',
                    mirrorType: 'UNRELATED',
                },
                {
                    text: 'Other Relative',
                    type: 'OTHER_RELATIVE',
                    code: 'G9',
                    mirrorType: 'OTHER_RELATIVE',
                },
            ],
            selfOption: {
                text: 'Self',
                type: 'SELF',
                code: '18',
                mirrorType: 'SELF',
            },
            loadedRelationsWholeList: [
                {
                    text: 'Adopted son or daughter',
                    type: 'ADOPTED_SON_OR_DAUGHTER',
                    code: '09',
                },
                {
                    text: 'Annuitant',
                    type: 'ANNUITANT',
                    code: '60',
                },
                {
                    text: 'Brother-in-law or sister-in-law',
                    type: 'BROTHER_OR_SISTER_IN_LAW',
                    code: '12',
                },
                {
                    text: 'Child (son or daughter)',
                    type: 'CHILD',
                    code: '19',
                },
                {
                    text: 'Collateral dependent',
                    type: 'COLLATERAL_DEPENDENT',
                    code: '38',
                },
                {
                    text: 'Court appointed guardian',
                    type: 'COURT_APPOINTED_GUARDIAN',
                    code: '31',
                },
                {
                    text: 'Dependent of a minor dependent',
                    type: 'DEPENDENT_OF_DEPENDENT',
                    code: '24',
                },
                {
                    text: 'Domestic partner',
                    type: 'DOMESTIC_PARTNER',
                    code: '53',
                },
                {
                    text: 'First cousin',
                    type: 'FIRST_COUSIN',
                    code: '08',
                },
                {
                    text: 'Former spouse',
                    type: 'FORMER_SPOUSE',
                    code: '25',
                },
                {
                    text: 'Foster child (foster son or foster daughter)',
                    type: 'FOSTER_CHILD',
                    code: '10',
                },
                {
                    text: 'Grandchild (grandson or granddaughter)',
                    type: 'GRANDCHILD',
                    code: '05',
                },
                {
                    text: 'Grandparent (grandfather or grandmother)',
                    type: 'GRANDPARENT',
                    code: '04',
                },
                {
                    text: 'Guardian',
                    type: 'GUARDIAN',
                    code: '26',
                },
                {
                    text: 'Mother-in-law or father-in-law',
                    type: 'MOTHER_FATHER_IN_LAW',
                    code: '13',
                },
                {
                    text: 'Nephew or niece',
                    type: 'NEPHEW_NIECE',
                    code: '07',
                },
                {
                    text: 'Parent (father or mother)',
                    type: 'PARENT',
                    code: '03',
                },
                {
                    text: 'Self',
                    type: 'SELF',
                    code: '18',
                },
                {
                    text: 'Sibling (brother or sister)',
                    type: 'SIBLING',
                    code: '14',
                },
                {
                    text: 'Son-in-law or daughter-in-law',
                    type: 'SON_DAUGHTER_IN_LAW',
                    code: '11',
                },
                {
                    text: 'Sponsored dependent',
                    type: 'SPONSORED_DEPENDENT',
                    code: '23',
                },
                {
                    text: 'Spouse',
                    type: 'SPOUSE',
                    code: '01',
                },
                {
                    text: 'Stepchild (stepson or stepdaughter)',
                    type: 'STEPCHILD',
                    code: '17',
                },
                {
                    text: 'Stepparent (stepfather or stepmother)',
                    type: 'STEPPARENT',
                    code: '16',
                },
                {
                    text: 'Trustee',
                    type: 'TRUSTEE',
                    code: 'D2',
                },
                {
                    text: 'Uncle or aunt',
                    type: 'UNCLE_AUNT',
                    code: '06',
                },
                {
                    text: 'Unspecified relationship',
                    type: 'OTHER',
                    code: 'G8',
                },
                {
                    text: 'Unspecified relative',
                    type: 'OTHER_RELATIVE',
                    code: 'G9',
                },
                {
                    text: 'Ward',
                    type: 'WARD',
                    code: '15',
                },
            ],
            codes: {
                SPOUSE: '01',
                caretakerNotConsidered: {},
                itfConsidered: {},
            },
        },
        scroll: null,
        settings: {
            alwaysDisplayMedicaidQuestions: true,
            autoReenrollSopaConsent: 'Enabled',
            collectMemberRemovalReason: 'Enabled',
            dacaEffective: null,
            escUiUpdated: 'Enabled',
            itfFeature: 'Enabled',
            inlineCurrentIncomeEnabled: 'Enabled',
            inlineEligibilityIgnoredForEscPage: 'Enabled',
            collectLivingArrangement: 'Enabled',
            medicaidEndDateOverride: 90,
            endDateOfPregnancyOverride: 60,
            medicaidTerminationFeature: 'Enabled',
            realtimeCheck: 'Enabled',
            sogiFeature: 'Enabled',
            voterRegistrationFeature: 'Enabled'
        },
        structure: {
            taxHouseholdStructure: 'array',
            bloodRelationshipStructure: 'primaryContact',
        },
        summary: {
            areOnlyUpdatedFieldsShown: false,
            isExtraFinalSummaryShown: false,
            isSummaryCrashed: false,
        },
    },
    common: {
        environment: {
            stateCode: states.MINNESOTA,
            isState: {
                [states.CALIFORNIA]: false,
                [states.GEORGIA]: false,
                [states.GETINSURED]: false,
                [states.IDAHO]: false,
                [states.MINNESOTA]: false,
                [states.NEVADA]: false,
                [states.NEW_JERSEY]: false,
                [states.PENNSYLVANIA]: false,
                [states.VIRGINIA]: false,
                [states.ILLINOIS]: false,
            },
            exchangeName: 'Pennie',
            properties: {
                GOOGLE_ANALYTICS_CONTAINER_ID: 'GTM-TSJ4GM4',
            },
            ticketEnabled: true,
            links: {
                ASSISTANCE: '#',
                BROKER_PHONE: '',
                CA_PROFILE_URL: null,
                CHAT: '#',
                CONTACT_US: 'https://help.nevadahealthlink.com/hc/en-us/articles/360029638331-Contact-Us',
                DASHBOARD: '/hix/account/user/getDashBoard',
                HELP: 'https://help.nevadahealthlink.com/hc/en-us',
                HOME: 'https://enroll.nevadahealthlink.com',
                LOGIN: '/hix/account/user/login',
                LOGOUT: '/hix/account/user/logout',
                LOGO_URL: 'https://www.nevadahealthlink.com/',
                PHONE: '800-547-2927, TTY 711',
                MY_ELIGIBILITY_HOME: 'https://people.idev.mnsure.org/universal/account',
                PRIVACY_POLICY: 'https://www.nevadahealthlink.com/about-nevada-health-link/privacy-policy/',
                REQUIRED_DOCUMENTS_LINK: 'https://help.nevadahealthlink.com/hc/en-us/articles/360028571432',
                SETTINGS: '/hix/account/user/accountsettings',
                SIGNUP_ADMIN_STAFF1:
                    '/hix/account/signup/bnqR472M60GZMTrDxVON_5sRNwEpwEPobvaSc7rZwWim05XxMiYjVM38_wGoZBatmK6NbHS_ZiHoQVL9K-5Ghw',
                SIGNUP_ADMIN_STAFF2:
                    '/hix/account/signup/xDagNc74URRZTolHoR-Bg6GoU2tUAzWBZGIEvX32O8ZB9GiSbnkrIBVtwVd0-rbA7bLdniP9uX-vt97aiARS9g',
                SIGNUP_AGENCY:
                    '/hix/account/signup/2__QJ880QV-JzO385z5wKrKaFj8a-b6wWTey3j4_7llRVPkBATSCWMH_Ni0rRr3e_onkIt51o5fsvqx5ye0VJQ',
                SIGNUP_AGENT_BROKER:
                    '/hix/account/signup/WzDVgRJ8KEllZjHJnlql5qDOWIhpdklsDA8ZVJ2l3xPHkFsLzBpAVODrIHnx1_AJ',
                SIGNUP_ENROLLMENT_COUNSELOR:
                    '/hix/account/signup/MkqgkkjoTYM44PJWwkTrhwChM14CpBa3isCuRpmP4CgoaiyXDSoNVofvkCWtKSP6',
                SIGNUP_ENROLLMENT_ENTITIES:
                    '/hix/account/signup/J9XB0FGuCYEMxVGevxJp4xYNQSW7kPLO8d7KRg25AeySoXgu6engj1xDLFOvlO-NauiFxeUDMRziodNKZ66nuQ',
                SIGNUP_INDIVIDUAL:
                    '/hix/account/signup/K9XUIEuGIY-Dy5GqFUGcIESh5wzRNAJCX6q5YUhWrYHi9w18b9BCD-gNGQ7CT_Cg',
                UNREAD_MESSAGES: '/hix/inbox/home?languageCode=${language}',
            },
            language: 'en',
            assets: {
                LOGO: '../assets/images/logo_nv.png',
                FAV_ICON: '/assets/images/favicon_nv.ico',
                LOGO_MOBILE: '/assets/images/logo_mobile_nv.png',
            },
            user: {
                role: ALL_USER_ROLES.BROKER,
                activeModuleName: ALL_USER_ROLES.ADMIN,
                userActiveRole: ALL_USER_ROLES.BROKER
            },
            flags: {
                multiHouseholdEnabled: true,
            },
            screenerConfigs: {
                iexCurrentCoverageYear: '2022',
                iexPreviousCoverageYear: '2021',
                numberOfPreviousCoverageYears: 3,
                showTobaccoCheck: true,
                showPregnancyCheck: true,
                showIncomeSection: true,
                leadPresent: true,
                currentCoverageYearOptionStartDate: '11/01/2021',
                isStateSubsidyEnabled: true,
                multiYearEnabled: true,
                showNativeAmericanCheck: true,
                encryptedIndividualRoleName: 'eNV7ER77351F8Exadl9erlKl7hUP3XLWyww2dBB-I6vPQHhYejKrkUH5JdhGPqEOdbf',
                issuerEffectiveDate: '',
            },
            localDates: {
                serverDate: formatDate('30-03-2022', DD_MM_YYYY),
                oepStartDate: formatDate('01-11-2020', DD_MM_YYYY),
                oepEndDate: formatDate('31-01-2021', DD_MM_YYYY),
                oepEnrollStartDate: formatDate('01-11-2020', DD_MM_YYYY),
                oepEnrollEndDate: formatDate('31-01-202', DD_MM_YYYY),
                exceptionalCircumstancesStartDate: formatDate('30-03-2022', DD_MM_YYYY),
                exceptionalCircumstancesEndDate: formatDate('30-03-2022', DD_MM_YYYY),
                serverDateInUTC: '2021-08-24T14:00:00Z',
                timezoneOffsetMs: -21600000,
                dstSavingsMs: 3600000,
            },
        },
        error: {
            errorStatus: false,
            errorMessage: null,
            errorType: null,
        },
        spinner: {
            activeSpinnersQty: 0,
            message: null,
        },
        progress: {
            processing: false,
            processingPercentage: 0,
        },
        modals: [
            {
                modalType: ssapModalTypes.LEAVE_PAGE_MODAL,
                modalData: {},
                zIndex: 10000,
            },
        ],
        messages: {
            en: messages,
        },
    },
    individualPortal: {
        dashboard: {
            activeHouseholdId: null,
            activeTab: 0,
            ctaType: '',
            dashboardModels: [
                {
                    applicationYear: '2021',
                    applicationStatus: 'EN',
                    applicationType: 'SEP',
                    caseNumber: '118286000',
                    encryptedCaseNumber: 'gCuOgpPMPxg7w3HsjR6PvEpTY5ZzXMX_SJD350gIALgBPXt_bA0Vq9GiGWRqAinR',
                    whereUserLeftOff: 'APPSCR51',
                    aptc: 2000,
                    stateSubsidy: 20,
                    renewalApplication: false,
                    isFinancial: true,
                    applicants: [
                        {
                            memberId: '317752874',
                            guid: '984493461',
                            firstName: 'Testkjjld',
                            lastName: 'Rockaddcnama',
                            relation: 'SPOUSE',
                            seekingCoverage: true,
                            seeksQHP: false,
                            exchangeEligible: true,
                            aptcEligible: true,
                            stateSubsidyEligible: true,
                            csrEligible: true,
                            nativeAmerican: true,
                            csrLevel: 'CS3',
                            middleName: '',
                            nameSuffix: '',
                            chipEligible: false,
                            assessedChipEligible: false,
                            medicaidMAGIEligible: false,
                            medicaidNonMAGIEligible: false,
                            assessedMedicaidMAGIEligible: false,
                            assessedMedicaidNonMAGIEligible: false,
                            verificationStatus: 'VERIFIED',
                            sepApplicantEvents: [
                                {
                                    eventName: 'NO_CHANGE',
                                    changeType: 'OTHER',
                                },
                            ],
                        },
                        {
                            memberId: '317752875',
                            guid: '984493462',
                            firstName: 'Alissa',
                            lastName: 'Blytonupdated',
                            relation: 'SELF',
                            seekingCoverage: true,
                            seeksQHP: false,
                            exchangeEligible: true,
                            aptcEligible: true,
                            stateSubsidyEligible: true,
                            csrEligible: true,
                            nativeAmerican: true,
                            csrLevel: 'CS3',
                            middleName: '',
                            nameSuffix: '',
                            chipEligible: false,
                            assessedChipEligible: false,
                            medicaidMAGIEligible: false,
                            medicaidNonMAGIEligible: false,
                            assessedMedicaidMAGIEligible: false,
                            assessedMedicaidNonMAGIEligible: false,
                            verificationStatus: 'VERIFIED',
                            sepApplicantEvents: [
                                {
                                    eventName: 'NO_CHANGE',
                                    changeType: 'OTHER',
                                },
                            ],
                        },
                    ],
                    openApplication: null,
                    preEligibility: null,
                    enrollments: [],
                    sepEvent: {
                        isIdentified: true,
                        isVerified: true,
                        isGatedNeedsVerification: null,
                        isDocumentUploadedAndVerified: true,
                    },
                    isSepOpen: false,
                    sepStartDate: '06/25/2021',
                    sepEndDate: '08/09/2021',
                    isInsideOEEnrollmentWindow: true,
                    validationStatus: 'PENDING',
                    applicationDentalStatus: 'EN',
                    verificationStatus: 'ACTION_NEEDED',
                    dmiDocumentUploadstatus: 'PENDING',
                    ssapApplicationId: 304502513,
                    healthRenewalStatus: null,
                    dentalRenewalStatus: null,
                    isInsideOEWindow: false,
                    oepApproachingDays: -323,
                    remainingDaysForROP: 0,
                    fullDeterminationRequested: false,
                    isLatestApplication: false,
                    tobaccoCoverageDate: '12/01/2021',
                    encryptedApplicationId: '2UwOKQR-EDL8fJySONHMUUhxmbm3hW95qkqxVoIdn7QUyz5oeNVv1GHDlm3UgHX7',
                    isBenefitYear: false,
                    sepOpen: false,
                    insideOEWindow: false,
                    financial: true,
                    insideOEEnrollmentWindow: false,
                },
            ],
        },
        applications: {
            loaded: false,
            householdCaseId: null,
            entities: {},
        },
        communicationPreferences: {
            emailAddress: 'carlos.spanish@yopmail.com',
            phoneNumber: '4086054525',
            preferredSpokenLanguage: 'Spanish',
            preferredWrittenLanguage: 'Spanish',
            mailingAddress: {
                streetAddress1: '27 West 4th St',
                streetAddress2: null,
                city: 'Emporium',
                countyCode: '42047',
                state: 'PA',
                postalCode: '15834',
            },
            textMe: false,
            paperless1095: true,
            emailMe: true,
            paperlessNotices: true,
            userRecordExists: true,
            middleName: null,
            nameSuffix: null,
            firstName: 'Carlos',
            lastName: 'Spanish',
            ssn: null,
            mailinglocationId: null,
            primaryLocationId: null,
            birthDate: null,
            showNoticeOptOut: true,
            noticeOptOut: false,
            mailingAddressUpdateAllowed: false,
        },
        eligibilityResults: {},
        secureInbox: {
            notifications: {
                content: [],
                pageable: {
                    sort: {},
                    pageNumber: 0,
                    pageSize: 0,
                    offset: 0,
                    paged: false,
                    unpaged: false,
                },
                sort: {},
                empty: false,
                first: true,
                last: true,
                number: 0,
                numberOfElements: 0,
                numberUnread: 6,
                size: 0,
                totalElements: 0,
                totalPages: 0,
            },
        },
        ticket: [],
        enrollmentHistory: {
            activeDentalEnrollments: [],
            activeHealthEnrollments: [],
            coverageStartDateForDisenrollment: '',
            inactiveDentalEnrollments: [],
            inactiveHealthEnrollments: [],
            errorMessage: ''
        }
    },
    delegation: {
        leftNavParams: {},
    },
    edeSearch: {
        results: [{}],
    },
    router: {
        location: {
            pathname: '/ssap',
            search: '',
            hash: '',
            query: {},
        },
        action: 'POP',
    },
    accountActivity: {
        activityData: [],
        currentFilteredData: [],
        initialData: {
            householdId: '',
            roleList: {},
            typeAndNames: {},
            memberHistoryPermissionMap: {
                memberAbtLogcall: true,
                memberAbtShowcomments: true,
            },
            viewTicketDetailsLink: true,
        },
        filters: {
            category: 'ALL',
            eventType: 'ALL',
            createdByRole: 'ALL',
            dateRange: [null, null],
        },
    },
    memberEnrollment: {
        enrollmentandenrolleedetails: {},
        enrollmentDetails: {},
        responseBasedErrorMessage: '',
        enrollmentRequest: {
            isSuccess: false,
            isError: false,
            errorMessage: '',
        }
    },
};

export const formsMockValues = {
    employerCoverageDetailModalForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: true,
        areAllInputsValid: false,
        nonStandaloneInputsChanged: [],
        registeredInputs: [
            {
                inputId: 'page_54_name_firstName',
                initialInputValue: 'test',
                isInputTouched: false,
                inputName: 'firstName',
                inputValue: 'test',
                isInputRequired: false,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_54_name_middleName',
                initialInputValue: 'one',
                isInputTouched: false,
                inputName: 'middleName',
                inputValue: 'one',
                isInputRequired: false,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'MIDDLE_NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_54_name_lastName',
                initialInputValue: 'two',
                isInputTouched: false,
                inputName: 'lastName',
                inputValue: 'two',
                isInputRequired: false,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_54_name_suffix',
                initialInputValue: 'Jr',
                isInputTouched: false,
                inputName: 'suffix',
                inputValue: 'Jr',
                isInputRequired: false,
                inputIsValid: true,
                inputValidationType: null,
                validOf: () => true,
            },
            {
                inputId: 'page_54_phone',
                initialInputValue: '1111111111',
                isInputTouched: false,
                inputName: 'phone',
                inputValue: '1111111111',
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.phone_number'],
                inputValidationType: 'PHONE_NUMBER',
                validOf: () => true,
            },
            {
                inputId: 'page_54_email',
                initialInputValue: null,
                isInputTouched: false,
                inputName: 'email',
                inputValue: null,
                isInputRequired: false,
                inputIsValid: true,
                inputValidationType: null,
                validOf: () => true,
            },
            {
                inputId: 'page_54_address_streetAddress1',
                initialInputValue: '',
                isInputTouched: false,
                inputName: 'streetAddress1',
                inputValue: '',
                isInputRequired: true,
                inputIsValid: false,
                messages: ['ssap.validation_error_message.valid_address'],
                inputValidationType: 'ADDRESS_LINE_OPTIONAL',
                validOf: () => true,
            },
            {
                inputId: 'page_54_address_streetAddress2',
                initialInputValue: '',
                isInputTouched: false,
                inputName: 'streetAddress2',
                inputValue: '',
                isInputRequired: false,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.valid_address'],
                inputValidationType: 'ADDRESS_LINE_OPTIONAL',
                validOf: () => true,
            },
            {
                inputId: 'page_54_address_city',
                initialInputValue: '',
                isInputTouched: false,
                inputName: 'city',
                inputValue: '',
                isInputRequired: true,
                inputIsValid: false,
                messages: ['ssap.validation_error_message.city'],
                inputValidationType: 'CITY_OPTIONAL',
                validOf: () => true,
            },
            {
                inputId: 'page_54_address_postalCode',
                initialInputValue: '',
                isInputTouched: false,
                inputName: 'postalCode',
                inputValue: '',
                isInputRequired: true,
                inputIsValid: true,
                inputValidationType: null,
                validOf: () => true,
            },
            {
                inputId: 'page_54_address_state',
                initialInputValue: '',
                isInputTouched: false,
                inputName: 'state',
                inputValue: '',
                isInputRequired: true,
                inputIsValid: false,
                messages: ['ssap.validation_error_message.chosen'],
                inputValidationType: 'CHOSEN',
                validOf: () => true,
            },
            {
                inputId: 'page_54_ein',
                initialInputValue: '',
                isInputTouched: false,
                inputName: 'ein',
                inputValue: '',
                isInputRequired: false,
                inputIsValid: true,
                inputValidationType: null,
                validOf: () => true,
            },
        ],
        isFormInInitialState: true,
        snapshot:
            '[{"inputId":"page_54_name_firstName","value":"test"},{"inputId":"page_54_name_middleName","value":"one"},{"inputId":"page_54_name_lastName","value":"two"},{"inputId":"page_54_name_suffix","value":"Jr"},{"inputId":"page_54_phone","value":"1111111111"},{"inputId":"page_54_email","value":null},{"inputId":"page_54_address_streetAddress1","value":""},{"inputId":"page_54_address_streetAddress2","value":""},{"inputId":"page_54_address_city","value":""},{"inputId":"page_54_address_postalCode","value":""},{"inputId":"page_54_address_state","value":""},{"inputId":"page_54_ein","value":""}]',
    },
    householdMembersForm: {
        isFormSubmitted: false,
        isEligiblyForSave: true,
        isFormOnTopLevelValid: true,
        areAllInputsValid: true,
        nonStandaloneInputsChanged: [],
        registeredInputs: [
            {
                inputId: 'page_05_hhm0_applyingForCoverageIndicator',
                initialInputValue: false,
                isInputTouched: false,
                inputName: 'applyingForCoverageIndicator',
                inputValue: false,
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.chosen'],
                inputValidationType: 'CHOSEN',
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm0_name_firstName',
                initialInputValue: 'David',
                isInputTouched: false,
                inputName: 'firstName',
                inputValue: 'David',
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm0_name_middleName',
                initialInputValue: 'John',
                isInputTouched: false,
                inputName: 'middleName',
                inputValue: 'John',
                isInputRequired: false,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'MIDDLE_NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm0_name_lastName',
                initialInputValue: 'Blacksmith',
                isInputTouched: false,
                inputName: 'lastName',
                inputValue: 'Blacksmith',
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm0_name_suffix',
                initialInputValue: 'Jr.',
                isInputTouched: false,
                inputName: 'suffix',
                inputValue: 'Jr.',
                isInputRequired: false,
                inputIsValid: true,
                inputValidationType: null,
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm0_dateOfBirth',
                initialInputValue: '1950-01-25',
                isInputTouched: false,
                inputName: 'dateOfBirth',
                inputValue: '1950-01-25',
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.date'],
                inputValidationType: 'DATE_NOT_GREATER_THAN_CURRENT',
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm1_applyingForCoverageIndicator',
                initialInputValue: true,
                isInputTouched: false,
                inputName: 'applyingForCoverageIndicator',
                inputValue: true,
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.chosen'],
                inputValidationType: 'CHOSEN',
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm1_name_firstName',
                initialInputValue: 'Sarah',
                isInputTouched: false,
                inputName: 'firstName',
                inputValue: 'Sarah',
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm1_name_middleName',
                initialInputValue: 'Jessica',
                isInputTouched: false,
                inputName: 'middleName',
                inputValue: 'Jessica',
                isInputRequired: false,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'MIDDLE_NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm1_name_lastName',
                initialInputValue: 'Blacksmith',
                isInputTouched: false,
                inputName: 'lastName',
                inputValue: 'Blacksmith',
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm1_name_suffix',
                initialInputValue: 'III',
                isInputTouched: false,
                inputName: 'suffix',
                inputValue: 'III',
                isInputRequired: false,
                inputIsValid: true,
                inputValidationType: null,
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm1_dateOfBirth',
                initialInputValue: '2000-09-23',
                isInputTouched: false,
                inputName: 'dateOfBirth',
                inputValue: '2000-09-23',
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.date'],
                inputValidationType: 'DATE_NOT_GREATER_THAN_CURRENT',
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm2_applyingForCoverageIndicator',
                initialInputValue: true,
                isInputTouched: false,
                inputName: 'applyingForCoverageIndicator',
                inputValue: true,
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.chosen'],
                inputValidationType: 'CHOSEN',
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm2_name_firstName',
                initialInputValue: 'Nataniel',
                isInputTouched: false,
                inputName: 'firstName',
                inputValue: 'Nataniel',
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm2_name_middleName',
                initialInputValue: 'George',
                isInputTouched: false,
                inputName: 'middleName',
                inputValue: 'George',
                isInputRequired: false,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'MIDDLE_NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm2_name_lastName',
                initialInputValue: 'Blacksmith',
                isInputTouched: false,
                inputName: 'lastName',
                inputValue: 'Blacksmith',
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm2_name_suffix',
                initialInputValue: 'Jr.',
                isInputTouched: false,
                inputName: 'suffix',
                inputValue: 'Jr.',
                isInputRequired: false,
                inputIsValid: true,
                inputValidationType: null,
                validOf: () => true,
            },
            {
                inputId: 'page_05_hhm2_dateOfBirth',
                initialInputValue: '2010-09-22',
                isInputTouched: false,
                inputName: 'dateOfBirth',
                inputValue: '2010-09-22',
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.date'],
                inputValidationType: 'DATE_NOT_GREATER_THAN_CURRENT',
                validOf: () => true,
            },
        ],
        isFormInInitialState: true,
        snapshot:
            '[{"inputId":"page_05_hhm0_applyingForCoverageIndicator","value":false},{"inputId":"page_05_hhm0_name_firstName","value":"David"},{"inputId":"page_05_hhm0_name_middleName","value":"John"},{"inputId":"page_05_hhm0_name_lastName","value":"Blacksmith"},{"inputId":"page_05_hhm0_name_suffix","value":"Jr."},{"inputId":"page_05_hhm0_dateOfBirth","value":"1950-01-25"},{"inputId":"page_05_hhm1_applyingForCoverageIndicator","value":true},{"inputId":"page_05_hhm1_name_firstName","value":"Sarah"},{"inputId":"page_05_hhm1_name_middleName","value":"Jessica"},{"inputId":"page_05_hhm1_name_lastName","value":"Blacksmith"},{"inputId":"page_05_hhm1_name_suffix","value":"III"},{"inputId":"page_05_hhm1_dateOfBirth","value":"2000-09-23"},{"inputId":"page_05_hhm2_applyingForCoverageIndicator","value":true},{"inputId":"page_05_hhm2_name_firstName","value":"Nataniel"},{"inputId":"page_05_hhm2_name_middleName","value":"George"},{"inputId":"page_05_hhm2_name_lastName","value":"Blacksmith"},{"inputId":"page_05_hhm2_name_suffix","value":"Jr."},{"inputId":"page_05_hhm2_dateOfBirth","value":"2010-09-22"}]',
    },
    primaryContactForm: {
        areAllInputsValid: true,
        isEligiblyForSave: true,
        isFormInInitialState: true,
        isFormOnTopLevelValid: true,
        isFormSubmitted: false,
        registeredInputs: [
            {
                initialInputValue: 'David',
                inputId: 'page_02_name_firstName',
                inputIsValid: true,
                inputName: 'firstName',
                inputValidationType: 'NAME',
                inputValue: 'David',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.name'],
                validOf: () => true,
            },
            {
                initialInputValue: 'John',
                inputId: 'page_02_name_middleName',
                inputIsValid: true,
                inputName: 'middleName',
                inputValidationType: 'MIDDLE_NAME',
                inputValue: 'John',
                isInputRequired: false,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.name'],
                validOf: () => true,
            },
            {
                initialInputValue: 'Blacksmith',
                inputId: 'page_02_name_lastName',
                inputIsValid: true,
                inputName: 'lastName',
                inputValidationType: 'NAME',
                inputValue: 'Blacksmith',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.name'],
                validOf: () => true,
            },
            {
                initialInputValue: 'Jr.',
                inputId: 'page_02_name_suffix',
                inputIsValid: true,
                inputName: 'suffix',
                inputValidationType: null,
                inputValue: 'Jr.',
                isInputRequired: false,
                isInputTouched: false,
                messages: undefined,
                validOf: () => true,
            },
            {
                initialInputValue: '1950-01-25',
                inputId: 'page_02_hhm0_dateOfBirth',
                inputIsValid: true,
                inputName: 'dateOfBirth',
                inputValidationType: 'DATE_NOT_GREATER_THAN_CURRENT',
                inputValue: '1950-01-25',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.date'],
                validOf: () => true,
            },
            {
                initialInputValue: 'davidblacksmth@gmail.com',
                inputId: 'page_02_contactPreferences_emailAddress',
                inputIsValid: true,
                inputName: 'emailAddress',
                inputValidationType: 'EMAIL',
                inputValue: 'davidblacksmth@gmail.com',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.email'],
                validOf: () => true,
            },
            {
                initialInputValue: true,
                inputId: 'page_02_contactPreferences_emailMe',
                inputIsValid: true,
                inputName: 'emailMe',
                inputValidationType: null,
                inputValue: true,
                isInputRequired: false,
                isInputTouched: false,
                messages: undefined,
                validOf: () => true,
            },
            {
                initialInputValue: '240 S Wood St',
                inputId: 'page_02_homeAddress_streetAddress1',
                inputIsValid: true,
                inputName: 'streetAddress1',
                inputValidationType: 'ADDRESS_LINE1',
                inputValue: '240 S Wood St',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.valid_address'],
                validOf: () => true,
            },
            {
                initialInputValue: '',
                inputId: 'page_02_homeAddress_streetAddress2',
                inputIsValid: true,
                inputName: 'streetAddress2',
                inputValidationType: 'ADDRESS_LINE2',
                inputValue: '',
                isInputRequired: false,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.valid_address'],
                validOf: () => true,
            },
            {
                initialInputValue: 'Bedford',
                inputId: 'page_02_homeAddress_city',
                inputIsValid: true,
                inputName: 'city',
                inputValidationType: 'CITY',
                inputValue: 'Bedford',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.city'],
                validOf: () => true,
            },
            {
                initialInputValue: '15522',
                inputId: 'page_02_homeAddress_postalCode',
                inputIsValid: true,
                inputName: 'postalCode',
                inputValidationType: 'ZIP_CODE_5_DIGITS',
                inputValue: '15522',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.zip_5_digits'],
                validOf: () => true,
            },
            {
                initialInputValue: 'PA',
                inputId: 'page_02_homeAddress_state',
                inputIsValid: true,
                inputName: 'state',
                inputValidationType: 'CHOSEN',
                inputValue: 'PA',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.chosen'],
                validOf: () => true,
            },
            {
                initialInputValue: '42009',
                inputId: 'page_02_homeAddress_countyCode',
                inputIsValid: true,
                inputName: 'countyCode',
                inputValidationType: 'CHOSEN',
                inputValue: '42009',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.chosen'],
                validOf: () => true,
            },
            {
                initialInputValue: null,
                inputId: 'page_02_noHomeAddress_noHomeAddress',
                inputIsValid: true,
                inputName: 'noHomeAddress',
                inputValidationType: null,
                inputValue: null,
                isInputRequired: false,
                isInputTouched: false,
                messages: undefined,
                validOf: () => true,
            },
            {
                initialInputValue: null,
                inputId: 'page_02_householdContact_mailingAddressSameAsHomeAddressIndicator',
                inputIsValid: true,
                inputName: 'mailingAddressSameAsHomeAddressIndicator',
                inputValidationType: null,
                inputValue: null,
                isInputRequired: false,
                isInputTouched: false,
                messages: undefined,
                validOf: () => true,
            },
            {
                initialInputValue: '27 West 4th St',
                inputId: 'page_02_mailingAddress_streetAddress1',
                inputIsValid: true,
                inputName: 'streetAddress1',
                inputValidationType: 'ADDRESS_LINE1',
                inputValue: '27 West 4th St',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.valid_address'],
                validOf: () => true,
            },
            {
                initialInputValue: '',
                inputId: 'page_02_mailingAddress_streetAddress2',
                inputIsValid: true,
                inputName: 'streetAddress2',
                inputValidationType: 'ADDRESS_LINE2',
                inputValue: '',
                isInputRequired: false,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.valid_address'],
                validOf: () => true,
            },
            {
                initialInputValue: 'Emporium',
                inputId: 'page_02_mailingAddress_city',
                inputIsValid: true,
                inputName: 'city',
                inputValidationType: 'CITY',
                inputValue: 'Emporium',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.city'],
                validOf: () => true,
            },
            {
                initialInputValue: '15834',
                inputId: 'page_02_mailingAddress_postalCode',
                inputIsValid: true,
                inputName: 'postalCode',
                inputValidationType: 'ZIP_CODE_5_DIGITS',
                inputValue: '15834',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.zip_5_digits'],
                validOf: () => true,
            },
            {
                initialInputValue: 'PA',
                inputId: 'page_02_mailingAddress_state',
                inputIsValid: true,
                inputName: 'state',
                inputValidationType: 'CHOSEN',
                inputValue: 'PA',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.chosen'],
                validOf: () => true,
            },
            {
                initialInputValue: '42047',
                inputId: 'page_02_mailingAddress_countyCode',
                inputIsValid: true,
                inputName: 'countyCode',
                inputValidationType: 'CHOSEN',
                inputValue: '42047',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.chosen'],
                validOf: () => true,
            },
            {
                initialInputValue: '1232321234',
                inputId: 'page_02_phone_phoneNumber',
                inputIsValid: true,
                inputName: 'phoneNumber',
                inputValidationType: 'PHONE_NUMBER',
                inputValue: '1232321234',
                isInputRequired: false,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.phone_number'],
                validOf: () => true,
            },
            {
                initialInputValue: false,
                inputId: 'page_02_contactPreferences_textMe',
                inputIsValid: true,
                inputName: 'textMe',
                inputValidationType: null,
                inputValue: false,
                isInputRequired: false,
                isInputTouched: false,
                messages: undefined,
                validOf: () => true,
            },
            {
                initialInputValue: '4087995678',
                inputId: 'page_02_otherPhone__phoneNumber',
                inputIsValid: true,
                inputName: '_phoneNumber',
                inputValidationType: 'PHONE_NUMBER',
                inputValue: '4087995678',
                isInputRequired: false,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.phone_number'],
                validOf: () => true,
            },
            {
                initialInputValue: '1223',
                inputId: 'page_02_otherPhone_phoneExtension',
                inputIsValid: true,
                inputName: 'phoneExtension',
                inputValidationType: 'PHONE_EXTENSION',
                inputValue: '1223',
                isInputRequired: false,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.phone_extension'],
                validOf: () => true,
            },
            {
                initialInputValue: 'English',
                inputId: 'page_02_contactPreferences_preferredSpokenLanguage',
                inputIsValid: true,
                inputName: 'preferredSpokenLanguage',
                inputValidationType: null,
                inputValue: 'English',
                isInputRequired: false,
                isInputTouched: false,
                messages: undefined,
                validOf: () => true,
            },
            {
                initialInputValue: 'English',
                inputId: 'page_02_contactPreferences_preferredWrittenLanguage',
                inputIsValid: true,
                inputName: 'preferredWrittenLanguage',
                inputValidationType: null,
                inputValue: 'English',
                isInputRequired: false,
                isInputTouched: false,
                messages: undefined,
                validOf: () => true,
            },
            {
                initialInputValue: 'Email',
                inputId: 'page_02_contactPreferences_preferredContactMethod',
                inputIsValid: true,
                inputName: 'preferredContactMethod',
                inputValidationType: 'CHOSEN',
                inputValue: 'Email',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.chosen'],
                validOf: () => true,
            },
            {
                initialInputValue: true,
                inputId: 'page_02_contactPreferences_paperless1095',
                inputIsValid: true,
                inputName: 'paperless1095',
                inputValidationType: 'CHOSEN',
                inputValue: true,
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.chosen'],
                validOf: () => true,
            },
        ],
    },
    removeMemberModalForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: true,
        areAllInputsValid: false,
        nonStandaloneInputsChanged: [],
        registeredInputs: [
            {
                inputId: 'page_05_removeAction',
                initialInputValue: null,
                isInputTouched: true,
                inputName: 'removeAction',
                inputValue: false,
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.chosen'],
                inputValidationType: 'CHOSEN',
                validOf: () => true,
            },
            {
                inputId: 'page_05_removeReason',
                initialInputValue: 'UNSPECIFIED',
                isInputTouched: true,
                inputName: 'removeReason',
                inputValue: 'DEATH',
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.chosen'],
                inputValidationType: 'NOT_UNSPECIFIED',
                validOf: () => true,
            },
            {
                inputId: 'page_05_dateOfDeath',
                initialInputValue: null,
                isInputTouched: false,
                inputName: 'dateOfDeath',
                inputValue: null,
                isInputRequired: true,
                inputIsValid: false,
                messages: ['ssap.validation_error_message.date'],
                inputValidationType: 'DATE_NOT_GREATER_THAN_CURRENT',
                validOf: () => true,
            },
        ],
        isFormInInitialState: false,
        snapshot: '[{"inputId":"page_05_removeAction","value":null}]',
    },
    incomeDeductionSourceModalForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: true,
        areAllInputsValid: false,
        nonStandaloneInputsChanged: [],
        registeredInputs: [
            {
                inputId: 'page_35_type',
                initialInputValue: null,
                isInputTouched: false,
                inputName: 'type',
                inputValue: null,
                isInputRequired: true,
                inputIsValid: false,
                messages: ['ssap.validation_error_message.chosen'],
                inputValidationType: 'CHOSEN',
                validOf: () => true,
            },
        ],
        isFormInInitialState: true,
        snapshot: '[{"inputId":"page_35_type","value":null}]',
    },
    incomeSourcesForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: false,
        areAllInputsValid: true,
        nonStandaloneInputsChanged: [],
        registeredInputs: [
            {
                inputId: 'page_45_isAnyIncome',
                initialInputValue: null,
                isInputTouched: true,
                inputName: 'isAnyIncome',
                inputValue: true,
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.chosen'],
                inputValidationType: 'CHOSEN',
                validOf: () => true,
            },
        ],
        isFormInInitialState: false,
        snapshot: '[{"inputId":"page_45_isAnyIncome","value":null}]',
    },
    deductionSourcesForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: false,
        areAllInputsValid: true,
        nonStandaloneInputsChanged: [],
        registeredInputs: [
            {
                inputId: 'page_45_isAnyDeduction',
                initialInputValue: null,
                isInputTouched: true,
                inputName: 'isAnyDeduction',
                inputValue: true,
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.chosen'],
                inputValidationType: 'CHOSEN',
                validOf: () => true,
            },
        ],
        isFormInInitialState: false,
        snapshot: '[{"inputId":"page_45_isAnyDeduction","value":null}]',
    },
    parentCaretakerForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: true,
        areAllInputsValid: false,
        nonStandaloneInputsChanged: [],
        registeredInputs: [
            {
                inputId: 'page_19_parentCaretaker',
                initialInputValue: null,
                isInputTouched: false,
                inputName: 'parentCaretaker',
                inputValue: null,
                isInputRequired: true,
                inputIsValid: false,
                messages: ['ssap.validation_error_message.chosen'],
                inputValidationType: 'CHOSEN',
                validOf: () => true,
            },
        ],
        isFormInInitialState: true,
        snapshot: '[{"inputId":"page_19_parentCaretaker","value":null}]',
    },
    personalInfoForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: true,
        areAllInputsValid: false,
        nonStandaloneInputsChanged: [],
        registeredInputs: [
            {
                inputId: 'page_10_gender',
                initialInputValue: 'male',
                isInputTouched: false,
                inputName: 'gender',
                inputValue: 'male',
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.chosen'],
                inputValidationType: 'CHOSEN',
                validOf: () => true,
            },
            {
                inputId: 'page_10_hhm0_socialSecurityCard_socialSecurityNumber',
                initialInputValue: '123456789',
                isInputTouched: false,
                inputName: 'socialSecurityNumber',
                inputValue: '123456789',
                isInputRequired: false,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.ssn'],
                inputValidationType: 'SSN',
                validOf: () => true,
            },
            {
                inputId: 'page_10_socialSecurityCard_nameSameOnSSNCardIndicator',
                initialInputValue: true,
                isInputTouched: true,
                inputName: 'nameSameOnSSNCardIndicator',
                inputValue: false,
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.chosen'],
                inputValidationType: 'CHOSEN',
                validOf: () => true,
            },
            {
                inputId: 'page_10_socialSecurityCard_firstNameOnSSNCard',
                initialInputValue: null,
                isInputTouched: false,
                inputName: 'firstNameOnSSNCard',
                inputValue: null,
                isInputRequired: true,
                inputIsValid: false,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_10_socialSecurityCard_middleNameOnSSNCard',
                initialInputValue: null,
                isInputTouched: false,
                inputName: 'middleNameOnSSNCard',
                inputValue: null,
                isInputRequired: false,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'MIDDLE_NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_10_socialSecurityCard_lastNameOnSSNCard',
                initialInputValue: null,
                isInputTouched: false,
                inputName: 'lastNameOnSSNCard',
                inputValue: null,
                isInputRequired: true,
                inputIsValid: false,
                messages: ['ssap.validation_error_message.name'],
                inputValidationType: 'NAME',
                validOf: () => true,
            },
            {
                inputId: 'page_10_socialSecurityCard_suffixOnSSNCard',
                initialInputValue: null,
                isInputTouched: false,
                inputName: 'suffixOnSSNCard',
                inputValue: null,
                isInputRequired: false,
                inputIsValid: true,
                inputValidationType: null,
                validOf: () => true,
            },
        ],
        isFormInInitialState: false,
        snapshot:
            '[{"inputId":"page_10_gender","value":"male"},{"inputId":"page_10_hhm0_socialSecurityCard_socialSecurityNumber","value":"123456789"},{"inputId":"page_10_socialSecurityCard_nameSameOnSSNCardIndicator","value":true}]',
    },
    incomeDiscrepancyForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: true,
        areAllInputsValid: false,
        registeredInputs: [],
        nonStandaloneInputsChanged: [],
        isFormInInitialState: true,
        snapshot: '',
    },
    employerCoverageDetailsForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: true,
        areAllInputsValid: false,
        registeredInputs: [],
        nonStandaloneInputsChanged: [],
        isFormInInitialState: false,
        snapshot: '',
    },
    additionalInfoForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: true,
        areAllInputsValid: false,
        registeredInputs: [],
        nonStandaloneInputsChanged: [],
        isFormInInitialState: false,
        snapshot: '',
    },
    signAndSubmitApplicationForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: true,
        areAllInputsValid: false,
        registeredInputs: [],
        isFormInInitialState: false,
        snapshot: '',
    },
    deceasedMemberModalForm: {
        isFormSubmitted: false,
        isEligiblyForSave: true,
        isFormOnTopLevelValid: true,
        areAllInputsValid: true,
        nonStandaloneInputsChanged: [],
        registeredInputs: [
            {
                inputId: 'page_05_removeAction',
                initialInputValue: false,
                isInputTouched: false,
                inputName: 'removeAction',
                inputValue: false,
                isInputRequired: true,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.chosen'],
                inputValidationType: 'CHOSEN',
                validOf: () => true,
            },
        ],
        isFormInInitialState: true,
        snapshot: '[{"inputId":"page_05_removeAction","value":false}]',
    },
    ethnicityRaceForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: true,
        areAllInputsValid: false,
        registeredInputs: [],
        nonStandaloneInputsChanged: [],
        isFormInInitialState: false,
        snapshot: '',
    },
    assistanceForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: true,
        areAllInputsValid: false,
        registeredInputs: [],
        nonStandaloneInputsChanged: [],
        isFormInInitialState: false,
        snapshot: '',
    },
    ridpUserInfo: {
        areAllInputsValid: true,
        isEligiblyForSave: true,
        isFormInInitialState: true,
        isFormOnTopLevelValid: true,
        isFormSubmitted: false,
        registeredInputs: [
            {
                initialInputValue: 'Manan',
                inputId: 'page_01_personGivenName',
                inputIsValid: true,
                inputName: 'personGivenName',
                inputValidationType: 'NAME',
                inputValue: 'Manan',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.name'],
                validOf: () => true,
            },
            {
                initialInputValue: '',
                inputId: 'page_01_personMiddleName',
                inputIsValid: true,
                inputName: 'personMiddleName',
                inputValidationType: 'MIDDLE_NAME',
                inputValue: '',
                isInputRequired: false,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.name'],
                validOf: () => true,
            },
            {
                initialInputValue: 'Rupani',
                inputId: 'page_01_personSurName',
                inputIsValid: true,
                inputName: 'personSurName',
                inputValidationType: 'NAME',
                inputValue: 'Rupani',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.name'],
                validOf: () => true,
            },
            {
                initialInputValue: 'Jr.',
                inputId: 'page_01_personNameSuffixText',
                inputIsValid: true,
                inputName: 'personNameSuffixText',
                inputValidationType: null,
                inputValue: 'Jr.',
                isInputRequired: false,
                isInputTouched: false,
                messages: undefined,
                validOf: () => true,
            },
            {
                initialInputValue: '1950-01-25',
                inputId: 'page_01_personBirthDate',
                inputIsValid: true,
                inputName: 'personBirthDate',
                inputValidationType: 'DATE_NOT_GREATER_THAN_CURRENT',
                inputValue: '1950-01-25',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.date'],
                validOf: () => true,
            },
            {
                initialInputValue: '240 S Wood St',
                inputId: 'page_01_address_streetName',
                inputIsValid: true,
                inputName: 'streetName',
                inputValidationType: 'ADDRESS_LINE1',
                inputValue: '240 S Wood St',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.valid_address'],
                validOf: () => true,
            },
            {
                initialInputValue: 'Bedford',
                inputId: 'page_01_address_locationCityName',
                inputIsValid: true,
                inputName: 'locationCityName',
                inputValidationType: 'CITY',
                inputValue: 'Bedford',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.city'],
                validOf: () => true,
            },
            {
                initialInputValue: '15522',
                inputId: 'page_01_address_locationPostalCode',
                inputIsValid: true,
                inputName: 'locationPostalCode',
                inputValidationType: 'ZIP_CODE_5_DIGITS',
                inputValue: '15522',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.zip_5_digits'],
                validOf: () => true,
            },
            {
                initialInputValue: 'PA',
                inputId: 'page_01_address_locationStateUSPostalServiceCode',
                inputIsValid: true,
                inputName: 'locationStateUSPostalServiceCode',
                inputValidationType: 'CHOSEN',
                inputValue: 'PA',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.chosen'],
                validOf: () => true,
            },

            {
                initialInputValue: '1232321234',
                inputId: 'page_01_address_fullTelephoneNumber',
                inputIsValid: true,
                inputName: 'fullTelephoneNumber',
                inputValidationType: 'PHONE_NUMBER',
                inputValue: '1232321234',
                isInputRequired: false,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.phone_number'],
                validOf: () => true,
            },
            {
                inputId: 'page_01_personSSNIdentification',
                initialInputValue: '123456789',
                isInputTouched: false,
                inputName: 'personSSNIdentification',
                inputValue: '123456789',
                isInputRequired: false,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.ssn'],
                inputValidationType: 'SSN',
                validOf: () => true,
            },
        ],
    },
    ridpUserInfoEmpty: {
        areAllInputsValid: true,
        isEligiblyForSave: true,
        isFormInInitialState: true,
        isFormOnTopLevelValid: true,
        isFormSubmitted: false,
        registeredInputs: [
            {
                initialInputValue: '',
                inputId: 'page_01_personGivenName',
                inputIsValid: true,
                inputName: 'personGivenName',
                inputValidationType: 'NAME',
                inputValue: '',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.name'],
                validOf: () => true,
            },
            {
                initialInputValue: '',
                inputId: 'page_01_personMiddleName',
                inputIsValid: true,
                inputName: 'personMiddleName',
                inputValidationType: 'MIDDLE_NAME',
                inputValue: '',
                isInputRequired: false,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.name'],
                validOf: () => true,
            },
            {
                initialInputValue: '',
                inputId: 'page_01_personSurName',
                inputIsValid: true,
                inputName: 'personSurName',
                inputValidationType: 'NAME',
                inputValue: '',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.name'],
                validOf: () => true,
            },
            {
                initialInputValue: '',
                inputId: 'page_01_personNameSuffixText',
                inputIsValid: true,
                inputName: 'personNameSuffixText',
                inputValidationType: null,
                inputValue: '',
                isInputRequired: false,
                isInputTouched: false,
                messages: undefined,
                validOf: () => true,
            },
            {
                initialInputValue: '',
                inputId: 'page_01_personBirthDate',
                inputIsValid: true,
                inputName: 'personBirthDate',
                inputValidationType: 'DATE_NOT_GREATER_THAN_CURRENT',
                inputValue: '',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.date'],
                validOf: () => true,
            },
            {
                initialInputValue: '',
                inputId: 'page_01_address_streetName',
                inputIsValid: true,
                inputName: 'streetName',
                inputValidationType: 'ADDRESS_LINE1',
                inputValue: '',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.valid_address'],
                validOf: () => true,
            },
            {
                initialInputValue: '',
                inputId: 'page_01_address_locationCityName',
                inputIsValid: true,
                inputName: 'locationCityName',
                inputValidationType: 'CITY',
                inputValue: '',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.city'],
                validOf: () => true,
            },
            {
                initialInputValue: '',
                inputId: 'page_01_address_locationPostalCode',
                inputIsValid: true,
                inputName: 'locationPostalCode',
                inputValidationType: 'ZIP_CODE_5_DIGITS',
                inputValue: '',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.zip_5_digits'],
                validOf: () => true,
            },
            {
                initialInputValue: '',
                inputId: 'page_01_address_locationStateUSPostalServiceCode',
                inputIsValid: true,
                inputName: 'locationStateUSPostalServiceCode',
                inputValidationType: 'CHOSEN',
                inputValue: '',
                isInputRequired: true,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.chosen'],
                validOf: () => true,
            },

            {
                initialInputValue: '',
                inputId: 'page_01_address_fullTelephoneNumber',
                inputIsValid: true,
                inputName: 'fullTelephoneNumber',
                inputValidationType: 'PHONE_NUMBER',
                inputValue: '',
                isInputRequired: false,
                isInputTouched: false,
                messages: ['ssap.validation_error_message.phone_number'],
                validOf: () => true,
            },
            {
                inputId: 'page_01_personSSNIdentification',
                initialInputValue: '',
                isInputTouched: false,
                inputName: 'personSSNIdentification',
                inputValue: '',
                isInputRequired: false,
                inputIsValid: true,
                messages: ['ssap.validation_error_message.ssn'],
                inputValidationType: 'SSN',
                validOf: () => true,
            },
        ],
    },
    citizenshipImmigrationForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: true,
        areAllInputsValid: false,
        registeredInputs: [],
        nonStandaloneInputsChanged: [],
        isFormInInitialState: false,
        snapshot: '',
    },
    reconciliationAptcForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: true,
        areAllInputsValid: false,
        registeredInputs: [],
        nonStandaloneInputsChanged: [],
        isFormInInitialState: false,
        snapshot: '',
    },
    medicaidTerminationDetailsForm: {
        isFormSubmitted: false,
        isEligiblyForSave: false,
        isFormOnTopLevelValid: true,
        areAllInputsValid: false,
        registeredInputs: [],
        nonStandaloneInputsChanged: [],
        isFormInInitialState: false,
        snapshot: '',
    }
};
